import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint sonarjs/no-duplicate-string: 0 */


import { extendTheme } from "native-base";
import baseTheme from "./base.theme";
import Platform from "react-native-web/dist/cjs/exports/Platform"; // Define the config

var config = {
  colors: {
    primary: {
      100: "#00A9A1",
      200: "#B4292D",
      300: "#DF4505",
      // TODO: replace this placeholder with appropriate color (this is for the focusring and hover to work)
      400: "#00A9A1",
      500: "#00A9A1",
      600: "#00A9A1"
    },
    secondary: {
      100: "#D7BA8A",
      200: "#D38232",
      300: "#8F278A"
    },
    background: {
      // TODO: this is used as bg color for card and category flatlist. might need to add a token
      100: "#F0FFFF",
      200: "#EBE9E9",
      300: "#DAD4D5",
      400: "#F0FFFF"
    },
    indicatorBannerColors: {
      indicatorBannerColor_NI: "#1AA9A0",
      indicatorBannerColor_LT: "#1AA9A0",
      indicatorBannerColor_CSK_B: "#b3292d",
      indicatorBannerColor_Default: "#C6653B"
    },
    viewMenuHover: "#8F278A",
    orderOnlineHomeButton: "#EC008C",
    errorModalHeaderBg: "#F0FFFF",
    locationListBtn: "#8F278A",
    timeDropDownBg: "#FFFFFF",
    modalLightBg: "#FFFFFF",
    outletLocationRestText: "#00A9A1",
    circularAddBtn: "#00A9A1",
    secondary200Mobile: "#00A9A1",
    modalDarkBg: "#FFFFFF",
    confirmationModalOptionBg: "#02aaa2",
    asapOptionBg: "#02aaa2",
    asapTextColor: "#fff",
    startBgColor: "#02aaa2",
    menuItemCardBg: "#FFFFFF",
    menuItemCardBorder: "#CFCFCF",
    selectedMenuCategoryBorder: "#ffff",
    themeErrorTextColor: "#AF272F",
    inActiveCategoriesText: "#ffff",
    inActiveModalCategoriesText: "#505050",
    themeErrorColor: "#C03838",
    themeTextFieldBoundary: "#DEDEDE",
    themeSectionSeparator: "#D6D6D6",
    themeSectionSeparatorDark: "#979797",
    listItemDivider: "#D6D6D6",
    themeSectionTextDark: "#505050",
    infoLinkColor: "#00A9A1",
    backLinkColor: "#EC008C",
    themeTextColor: "#505050",
    legalDesclaimerText: "#505050",
    themeGrey: "#505050",
    headerBackground: "#ffffff",
    downArrowColor: "#ffff",
    orderSettingsDateTimeChoiceColor: "#2D2926",
    themeDarkGrey: "#2E2A26",
    selectedOptionBorderColor: "#EC008C",
    notSelectedOptionBorderColor: "#D7D7D7",
    menuDetailsMobileHeaderText: "#8F278A",
    configOptionsAccordionBackground: "#00A9A1",
    hStackArrowsColor: "#00A9A1",
    popoverBg: "#F2EFEA",
    hStackArrowsBg: "#FDFDFDD9",
    categoryNavBgColor: "transparent",
    separatorLineColor: "#2A2C25",
    themeDisableButton: "#E5E5E5",
    orderConfirmationDivider: "#E5E5E5",
    categoryHeaderSeparator: "#EAEAEA",
    btnHoverColor: "#671B63",
    menuListTooltipBg: "#1AA9A0",
    menuListTooltipColor: "#FFFFFF",
    menuDetailTooltipBg: "#1AA9A0",
    menuDetailTooltipColor: "#FFFFFF",
    menuItemNameColor: "#00A9A1",
    tempSilderText: "#00A9A1",
    selectTemperatureAccordian: "#E9E9E9",
    legalTextContainerBg: "#EFEFEF",
    menuLinksColor: "#ffff",
    menuLinksColorMobile: "#606060",
    sliderItemColor: "#00A9A1",
    headerBackgroundTop: "#ffffff",
    menuButtonBackgroundColor: "#00A9A1",
    orderSettingsTextColor: "#00A9A1",
    categoriesText: "#ffff",
    modalCategoriesText: "#00A9A1",
    refreshIconColor: "#8F278A",
    menuItemPriceColor: "#505050",
    mobilePayNotYourCheckTextColor: "#606060",
    mobilePayReachOutSubTextColor: "#782434",
    menuItemCalorieColor: "#505050",
    scrollToTopColor: "#8F278A",
    menuItemAddButtonColor: "#8F278A",
    itemAddToCartPopupBackground: "#00A9A1",
    remoteCheckinWaitTimeBg: "#F0FFFF",
    remoteCheckinWaitTimeBorderTwo: "rgba(0, 169, 161, 0.1)",
    remoteCheckinWaitTimeBorderOne: "rgba(0, 169, 161, 0.2)",
    remoteCheckinWaitTimeInnerBorder: "rgba(0, 169, 161, 1)",
    remoteCheckinWaitTimeCircleBg: "#FFFFFF",
    remoteCheckinWaitTimeHeaderText: "rgba(0, 169, 161, 1)",
    remoteCheckinWaitTimeText: "rgba(0, 169, 161, 1)",
    remoteCheckinWaitTime: "rgba(96, 96, 96, 1)",
    remoteCheckinRefreshBtnColor: "#8F278A",
    remoteCheckinRefreshBtnBg: "#FFFFFF",
    remoteCheckinPartySizeText: "#222828",
    mobileBg: "#FFFFFF",
    deliveryModalHeadingColor: "#2A2C25",
    deliveryModalBrandColor: "#54301A",
    deliveryModalNameColor: "#A2402A",
    cartNoOfItemsText: "#EC008C",
    cartItemPrice: "#EC008C",
    cartPhoneNumber: "#00A9A1",
    cartItemActionBtn: "#00A9A1",
    cartHeaderOrderType: "#505050",
    cartHeaderLocationName: "#00A9A1",
    sliderWithButtonsBackground: "#FFFFFFE5",
    recommendationHeadingColor: "#020001",
    menuDetailAccordionDownArrowColor: "#00A9A1",
    menuDetailAccordionTextColor: "#505050",
    menuDetailsAccordionDetailsBackground: "#F4F4F3",
    menuDetailsAccordionDetailsBackgroundNotDefaultExpanded: "#FFFFFF",
    menuDetailModifyOrRemoveColor: "#020001",
    menuDetailTemparatureSliderLabelColor: "#505050",
    menuDetailItemNameColor: "#505050",
    menuDetailsItemPriceColor: "#505050",
    specialInstArrowColor: "black",
    menuDetailsItemDescriptionColor: "#505050",
    legalDisclaimerText: "#282C25",
    menuDetailsItemCaloriesCaolor: "#505050",
    menuDetailsModifiersBorderColor: "#EC008C",
    menuDetailsSliderHoverColor: "#00A9A1",
    menuDetailsBackToMenu: "#00A9A1",
    jwcLeaveTheLineModalHeadBg: "#D7D2CB",
    menuDetailsSliderItemBackground: "#F0FFFF",
    loginModalTextColor: "#8F278A",
    requiredTextColor: "#D93D3D",
    recommendationaInfoTextColor: "#505050",
    reorderInfoTextColor: "#505050",
    reorderHeadingsText: "#505050",
    nutritionalHTMLColor: "#505050",
    orderConfirmationTextColor: "#fff",
    locationListingItemHeading: "#02aaa2",
    locationListingItemHeadingMobile: "#02aaa2",
    locationListingItemText: "#505050",
    confirmPickupDetailsText: "#2D2926",
    addressTextColor: "#505050",
    itemIsFor: "#8A8A8A",
    itemIsForName: "#020001",
    cartItemTitle: "#505050",
    globalBannerBg: "#00a9a1",
    specialInstructions: "#505050",
    cartItemOption: "#505050",
    cartNumberText: "#ffff",
    locationsNear: "black",
    searchResultsName: "#303030",
    locationConfirmationHeadings: "#782434",
    orderSettingsDesktop: "#505050",
    orderSettingsMobile: "#505050",
    bannerDropShadow: "#5F2C2D",
    previousOrderItemStatus: "#AF272F",
    accordionDescription: "white",
    skuUnavaliableTextColor: "#A2402A",
    youMightLikeBannerColor: "#8F278A",
    youMightLikeBannerGradientStartColor: "#EC008C",
    defaultMenuBannerBg: "#2f2f2f",
    newIndicatorBannerColor: "#1AA9A0",
    orderInfoBg: "#ffff",
    specialInstInputBg: "#ffff",
    defaultMenuTextColor: "white",
    categoryBoxTop: "#D6D6D6",
    categoryBoxBottom: "#D6D6D6",
    categoryBoxDivider: "#ffff",
    firstCategoryBoxDivider: "#FFFFFF",
    quantityArrowColor: "#EC008C",
    textCTAColor: "#8F278A",
    selectedCarouselItemWithoutImage: "#FFFFFF",
    unselectedCarouselItemWithoutImage: "#ffff",
    checkoutButtonBackgroundColor: "#8F278A",
    orderSettingsDivider: "#D0D0D0",
    orderSettingsDividerMobile: "#D0D0D0",
    emptyCartHeaderBgColor: "#F0FFFF",
    orderSettingsBorder: "#D6D6D6",
    modalTextColor: "#332C28",
    plusIconColor: "#8F278A",
    ninjaIconColor: "#00A9A1",
    selectedListItem: "#FFFFFF",
    locationListItemBorder: "transparent",
    allLocationsSelectBgMobile: "#02aaa2",
    reOrderAddBtnBorder: "#8F278A",
    allLocationsSelectBgDesktop: "#02aaa2",
    locationCardBg: "#ffff",
    locationDropdownBg: "#ffff",
    allLocationsSelectBorderColorMobile: "#DEDEDE",
    allLocationsSelectBorderColorDesktop: "#DEDEDE",
    allLocationsItemBoxBorderColor: "#DEDEDE",
    allLocationsBodyBgMobile: "#ffffff",
    allLocationsBodyBgDesktop: "#ffffff",
    allLocationsSelectBorderColor: "#D6D6D6",
    confirmPickupDetailsChangeBtnBorder: "#8F278A",
    checkoutBorderColor: "#D6D6D6",
    categoriesHeadingColor: "#505050",
    categoriesDescriptionColor: "#505050",
    itemUnavailableCardBg: "#F0FFFF",
    itemCardBg: "#F0FFFF",
    itemCardBgLight: "#F0FFFF",
    orderConfirmationBackground: "#F6F6F6",
    orderConfirmationCustomerEmail: "#464838",
    // ORDER CONFIRMATION START
    confirmationPrimary: "#8F278A",
    confirmationSecondary: "#303030",
    confirmationAccent: "#2A2C25",
    confirmationAccentLight: "#666666",
    confirmationAccentDark: "#303030",
    confirmationCheckbox: "#00A9A1",
    confirmationThemeDark: "#000000",
    confirmationThemeLight: "#EEEEEE",
    confirmationThemeGrey: "#B0B0B0",
    podBackground: "white",
    confirmationSpecialInstructionsBg: "#EEEEEE",
    // ORDER CONFIRMATION END
    // order tracking page
    orderStatusText: "#464838",
    orderStatusCircleBg: "#000000",
    locaionAndTimeHeaderBg: "#F0FFFF",
    locaionAndTimeHeaderBorder: "#DCDCDC",
    borderColorCallSection: "#DCDCDC",
    payNowButtonBg: "#8F278A",
    curbsideCheckInPrimary: "#FFFFFF",
    curbsideCheckInSecondary: "#8F278A",
    orderStatusSectionBg: "#F4F4F4",
    refreshButtonColor: "#8F278A",
    checkText: "#303030",
    curbsideCheckInAvailable: "#7C7C7C",
    orderStatusSectionBorderColor: "#DCDCDC",
    refreshButtonBg: "#FFFFFF",
    // order tracking page end
    categoriesPopupInactive: "#505050",
    categoriesPopupBg: "white",
    bodyBg: "transparent",
    quickAddModalBg: "white",
    cardColor: "#F0FFFF",
    menuInfoBackgroundMobile: "#FFFFFF",
    menuInfoBackgroundDesktop: "#F0FFFF",
    selectedSKUItem: "#F0FFFF",
    nonSelectedSkuItem: "white",
    configOptionBg: "white",
    nonSelectedListItem: "white",
    selectedListItemWithImage: "white",
    nonExpandedAccordionBackground: "#F0FFFF",
    selectedDescriptionText: "#505050",
    carouselBorderColor: "#D6D6D6",
    signInTextColor: "#505050",
    registerTextColor: "#505050",
    recommendationsHeadingColor: "#505050",
    capacityInfoText: "#505050",
    selectedStateColor: "#000000",
    mobilePayHeaderBtnBorder: "#8F278A",
    quantityColor: "#505050",
    timeDropdownColor: "#000000",
    searchKeywordHighlightColor: "#00A9A1",
    waitlistBannerBg: "#00A9A1",
    waitlistFooterBorderTop: "#B0B0B0",
    waitlistDisclaimer: "#606060",
    fwlvMiddleCtaBackground: "#D7F1F1",
    waitlistBottomBackground: "#F0FFFF",
    selectedWaitlistRow: "#F0FFFF",
    waitlistTableHeaderBg: "#F8F8F8",
    howItWorksBannerBg: "#00A9A1",
    //Menu search
    searchModalCategoryListBg: "#F6F6F6",
    searchIconContainerBgColor: "#DF4505",
    linearGradientHeaderDark: "#D0FEFE",
    linearGradientHeaderLight: "rgba(225,246,246,0)",
    homeScreenHeaderIconColors: "#606060",
    homeScreenLoginBorderColor: "#ffffff",
    mobilePayUserLoginButtonTextColor: "#FFFFFF",
    mobilePayBodyTextColor: "#606060",
    mobileAuthFooterActiveText: "#00A9A1",
    menuCustomisationButtonColor: "#8F278A",
    profileHeaderBackground: "#00A9A1",
    joinEClubTickScheme: "#00A9A1",
    checkoutGratuitySliderMinTrackColor: "#00A9A1",
    checkoutRadioBtnColor: "#00A9A1",
    lowWait: "#8F278A",
    menuCustomisationIsSelectedBorderMobileColor: "#00A9A1",
    selectedNumberOfGuestBorderColor: "#00A9A1",
    menuLinearGradientStartColor: "#00a8ff",
    menuLinearGradientEndColor: "#02aaa2",
    onboardingButtonTextColor: "#FFFFFF",
    locationTopTabColor: "#00A9A1",
    onboardingActiveDotColor: "#00A9A1",
    onboardingInactiveDotColor: "rgba(0,0,0, 0.2)",
    onboardingButtonBackgroundColor: "#8F278A",
    homescreenWaitlistButtonBorderColor: "#00A9A1",
    homescreenWaitlistButtonTextColor: "#00A9A1",
    ratingCardSubmitButton: "#00A9A1",
    recentOrdersListItemPrice: "#494949",
    weekDayStartColor: "#02AAA2",
    weekDayEndColor: "#00A8FF",
    mobileGiftCardGradientFirst: "#8F278A",
    mobileGiftCardGradientSecond: "#EC008C",
    profileAddCardButtonText: "#8F278A",
    mobilePaymentMethodIconBg: "#F8F8F8",
    menuSearchBarContainerBg: "#FFFFFF",
    menuSearchModalCloseIconBg: "#F0FFFF",
    searchItemBreadCrumbSlugcolor: "#666666",
    //
    //
    //
    // Copied from OG
    grey300: "#303030",
    mobileAppAuthBg: "white",
    smartRecommendationCardbg: "white",
    myReservationsBoxBg: "white",
    waitlistRestaurantInfoBoxText: "#303030",
    mobileAuthOrDividerBorderColor: "#CDCFD5",
    mobileAuthOrTextColor: "#737373",
    mobileAuthFooterPassiveText: "#808080",
    mobileAuthTransparentBg: "rgba(0, 0, 0, 0.7)",
    mobileCriticalModeHeding: "#606060",
    mobileCriticalModeText: "#959595",
    mobileCreateAccountDetailsSectionBackgroundColor: "#FFFFFF",
    mobileCreateAccountButtonTextColor: "#FFFFFF",
    mobileCreateAccountLegalNoticesColor: "#cb7034",
    mobileCriticalModeBg: "#E5E5E5",
    mobileForgotPasswordHeding: "#606060",
    linearGradientTransparent: "rgba(255,255,255,0)",
    linearGradientWhite: " rgba(255,255,255,1)",
    linearGradientCardDarkShade: "rgba(54, 26, 5, 0.84)",
    linearGradientCardLightShade: "rgba(54, 26, 5, 0.44)",
    linearGradientCardTransparent: "rgba(35,34,30,0)",
    ratingCardTitle: "#2A2C25",
    ratingCardSubheaderText: "#606060",
    ratingCardBodyHeader: "#606060",
    ratingCardTextAreaBorderColor: "F3F4EA",
    ratingCardTextAreaWordCount: "rgba(0, 0, 0, 0.4)",
    ratingCardSubmitButtonText: "#FFFFFF",
    ratingCardDismissButtonText: "#808080",
    mobileForgotPasswordHeading: "#606060",
    mobileResetPasswordText: "#606060",
    mobileCustomBrandModalBg: "#F8F7F6",
    lunchIssueModalBody: "#F8F7F6",
    lunchIssueModalSeparator: "#EBE9E9",
    restaurantDetailsDataText: "#303030",
    mobileHeaderBg: "rgba(255, 255, 255, 0.9)",
    routerNavigationHeaderColor: "rgba(0, 0, 0, 0.7)",
    displayImageFallbackBackground: "#C6C6C6",
    mobileOrderDetailsBanner: "#F5F7E8",
    mobileOrderDetailsDisabledButton: "#C6C6C6",
    mobileOrderDetailsBg: "white",
    locationModalHeadingColor: "#2A2C25",
    locationModalBodyDataColor: "#808080",
    locationModalDividerColor: "#C6C6C6",
    restaurantsTimingDetails: "#606060",
    restaurantLabelColor: "#8F278A",
    joinWaitlistColor: "#8F278A",
    disableJoinWaitlistColor: "#C6C6C6",
    waitlistHeaderAddressHeaderBorder: "#D6D6D6",
    mobileSelectedVehicleTypeBg: "#F4F4F4",
    mobileSliderSeparator: "#BEBEBE",
    locationInfographicModalTextColor: "#606060",
    locationInfographicModalActionButtonTextColor: "#FFFFFF",
    inputPlaceholderTextColor: "#303030",
    restaurantDetailsHeaderBackground: "#FFFFFF",
    amenitiesHeadingColor: "#2A2C25",
    amenitiesDividerColor: "rgba(0,0,0,0.2)",
    amenitiesActionButtonsColor: "#8F278A",
    currentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantWaitlistTextColor: "#606060",
    joinWaitlistButtonColor: "#8F278A",
    orderFromHereButtonTextColor: "#FFFFFF",
    restaurantAboutSectionHeadingTextColor: "#2A2C25",
    restaurantAboutSectionBodyTextColor: "#222828",
    restaurantAboutSectionBodyTextSecColor: "#303030",
    restaurantImageBorderColor: "#FFFFFF",
    restaurantNumberAndDistanceDividerColor: "rgba(0,0,0,0.20)",
    restaurantHoursTextColor: "#2A2C25",
    restaurantSpecialDayHeadingTextColor: "#303030",
    restaurantSpecialDayBodyTextColor: "#606060",
    restaurantTimingsHeadingTextColor: "#EC008C",
    restaurantTimingsDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsSeparatorDividerColor: "rgba(0,0,0,0.1)",
    restaurantTimingsTextColor: "#404040",
    locationTabNavigationNotFocusedTabText: "#606060",
    locationInfographicLoginBackgroundColor: "#FFFFFF",
    locationOverlayMyLocationsTitles: "#303030",
    locationOverlayMyLocationsScrollView: "#FFFFFF",
    locationOverlaySelectLocationColor: "#2A2C25",
    noRecentLocationsTextColor: "#606060",
    searchThisAreaText: "#FFFFFF",
    selectedWeekDayColor: "#223E6A",
    notSelectedWeekDayColor: "#FFFFFF",
    weekDayBorderColor: "#DCDCDC",
    currentWeekDayIndicator: "#49909B",
    mobileScrollableMenuTab: "#F8F8F8",
    orderConfirmationThanksSubHeaderColor: "#505050",
    pickupRestaurantTitle: "#737373",
    pickupRestaurantName: "#303030",
    pickupRestaurantAddress: "#606060",
    pickMyOrderCardTitle: "#303030",
    pickUpMyOrderHStackText: "#303030",
    bottomSheetTitleColor: "#303030",
    errorModalBackgroundColor: "rgba(29, 26, 26, 0.88)",
    errorModalTitleColor: "#2A2C25",
    errorModalSubTitleTextColor: "#606060",
    errorModalOKButtonTextColor: "#FFFFFF",
    addCardModalValidWarningTextColor: "#D30000",
    cardExpiredColor: "#D51010",
    saveCardCheckbox: "#737373",
    saveCardAddButtonTextColor: "#FFFFFF",
    enterCVVSubTitle: "#606060",
    enterCVVPlaceholderText: "#606060",
    enterCVVTooltipBgColor: "#e3e3e3",
    enterCVVValidWarningTextColor: "#D30000",
    enterCVVConfirmButtonDisabledColor: "#C6C6C6",
    enterCVVConfirmButtonTextColor: "#FFFFFF",
    mobilePaymentsCardTextColor: "white",
    mobileMasterCardGradientFirst: "#2A0000",
    mobileMasterCardGradientSecond: "#912F2F",
    mobileMasterCardGradientThird: "#5A1F21",
    mobileVisaGradientFirst: "#0B765C",
    mobileVisaGradientSecond: "#0B765C",
    mobileVisaGradientThird: "#13770B",
    mobileDiscoverGradientFirst: "#95989F",
    mobileDiscoverGradientSecond: "#D1D5D8",
    mobileDiscoverGradientThird: "#93969B",
    mobileAmericanExpressGradientFirst: "#1B1B1D",
    mobileAmericanExpressGradientSecond: "#5E5E62",
    mobileAmericanExpressGradientThird: "#1E1E20",
    mobileJcbCardGradientFirst: "#001741",
    mobileJcbCardGradientSecond: "#195182",
    mobileJcbCardGradientThird: "#2B3E7F",
    mobilePaymentMethodAssistTextColor: "#808080",
    mobileCouponInputPlaceholderColor: "#C7C0C0",
    mobilePaymentsScreenBg: "white",
    addGiftCardBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    enterCVVBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    addCreditDebitCardTooltipBgColor: "#e3e3e3",
    yourOrderTitle: "#303030",
    orderDescriptionItem: "#2A2C25",
    orderTotalTitle: "#54301A",
    pickupDetailsTitle: "#303030",
    carSideStackTitle: "#606060",
    cardCreateAnAccountHeading: "#303030",
    takeSurveyText: "#606060",
    joinEClubTitle: "#303030",
    mobileGiftVoucherGiftText: "#E7A227",
    mobileGiftVoucherVoucherIDText: "#C6C6C6",
    mobileGiftVoucherValueFirstGrad: "#F6C551",
    mobileGiftVoucherValueSecondGrad: "#B15801",
    mobileGiftVoucherBoxFirstGrad: "#423F3F",
    mobileGiftVoucherBoxSecondGrad: "#5F5852",
    mobileGiftCardNormalText: "white",
    wailistHomeScreenBannerGradientOne: "#02AAA2",
    waitlistHomeScreenBannerGradientTwo: "#00A8FF",
    waitlistHomeScreenBannerText: "#FFFFFF",
    waitlistBannerCircleOuterBorder: "rgba(255,255,255,0.2)",
    waitlistBannerFooterText: "#303030",
    waitlistPositionBackground: "#F3F4E7",
    waitlistPositionBorderTwo: "rgba(159, 167, 58, 0.1)",
    waitlistPositionBorderOne: "rgba(159, 167, 58, 0.2)",
    waitlistPositionInnerBorder: "#9FA73A",
    waitlistPositionCircleBackgroundColor: "#FFFFFF",
    waitlistPositionSubTitle: "#606060",
    waitlistPositionButtonBackground: "#FFFFFF",
    waitlistPositionSubTextColor: "#303030",
    waitlistSubCardsVerticalDivider: "#F6F6F6",
    waitlistDetailsSwiperText: "#FFFFFF",
    waitlistSwiperNavigationButtonBorderColor: "#FFFFFF",
    waitlistSwiperNavigationButtonBackgroundColor: "#FFFFFF",
    seasonFavouriteTitleText: "#FFFFFF",
    seasonFavouritesHeadingDivider: "#4D4D4D",
    waitlistMapSectionBorder: "#DCDCDC",
    waitlistMapSectionButtonBackground: "#FFFFFF",
    waitlistDetailsOrderbuttonText: "#FFFFFF",
    waitlistPositionHeadingText: "#2A2C25",
    waitlistDetailsScreenBackground: "#FFFFFF",
    waitlistBannerCircleBackgroundColor: "#FFFFFF",
    mobileCategoryNavigationBg: "#F8F8F8",
    mobileOrderSummaryBackground: "#F6F6F6",
    mobileOrderSummaryHeaderText: "#303030",
    mobileOrderSummaryDishQuantity: "#2A2C25",
    mobileOrderSummaryOtherInstructions: "#606060",
    mobileOrderSummaryOrderTotalDetailsItem: "#000000",
    mobileOrderSummaryOrderTotalDetailsItemCoupon: "#8F278A",
    mobileOrderSummaryPaidByColor: "#303030",
    ProfilePictureCircleBorderColor: "#FFFFFF",
    mobileOrderSettingsOptionStackBorderColor: "#DEDEDE",
    orderSettingsPickupDetails: "#2A2C25",
    orderSettingsBackdrop: "rgba(0, 0, 0, 0.7)",
    curbsideHomeScreenBannerGradientOne: "#02AAA2",
    curbsideHomeScreenBannerGradientTwo: "#00A8FF",
    curbsideHomeScreenBannerText: "#523020",
    curbsideDetailsBackground: "#F3F4E7",
    curbsidePickupScreenBackground: "#FFFFFF",
    curbsidePickupScreenDetailsBackground: "#F2F4E6",
    curbsidePickupScreenDetailsDivider: "#DCDCDC",
    curbsidePickupScreenBannerText: "#523020",
    curbsidePickupScreenDetailsSubText: "#303030",
    curbsidePickupScreenDetailsIconsBackground: "#F6F6F6",
    curbsidePickupScreenDetailsEditButtonText: "#993324",
    viewDirectionButtonTextColor: "#FFFFFF",
    restaurantLocationBottomSheetBackdropColor: "rgba(0,0,0,0.6)",
    modalHeaderBackgroundColor: "rgba(0, 0, 0, 0.7)",
    restuarantLocationBottomSheetLocationText: "#606060",
    addGiftCardHeaderTextColor: "#2A2C25",
    mobileOrderHistoryBackgroundColor: "#FFFFFF",
    mobileOrderHistoryItemCardHeaderBackgroundColor: "#F0FFFF",
    orderHistoryItemDividerColor: "#C6C6C6",
    orderHistoryReorder: "#8F278A",
    orderHistoryDetailsText: "#303030",
    orderHistoryOrderFrom: "#808080",
    orderHistoryDetailsAddress: "#606060",
    orderHistoryDetailsBGColor: "#F6F6F6",
    searchBarBackground: "#FFFFFF",
    addCardFooterButtonText: "#FFFFFF",
    homeScreenBackgroundColor: "#F6F6F6",
    homeScreenOrderNowButtonTextColor: "#FFFFFF",
    restCallNowCTATextColor: "#FFFFFF",
    homeScreenCardButtonTextColor: "#FFFFFF",
    homeScreenCardButtonBorderColor: "#FFFFFF",
    homeScreenCardTextColor: "#FFFFFF",
    selectPreferredLocationBackgroundColor: "#FFFFFF",
    outletLocationItemIconText: "#FFFFFF",
    outletLocationItemButtonText: "#FFFFFF",
    profileScreenMainModalBackgroundColor: "#FFFFFF",
    showCreditCard_bottomSheet_BackgroundColor: "#FFFFFF",
    addEditCreditCard_scrollView_backgroundColor: "#FFFFFF",
    HomeScreenlinearGradientBackgroundColor: "#F6F6F6",
    homeScreenRecentOrdersListItemSubTextColor: "#606060",
    homeScreenRecentOrdersListItemDividerColor: "#C6C6C6",
    homeScreenRecentOrdersListItembackgroundColor: "#FFFFFF",
    homeScreenRecentOrdersListItemButtonTextColor: "#FFFFFF",
    addCardPlaceholderTextColor: "#606060",
    addCardCheckboxTextColor: "#606060",
    mobileReorderBg: "#F8F8F8",
    editProfileScreensBackgroundColor: "#FFFFFF",
    googleSocialSignInBGColor: "#FFFFFF",
    facebookSocialSignInBGColor: "#1877F2",
    appleSocialSignInBGColor: "#000000",
    socialAuthBorderColor: "#DEDEDE",
    createAccountPreferredLocationBGColor: "#F8F7F6",
    cartScreenBackgroundColor: "#FFFFFF",
    orderLimitReacherModalBackdrop: "rgba(0,0,0,0.7)",
    cartHeaderPressableColor: "#F6F6F6",
    securityQuestionContainer: "#ffffff",
    securityQuestionMenuColor: "#C6c6c6",
    securityQuestionTextColor: "#606060",
    createAccountBackgroundColor: "#FFFFFF",
    createAccountScreenTextColor: "#303030",
    createAccountZipCodeBorderColor: "#DCDCDC",
    createAccountZipCodeLabelColor: "#808080",
    settingScreenBg: "#F8F8F8",
    settingListItemShadow: "rgba(0,0,0,0.5)",
    frequentlyOrderedItemBackground: "#FFFFFF",
    frequentlyOrderedItemSubText: "#505050",
    giftCardBalanceColor: "#606060",
    mobileDividerColor: "rgba(0,0,0,0.5)",
    homescreenPromoBackdrop: "rgba(0, 0, 0, 0.6)",
    fullHomescreenPromoBg: "#F8F7F6",
    paymentScreenImportantTextDescription: "#808080",
    curbsideBannerTagColor: "#FFFFFF",
    guestFavoritesBackgroundColor: "#F6F6F6",
    guestFavouritePopOverBGColor: "#F3F4E7",
    guestPopoverBackdropColor: "rgba(0,0,0,0.7)",
    mobilePayBgColor: "#FFFFFF",
    mobilePayDividerColor: "#C6C6C6",
    mobilePayDividerTextColor: "#808080",
    mobilePayWorksHeaderTextColor: "#404040",
    mobilePayWorksListItemBgColor: "#F6F6F6",
    mobilePayWorksTitleColor: "#303030",
    mobilePayWorksItemTitleColor: "#2A2C25",
    mobilePayGuidlineBgColor: "#F6F6F6",
    mobilePayWhiteTextColor: "#FFFFFF",
    reorderTopTabScreenBackgroundColor: "#F6F6F6",
    errorPopUpContentDividerBackgroundColor: "#F6F6F6",
    menuSliderSelectedCountTextColor: "#808080",
    menuCustomisationIsSelectedMobileColor: "#F0FFFF;",
    menuCustomisationNotSelectedBorderMobileColor: "#C6C6C6",
    joinWaitListMapTextColor: "#464838",
    joinWaitlistBackgroundColor: "#F6F6F6",
    howMobilePayWorksModalBg: "rgba(0,0,0,0.6)",
    selectedNumberOfGuestBackgroundColor: "#F3F4EA",
    backgroundWhite: "#fff",
    menuCustomisationListIItemActiveColour: "#a18e82",
    collapsableDropdownItemBgColor: "#F6F6F6",
    smartRecommendationBackgroundColor: "#E5E5E5",
    smartRecommendationActiveDotColor: "#54301A",
    smartRecommendationInActiveDotColor: "#C6C6C6",
    waitlistStatusScreenBg: "#F0FFFF",
    unavailableWaitlistColor: "#BDBDBD",
    mobileReorderScreenTitleColor: "#2A2C25",
    // ORDER CONFIRMATION END
    checkoutRadioButtonBorderColor: "#D6D6D6",
    pickupMethodBackgroundColor: "#F6F6F6",
    pickupMethodSectionDivider: "#DCDCDC",
    // Menu Search Start
    suggestedSearchTextColor: "#404040",
    noResultFoundMenuSearchBg: "#F6F6F6",
    searchModalBackgroundColor: "white",
    menuSearchModalDivider: "#ABABAB",
    searchCardCategorySlugColor: "grey",
    inputFieldBackgroundColor: "#F6F6F6",
    suggestionsBorderColor: "#C6C6C6",
    clearTextColor: "#993324",
    noResultTextColor: "#EC008C",
    backgroundE5E5: "#E5E5E5",
    searchItemCardTextColor: "#505050",
    // Menu Search End

    /* Restaurant Details */
    restaurantDetailsBGColor: "white",
    restaurantDetailsDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsAboutSectionDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsMobilePoliteNoticeDividerBg: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerMobileColor: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerColor: "transparent",
    restaurantDetailsJoinWaitlistButtonTextColor: "#8F278A",
    restaurantDetailsJoinWaitlistButtonBorderColor: "#8F278A",
    restaurantDetailsJoinWaitlistButtonLargeTextColor: "white",
    restaurantDetailsDisableJoinWaitlistTextColor: "#C6C6C6",
    restaurantDetailsDisableJoinWaitlistButtonBorderColor: "#C6C6C6",
    restaurantDetailsCurrentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsRestInfoBoxBackgroundColor: "#F0FFFF",
    restaurantDetailsRestInfoLgDividerBackgroundColor: "#0000004D",
    restaurantDetailsSelectedWeekDayColor: "#EC008C",
    restaurantDetailsNotSelectedWeekDayTextColor: "#303030",
    restaurantDetailsNotSelectedWeekDayColor: "#FFFFFF",
    restaurantDetailsCurrentWeekDayIndicator: "#49909B",
    restDetailsRestInfoTitleColor: "#020001",
    restaurantInfoAddressTextColor: "#8F278A",
    restaurantInfoNumberAndDistanceTextColor: "#8F278A",
    restaurantInfoAddToFavouritiesTextColor: "#8F278A",
    restaurantTimingWeekDayTextColor: "#00A9A1",
    restaurantDetailsAmenetiesbgColor: "#FFFFFF",
    imageStackBorderColor: "#FFFFFF",
    ///Order Ahead Flow Tokens
    serveAsEntreeSwitch: "#97BC67",
    //mobile Payment Options tokens
    paymentOptionsHeaderColor: "#E5F6F6",
    paymentOptionsBorderColor: "#E5F6F6",
    //mobile app profile
    editProfileInfoLabelColor: "#808080",
    editProfileInfoAsteriskColor: "#D30000",
    profilePictureShadowColor: "#000000",
    mobileOrderInfoBannerBorderColor: "#D6D6D6",
    // order tracking page end
    //mobile restaurant details skeleton
    skeletonColorGrey: "#DCDCDC",
    onboardingScreenBGColor: "#FFFFFF",
    orderDetailsSkeletonBgColor: "#C4C4C4",
    //tab bar
    backgroundTabBarColor: "white",
    shadowColor: "#2c2c2c",
    //home-screen header avatar
    homeScreenHeaderAvatarBg: "lightgrey",
    //menu-collapsable bg
    menuCollapsableButton: "#F3F4E7",
    //number of guests bg
    numberOfGuestsActiveColor: "#303030",
    // estimated waitTime bg
    estimatedWaitTimeBg: "#54301A",
    // cart item qty color
    cartItemQuantityColor: "#54301A",
    mobileBottomTabBackgroundColor: "#FFFFFF",
    bottomTabTextColor: "#606060",
    checkoutGratuitySliderMaxTrackColor: "#D5E1AB",
    cartQuantityTextColor: "#54301A",
    // waitlistWineWhileYouWait Background color:
    waitlistWineWhileYouWaitBg: "#FFEFC2",
    recentOrderTextColor: "#303030",
    orderConfirmationSeeDetailsShadowStart: "rgba(0, 0, 0, 0.02)",
    orderConfirmationSeeDetailsShadowEnd: "rgba(0, 0, 0, 0.05)",
    // statuses colours:
    highWait: "#8F278A",
    waitNotAvailable: "#BDBDBD",
    paymentOrderTotalTextColor: "#000000",
    keyboardDoneButtonBgColor: "#FBFBFB",
    keyboardDoneButtonColor: "#2c7aff",
    profileHeaderLinearGradientStartColor: "#00A9A1",
    profileHeaderLinearGradientEndColor: "#00A9A1",
    searchBarBorderColor: "#D6D6D6",
    mobilePayConfirmationScreenBlockBG: "#F3EEE9",
    reservationCarouselActiveDotColor: "#00A9A1",
    reservationCarouselInactiveDotColor: "#D5D8DA",
    reservationBorderColor: "rgba(0,0,0,0.1)",
    reservationButtonBGDisabled: "#CBD1D6",
    reservationSelectedCTABorderColor: "#00A9A1",
    reservationUnSelectedCTABorderColor: "rgba(0,0,0,0.1)",
    reservationSelectedCTABGColor: "#F0FFFF",
    reservationUnSelectedCTABGColor: "#FFF",
    reservationPopupBgColor: "#fff",
    locationsTopTabsContainerColor: "#FFFFFF",
    preferredLocationHeaderBg: "#FFFFFF",
    preferredLocationHeaderTextColor: "#2A2C25",
    orderTotalTextColor: "#464838",
    orderTotalPriceColor: "#464838",
    scrollingNavigationFlatlistStartingGradientStartColor: "rgba(248, 248, 248, 0)",
    scrollingNavigationFlatlistStartingGradientEndColor: "rgba(248, 248, 248, 0)",
    waitlistVisibilityAddressBoxArrow: "#00A9A1",
    howItWorksText: "#00A9A1",
    calenderTodayBackgroundColor: "#00A9A1",
    calenderSelectedDayColor: "#00A9A1",
    calenderSelectedDayTextColor: "#FFF",
    calenderSelectedDayStyleBGColor: "#00A9A1",
    reserveTableHeaderRightButtonText: "#00A9A1",
    reserveConfirmationDescriptionHeaderBg: "#00A9A1",
    waitlistVisibilityModalBg: "#000000B2",
    defaultCardColor: "#rgba(255, 255, 255, 0.3)",
    defaultCardTextColor: "#FFFFFF",
    waitlistTableRowSeperator: "#F6F6F6",
    mobilePayBringYourCardArea: "#D6DCD2",
    mobilePayCheckArea: "#F2F2F2",
    mobilePayCallInCheckDivider: "rgba(0, 0, 0, 0.1)",
    mobilePaySkeletonColor: "#DCDCDC",
    noOfGuestsLabelColor: "#808080",
    mobilePayCheckCloseBackgroundColor: "#F4F4F4",
    mobilePayCheckDividerColor: "rgba(0, 0, 0, 0.4)",
    mobilePayCheckBackground: "#FFFFFF",
    waitlistTableInfoBg: "#FCAF17",
    waitlistTableInfoText: "#FFFFFF",
    homescreenLocationTagBGColor: "rgba(255, 255, 255, 0.68)",
    homescreenLocationTagBorderColor: "#8F278A",
    homescreenLocationTextColor: "#8F278A",
    homeScreenAlertBackgroundGradientOne: "#BE6336",
    homeScreenAlertBackgroundGradientTwo: "#4E332B",
    // location Search Token
    locationSearchTitle: "#303030",
    locationSearchSubTitle: "#020001",
    locationSearchActiveTab: "#00A9A1",
    searchThisAreaBg: "#00A9A1",
    locationSearchInActiveTab: "#606060",
    searchCurrentLocation: "#A2402A",
    registerLsBtn: "#8F278A",
    allLocationsLsBg: "#F0FFFF",
    locationListingItemHeadingInPage: "#00A9A1",
    callRestLsText: "#303030",
    mobilePayICheckError: "#3F3C3C",
    locationSearchTabDivider: "#DEDEDE",
    locationSearchTabBgColor: "transparent",
    lsAllLocationsSelectBorder: "#D6D6D6",
    allLocationsLSPageBg: "#ffffff",
    locationSearchAddressColor: "#020001",
    locationsSearchPageLocationListItemBgColor: "#ffff",
    lsMyLocationsTabContentDivider: "#0000001a",
    hoursInfoAccordionIcon: "#8F278A",
    hoursInfoAccordionTitle: "#EC008C",
    joinWaitlistBtnHover: "white",
    joinWaitlistBtnTextHover: "#8F278A",
    newLoctionsLinkText: "white",
    loginScreenHeaderBackground: "white",
    loginScreenScrollBg: "white",
    createAccountZipCodeBg: "#FFFFFF",
    createAccountLocationCardBackgroundColor: "#FFFFFF",
    loginErrorMessageBg: "#FECACA",
    loginErrorMessageBorder: "#FCA5A5",
    preferredLocationScrollBg: "#FFFFFF",
    menuListingScrollBackground: "#FFFFFF",
    cartCheckoutButtonLinearGradientStart: "rgba(255,255,255,0.6)",
    cartCheckoutButtonLinearGradientEnd: "#FFF",
    menuListingTopTabsColor: "#FFF",
    cartHeaderTextColor: "#000",
    menuListingTopTabActiveBorderColor: "#8F278A",
    dividerBackgroundColor: "#E5E5E5",
    moreHeaderTitleTextColor: "#000000",
    customMobileHeaderBG: "#FFFFFF",
    addCreditCard_headerBackgroundColor: "#FFFFFF",
    editProfileInfoCardBg: "#FFFFFF",
    addCardSecurityBannerBg: "#F6F7F0",
    mobileCreateAccountScrollBackgroundColor: "transparent",
    menuTopTabNotActiveTextColor: "#171717",
    menuTopTabActiveTextColor: "#8F278A",
    checkoutTopTabActiveTextColor: "#171717",
    checkoutTopTabTextColor: "#171717",
    checkoutCardsBg: "transparent",
    orderInfoBannerCartSubTotalColor: "#00A9A1",
    orderSettingsCardsBackgroundColor: "transparent",
    orderSettingsActionSheetBackgroundColor: "#FFF",
    orderSettingsActionSheetAsapScheduledColor: "#00A9A1",
    menuItemDetailMenuSummaryBackgroundColor: "#FFF",
    menuitemDetailScreenBackgroundColor: "#FFF",
    cartHeaderBGColor: "#F6F6F6",
    nearbyLocationsListViewScrollViewBgColor: "#FFF",
    menuSearchResultsBg: "#fff",
    searchHeaderColor: "#fff",
    menuSearchPlaceHolder: "#606060",
    recentOrderDividerBg: "#E5E5E5",
    restDetailsTitleColor: "#2A2C25",
    restDetailsBg: "#fff",
    restDetailButtonBg: "#fff",
    newLocationsBannerBg: "#00A9A1",
    recentOrderBorder: "#F0FFFF",
    topTabCountInactiveBg: "#DAD4D5",
    tooltipTextColor: "#fff",
    pickupDetailsBorder: "#D6D6D6",
    checkoutVehicleBg: "#fff",
    seeDetailsText: "#606060",
    orderSettingsQuantityBg: "#F0FFFF",
    criticalModeBg: "#fafafa",
    reorderAddItemBg: "#8F278A",
    reorderAddItem: "#fff",
    orderHistoryItemCardBackgroundColor: "#FFF",
    orderHistoryItemCardPriceColor: "#00A9A1",
    orderHistoryHeaderTitleColor: "#2A2C25",
    orderHistoryDetailsOrderNumberTextColor: "#00A9A1",
    orderHistoryCardLayoutBackgroundColor: "#FFF",
    orderHistoryFooterBackgroundColor: "#FFF",
    orderHistoryHeaderBgColor: "#FFF",
    menuListSkeletonHeaderContainerBackground: "#F8F8F8",
    menuListSkeletonHeaderBackground: "#FFF",
    menuListSkeletonCategoryNavigationBgColor: "#F8F8F8",
    menuListSkeletonTopTabActiveBottomBorderColor: "#8F278A",
    menuDetailsHeaderTitleColor: "#404040",
    selectedOrderTypeBorderColor: "#00A9A1",
    selectedOrderTypeTextColor: "#00A9A1",
    reservationsLocationCardBg: "#FFFFFF",
    reservationDetailsCTABg: "#FFFFFF",
    reservationAvailableTimeSlotBg: "transparent",
    reservationTimeSlotsItemInactiveBg: "#D8DCE0",
    reservationsSpecialRequestBg: "transparent",
    reservationsConfirmationDetailsBg: "#FFFFFF",
    reservationHeaderTitleColor: "#404040",
    reservationDOBBgColor: "transparent",
    reservationsCardBg: "#fff",
    modalHeaderColor: "#fff",
    modalHeaderTextColor: "#404040",
    mobileCalendarTextColor: "#00A9A1",
    gcBalanceRefreshBorderTextColor: "#8F278A",
    gcBalanceRefreshBackdropColor: "rgba(0, 0, 0, 0.6)",
    smartRecommendationModalCloseIconColor: "#737373",
    noReservationBorder: "transparent",
    networkIndicatorColor: "black",
    //RESERVATION start
    reservationSelectedSeatingOption: "#73994A26",
    reservationCalendarCtaBorderRadius: 6,
    reservationDOBMonthBgColor: "#fff",
    reservationDOBNavColor: "primary.100",
    reservationDOBYearBgColor: "#fff",
    reservationInputErrorColor: "#DF4505",
    reservationLocationModalDeskHeaderBg: "#FFF",
    reservationLocationModalMobHeaderBg: "#FFF",
    reservationLocationListBg: "#FFF",
    pdLocationListBg: "#FFF",
    pdLocationListBgMobile: "#FFF",
    reservationDropDownIconColor: "#00A9A1",
    reservationsSpecialRequestSwitch: "#00A9A1",
    reservationBg: "#F6F6F6",
    reservationStaticTextBg: "#F0FFFF",
    reservationTabsBg: "#00A9A1",
    reservationPickerHoverColor: "#00A9A1",
    reservationNoOfGuestsSelectedBg: "#00A9A1",
    reservationNoOfGuestsNotSelectedBg: "white",
    reservationsTimePickerBg: "white",
    reservationActionButtonsBg: "white",
    reservationInactiveSelectTime: "#EDEDED",
    confirmationModalBorderRadius: 6,
    cancelConfirmationModalBorderRadius: 6,
    reservationUserInitials: "#00A9A1",
    preferredLocationCloseButtonBg: "#00A9A1",
    preferredLocationCloseButtonHover: "#00A9A1",
    preferredLocationModalContentColor: "#FFFFFF",
    preferredLocationCloseButtonIconColor: "#040101",
    reservationHoveredText: "#FFF",
    reservationNotHoveredText: "#606060",
    reservationsCardsBodyBg: "#F6F6F6",
    reservationSpecialRequests: "#FFFFFF",
    reservationDOBTooltipTextColor: "#FFFFFF",
    reservationDOBTooltipBgColor: "#8F278A",
    reservationsTopTabsBg: "#00A9A1",
    reservationsTopTabsLabel: "rgba(255, 255, 255, 0.7)",
    reservationsTopTabsLabelFocused: "#000",
    //RESERVATION end

    /** Colors: Private Dining Start */
    minimalHeaderSignInBtn: "#00A9A1",
    makeRequestPageBg: "#F0FFFF",
    requestFormTabActiveItem: "#00A9A1",
    requestFormTabDisableItem: "#B8CBCA",
    splRequestToggleTrackColor: "#8F278A",
    pdPurposeDropDownOptionHover: "#F0FFFF",
    pdTimeDropDownOptionHover: "#00A9A1",
    pdPartySizeRangeOptionHover: "#00A9A1",
    pdmenuPrefOptionHover: "#F0FFFF",
    pdFooterPrivacyNotice: "#00A9A1",
    pdContactDetailsEdit: "#00A9A1",
    pdReviewDetailsEventInfoDivider: "#D8D8D8",
    pdConfirmationMobileBg: "transparent",
    pdRequestFormInputBg: "#FFFFFF",
    pdRequestFormInputBorder: "#DDD",
    pdFooterBg: "#FFFFFF",
    pdActionSheetBody: "#FFFFFF",
    pdMobilePageBg: "transparent",
    eventPurposeSelectorColor: "#303030",
    eventPurposeSelectorHoverColor: "#303030",
    pdContactsPhoneTypeDivider: "#F3F3F3",
    pdFormAsteriskColor: "#303030",
    desktopTopTabsBG: "transparent",
    menuSearchModalCloseIconColor: "black",
    menuSearchInputBorder: "primary.100",
    menuSearchResultContainerBG: "#fff",
    pdRequestFormBG: "#fff",
    pdLandingMenuTabBg: "#FFFFFF",
    pdLandingLocationInfoMobileBg: "#F0FFFF",
    pdLandingDropdownActive: "#00A9A1",
    pdLandingDropdownInActive: "#FFFFFF",
    pdLandingNoLocationContainer: "transparent",
    pdInputDataTextColor: "#000",

    /** Colors: Private Dining End */
    menuItemcardVerticalImageBorderRadius: "xl",

    /** My Account Starts */
    myAccountSubTextColor: "#606060",
    myAccountScreenBackroundColor: "#F6F6F6",
    myAccountScreenMobileBackgroundColor: "#F6F6F6",
    myAccountScreenWebBackgroundColor: "#fff",
    myAccountScreenUserInfoTextColor: "#606060",
    myAccountCardShadow: "rgba(0, 0, 0, 0.2)",
    myAccountCardBackground: "#FFFFFF",
    myAccountCartAmountTextBorderColor: "#FFFFFF",
    myAccountCartAmountTextColor: "#FFFFFF",
    myAccountBgImageOverlay: "#F0FFFF",
    myAccountBgColor: "#F0FFFF",
    myAccountCardBackgroundActive: "#F0FFFF",
    myAccountChangeFieldModalBg: "white",
    myAccountEditProfileScrollViewBg: "white",
    myAccountAddGiftCardsPopover: "#54301A",
    myAccountDOBYearBgColor: "transparent",
    myAccountDOBMonthBgColor: "transparent",
    myAccountDOBTextColor: "#00A9A1",
    myAccountCalendarCtaBorderRadius: 6,
    myAccountGiftCardLargeBorderRadius: 26,
    myAccountMenuItemActiveTextColor: "#8F278A",
    myAccountMenuItemInActiveTextColor: "#303030",

    /** My Account Ends*/
    eClubHoverActiveColor: "#E9FBFA",
    eClubHoverActiveTextColor: "#303030",
    eClubHoverInactiveTextColor: "#303030",
    eClub_background_color: "#F6F6F6",
    eClub_confirmation_background_color: "#F6F6F6",
    eClubPopOverBackgroundColor: "#FFFFFF",
    EclubUnsubscribeBackgroundColor: "#F6F6F6",
    EClubUnsubscribeEmailValidationTextColor: "#f00",
    editProfileFullBottomButtonBackgroundColor: "white",
    orderHistoryFullBottomButtonBackgroundColor: "white",
    orderHistoryDetailsHeaderModalBackgroundColor: "white",
    joinEclubPreferredLocationLocationHeadingTextColor: "#808080",
    EClubInputErrorColor: "#DF4505",
    reservationSelectTimeTextColor: "#000",
    menuListingContainerBG: "#fff",
    locationListBgColor: "#fff",
    locationsSearchPageLocationListItemBgColorMobile: "#fff",
    joinEclubContainerBgColor: "#F6F6F6",
    editProfile_modalHeaderBackgroundColor: "#FFFFFF",
    editProfile_modalBodyBackgroundColor: "#F6F6F6",
    confirmationModalCTABackgroundColor: "#8F278A",
    myAccountCardMobileBackgroundColor: "transparent",
    giftCardLargeBody_BackgroundColor: "#FAFAFA",
    giftCardLargeBody_webModalBackgroundColor: "#FAFAFA",
    giftCardLargeHeader_BackgroundColor: "#FAFAFA",
    webOrderHistoryBackgroundColor: "#FFFFFF",
    orderHistoryDetailsBottomButton_BackgroundColor: "#FFFFFF",
    paymentOptionsAddEditGCModalHeaderBackgroundColor: "#FFFFFF",
    paymentOptionsAddEditCCModalHeaderBackgroundColor: "#FFFFFF",
    securityBannerTextColor: "#606060",
    addCreditDebitCardTooltipTextColor: "#606060",
    orderHistoryModalHeaderTextColor: "#404040",
    orderHistoryDetailsModalBackgroundColor: "#FFFFFF",
    EclubFormInputPlaceholderTextColor: "#989182",
    myAccountSkipConfirmationCTA: "#00A9A1",
    paymentOptions_giftCard_balanceAmountColor: "#000000",
    joinEclubPreferredLocationButtonBorderColor: "#D6D6D6",
    joinEclubDOBTextColor: "#8F278A",
    joinEclubPreferredLocationLocationNameTextColor: "#303030",
    joinEclubPreferredLocationLocationAddressTextColor: "#606060",
    EclubDOBBottomBorderColor: "#505050",
    reservationShareIconText: "#00A9A1",
    globalMessageBannerPadding: 1,
    errorDialogModalBorderRadius: 8,
    itemIsForBgColor: "#F0FFFF",
    locationListItemOrderText: "white",
    locationListItemOrderBg: "secondary.300",
    locationListItemOrderHoverBg: "secondary.300",
    locationListItemOrderPadding: 3,
    orderDetailsCartItemPrice: "#000000"
  },
  components: {
    Pressable: {
      variants: {
        // My Account starts
        myAccount_edit_fields_sheet_title_container: {
          bg: "white",
          width: "100%"
        },
        myAccount_order_history_order_details_modal_header_close_icon: {
          position: "absolute",
          right: 5,
          my: "auto"
        },
        myAccount_infoList_changeOperation_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          shadow: 17,
          py: 5,
          backgroundColor: {
            base: "myAccountCardBackground",
            md: "#F6F6F6"
          },
          borderRadius: 0
        },
        myAccount_paymentOptions_addGC_actionSheet_Add: function myAccount_paymentOptions_addGC_actionSheet_Add(_ref) {
          var isDisabled = _ref.isDisabled;
          return {
            my: 1,
            borderRadius: 8,
            width: "100%",
            backgroundColor: !isDisabled ? "secondary.300" : "themeDisableButton",
            flex: 1,
            _web: {
              my: 0
            }
          };
        },
        // My Account ends

        /* RESERVATION */
        reservationLocationSelectionBtn: {
          borderRadius: 6,
          px: 10,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center"
        },
        reservationConfBackHomeBtn: {
          borderRadius: 6,
          alignItems: "center",
          justifyContent: "center",
          mb: 30,
          mx: 5,
          px: 5,
          mt: 5,
          borderWidth: 1,
          height: 12,
          borderColor: "secondary.300"
        },
        reservationSelectGuestBtn: {
          borderColor: "reservationBorderColor",
          borderWidth: 1,
          py: 3,
          px: 5,
          mx: 1.5,
          borderRadius: 8,
          _ios: {
            radiusValue: 6
          },
          _android: {
            radiusValue: 6
          }
        },
        reservationPickerBtn: {
          flex: 1,
          py: 2,
          _web: {
            py: 4,
            px: 4
          },
          _ios: {
            alignItems: "center"
          },
          _android: {
            alignItems: "center"
          },
          mx: 1.5,
          borderRadius: 4,
          justifyContent: "center"
        },
        reservationAvailableTimeSlotBtn: {
          borderColor: "reservationBorderColor",
          borderRadius: 4,
          mx: 2
        },

        /* RESERVATION */
        jwcPreOrderBtn: {
          px: 5,
          py: 4,
          bg: {
            base: "#A2402A",
            lg: "white"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        qualityStoryBtnCta: {
          px: 5,
          py: 4,
          bg: {
            base: "#ffffff",
            lg: "#ffffff"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        categoryActiveBorder: {
          borderBottomWidth: "5"
        },
        suggestedSearchPill: {
          mt: 2,
          mb: 2,
          mr: 3,
          py: 2,
          px: 4,
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          bg: "#FFFFFF",
          borderColor: "suggestionsBorderColor",
          borderRadius: 50
        },
        //Order Tracking
        orderTrackingCurbsideCheckPrimary: {
          bg: "payNowButtonBg",
          borderColor: "curbsideCheckInSecondary",
          borderWidth: 1,
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        orderTrackingCurbsideCheckSecondary: {
          bg: "#FFFFFF",
          borderColor: "curbsideCheckInSecondary",
          px: 5,
          py: 3,
          borderWidth: 1,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        //Restaurant Details Start
        restaurantDetails_RestWaitlist_JoinWaitlistButton: function restaurantDetails_RestWaitlist_JoinWaitlistButton(_ref2) {
          var disabled = _ref2.disabled;
          return {
            borderRadius: 5,
            borderColor: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 1,
            _ios: {
              py: 2
            },
            _android: {
              py: 2
            },
            bg: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            minWidth: {
              base: "70%",
              lg: "261px"
            },
            _web: {
              minH: "48px"
            }
          };
        },
        restaurantDetails_OrderButtonSection_OrderNowButton: function restaurantDetails_OrderButtonSection_OrderNowButton(_ref3) {
          var disabled = _ref3.disabled;
          return {
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "secondary.300",
            borderRadius: 8,
            opacity: disabled ? 0.4 : 1,
            borderWidth: 1,
            width: "100%",
            disabled: disabled,
            _web: {
              minH: "48px",
              padding: 2
            },
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconButton: function restaurantDetails_RestTimings_WeekDayIconButton(_ref4) {
          var selectedDay = _ref4.selectedDay;
          return {
            borderRadius: 100,
            backgroundColor: selectedDay ? "restaurantTimingWeekDayTextColor" : "restaurantDetailsNotSelectedWeekDayColor",
            width: 38,
            height: 38,
            borderColor: "weekDayBorderColor",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center"
          };
        },
        restaurantDetails_ActionButtons_ApplyNowButton: function restaurantDetails_ActionButtons_ApplyNowButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: 4,
            _web: {
              minH: "48px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_ActionButtons_ViewMenuButton: function restaurantDetails_ActionButtons_ViewMenuButton(_ref5) {
          var disabled = _ref5.disabled;
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            opacity: disabled ? 0.4 : 1,
            borderRadius: 8,
            paddingY: 4,
            _web: {
              minH: "48px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_RestaurantInfo_FavoriteButton: function restaurantDetails_RestaurantInfo_FavoriteButton() {
          return {
            bg: "white",
            w: "10",
            h: "10",
            shadow: 11,
            m: "auto",
            rounded: "full",
            position: "absolute",
            top: 2,
            right: 2
          };
        },
        restaurantDetails_RestInfo_ShareButton_Icon: {
          alignItems: "center",
          flexDirection: "row"
        },
        //Restaurant Details End
        locationListItemAddress: {
          pointerEvents: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref6) {
          var radiusValue = _ref6.radiusValue,
              topRadiusValue = _ref6.topRadiusValue,
              bottomRadiusValue = _ref6.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        viewCartBtnBorderRadius: {
          _ios: {
            borderRadius: 8
          },
          _android: {
            borderRadius: 8
          }
        },
        homeScreen_order_button: function homeScreen_order_button() {
          return {
            shadow: 9,
            backgroundColor: "secondary.300",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%"
          };
        },
        reservationCTASelector: {
          borderRadius: 12
        },
        reservationTimeSelectionCTA: {
          borderRadius: 6
        },

        /** Pressable: Private Dining Start */
        privateDiningLocationSelectionBtn: {
          borderRadius: 6,
          px: 10,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center",
          margin: "auto"
        },
        privateDiningModalCancelCTA: {
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "#8F278A",
          borderRadius: 4,
          alignItems: "center",
          justifyContent: "center",
          w: "100%"
        },
        privateDiningModalConfirmCTA: {
          bg: "#8F278A",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 4,
          w: "100%",
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "#8F278A"
        },
        pd_landing_menuTabs_Item: function pd_landing_menuTabs_Item(_ref7) {
          var isActive = _ref7.isActive;
          return {
            bgColor: isActive ? "#8F278A" : "transparent",
            px: isActive ? 4 : 0,
            py: isActive ? 1.5 : 0,
            borderRadius: 20
          };
        },
        pd_landing_noLocation_selectCTA: {
          bgColor: "#8F278A",
          borderRadius: 8,
          mt: {
            base: 8,
            md: 12
          },
          py: 3.5,
          px: 24,
          width: {
            base: "100%",
            sm: "auto"
          }
        },
        pd_landing_eventGuideCTA: {
          width: {
            base: "100%",
            lg: "273px"
          },
          borderColor: "#8F278A",
          borderWidth: 1,
          borderRadius: 8
        },
        myAccount_paymentOptions_addCard_Pressable: {
          mt: 8,
          bg: "#8F278A",
          borderRadius: 8,
          mx: 5,
          _ios: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          },
          _android: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          }
        },
        addEditCreditCard_add_pressable: {
          width: "100%",
          backgroundColor: "secondary.300",
          borderRadius: 8
        },
        myAccount_menuListItem_pressable: function myAccount_menuListItem_pressable(_ref8) {
          var isActive = _ref8.isActive;
          return {
            borderRadius: 8,
            alignItems: "center",
            padding: 4,
            backgroundColor: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground",
            flexDirection: "row",
            _web: {
              backgroundColor: {
                base: "white",
                md: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground"
              }
            }
          };
        },

        /** Pressable: Private Dining End */
        eClubStickySignUpDesktopPressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          w: "100%",
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelDesktopPressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          w: "100%",
          right: 4,
          h: "100%",
          justifyContent: "center"
        },
        eClubConfirmationSignUpMobilePressable: {
          bg: "secondary.300",
          mt: 10,
          width: "100%",
          alignItems: "center",
          borderRadius: 10,
          py: 3,
          mb: 5
        },
        eClubStickySignUpMobilePressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          flex: 1,
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelMobilePressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          flex: 1,
          mr: 3,
          h: "100%",
          justifyContent: "center"
        },
        myAccount_editFieldsConfirmationModalCancelCTAPressable: {},
        myAccount_paymentOptions_checkBalanceCTA: {
          justifyContent: "center",
          alignItems: "center",
          marginY: 1,
          border: 1.5,
          borderColor: "#8F278A",
          borderRadius: 8,
          _web: {
            my: 0
          },
          flex: 1,
          mr: 2
        }
      }
    },
    Button: {
      variants: {
        solid: {
          bg: "#8F278A",
          _pressed: {
            bg: "#8F278A"
          },
          _hover: {
            bg: "#671B63"
          }
        },
        ghost: {
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            bg: "background.100"
          }
        },
        addMoreItemsButton: {
          _ios: {
            width: "100%",
            py: 4
          },
          _android: {
            width: "100%",
            py: 4
          },
          _web: {
            width: "100%",
            py: 2
          }
        },
        HomeScreenCTAreserveNow: function HomeScreenCTAreserveNow(_ref9) {
          var borderRadiusValue = _ref9.borderRadiusValue;
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            bg: "bodyBg",
            _text: {
              color: "secondary.300"
            }
          };
        },
        HomeScreenCTAjwl: function HomeScreenCTAjwl(_ref10) {
          var borderRadiusValue = _ref10.borderRadiusValue;
          return {
            marginTop: 5,
            borderRadius: borderRadiusValue || 0
          };
        },
        HomescreenOrderOnlineCta: function HomescreenOrderOnlineCta(_ref11) {
          var borderRadiusValue = _ref11.borderRadiusValue;
          return {
            borderRadius: borderRadiusValue || 0,
            backgroundColor: "secondary.300",
            shadow: 9
          };
        },
        wcacSecondaryBtn: {
          bg: "white",
          _hover: {
            bg: "background.100"
          },
          _pressed: {
            bg: "background.100"
          },
          border: 1,
          borderColor: "#00A9A1",
          mr: 3,
          _text: {
            px: 4,
            fontSize: 16,
            fontWeight: 200,
            color: "#00A9A1",
            textTransform: "uppercase"
          }
        },
        wcacPrimaryBtn: {
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#00A9A1"
          },
          _text: {
            px: 2,
            fontSize: 16,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        remoteCheckinBodyBtn: {
          mt: 3,
          bg: "#8F278A",
          _web: {
            width: {
              base: "80%",
              sm: "80%",
              md: "100%"
            }
          },
          pt: 2,
          pb: 2
        },
        camAccessBtn: {
          bg: "#8F278A",
          paddingY: 18,
          marginTop: 27,
          marginX: 5,
          borderWidth: 1,
          w: "100%",
          _text: {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        socialLoginBtn: {
          bg: "transparent",
          mb: 4,
          border: 1,
          borderColor: "rgb(53,88,156)",
          borderRadius: 4,
          _text: {
            fontWeight: 400,
            color: "rgb(53,88,156)"
          },
          _hover: {
            bg: "white"
          }
        },
        loginPopUpBtn: {
          borderRadius: 4,
          height: 12,
          _web: {
            height: null
          },
          _text: {
            color: "white",
            fontWeight: 400
          },
          bg: "#8F278A",
          _pressed: {
            bg: "#8F278A"
          },
          _hover: {
            bg: "#671B63"
          }
        },
        link: {
          _text: {
            textTransform: "uppercase",
            color: "#00A9A1",
            fontWeight: "500",
            fontStyle: "normal",
            fontSize: "md",
            lineHeight: 6,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            textAlign: "center"
          },
          _pressed: {
            bg: "transparent"
          }
        },
        outline: {
          _hover: {
            bg: "#EDDAEC"
          },
          _pressed: {
            bg: "#EDDAEC"
          }
        },
        cartItemActionButton: {
          _text: {
            color: "cartItemActionBtn",
            textTransform: "uppercase",
            lineHeight: 5,
            fontWeight: 300,
            fontFamily: "headingSecondary",
            _ios: {
              fontSize: "20",
              fontWeight: "400"
            },
            _android: {
              fontSize: "20",
              fontWeight: "400"
            },
            _web: {
              fontSize: "20px"
            }
          }
        },
        refreshIcon: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "white",
          borderColor: "#00A9A1",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "secondary.300",
            fontWeight: 400
          }
        },
        cartItemRemoveBtn: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "secondary.300",
          borderColor: "secondary.300",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "white",
            fontWeight: 400,
            fontFamily: "headingSecondary"
          }
        },
        changeLocationLink: {
          _text: {
            textTransform: "uppercase",
            _web: {
              fontSize: "xs"
            },
            fontWeight: "400",
            color: "#00A9A1",
            fontStyle: "normal",
            lineHeight: 6,
            letterSpacing: "-0.3px",
            textAlign: "center"
          },
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            _text: {
              underline: true
            }
          }
        },
        orderOnlineBtn: function orderOnlineBtn(_ref12) {
          var isMacOS = _ref12.isMacOS;
          return {
            padding: 0,
            _text: {
              color: "white",
              fontFamily: "headingSecondary",
              fontWeight: 300,
              fontSize: "lg",
              textTransform: "uppercase",
              margin: 2,
              marginBottom: {
                lg: 0.5
              },
              _web: {
                marginBottom: {
                  lg: isMacOS ? 2 : 0.5
                },
                marginTop: {
                  base: isMacOS ? "8px" : "11px",
                  lg: 2
                }
              }
            },
            bg: "locationListBtn",
            _hover: {
              bg: "locationListBtn"
            },
            _pressed: {
              bg: "locationListBtn"
            }
          };
        },
        orderOnlineBtnExternalLink: function orderOnlineBtnExternalLink(_ref13) {
          var isMacOS = _ref13.isMacOS;
          return {
            padding: 0,
            _text: {
              color: "white",
              fontFamily: "headingSecondary",
              fontWeight: 300,
              fontSize: "lg",
              textTransform: "uppercase",
              margin: 2,
              marginBottom: {
                lg: 0.5
              },
              _web: {
                marginBottom: {
                  lg: isMacOS ? 2 : 0.5
                }
              }
            },
            border: 1,
            borderColor: "secondary.300",
            bg: "secondary.300",
            _hover: {
              bg: "secondary.300"
            },
            _pressed: {
              bg: "secondary.300"
            }
          };
        },
        menuButton: function menuButton(_ref14) {
          var isActive = _ref14.isActive,
              isMobile = _ref14.isMobile,
              isLongText = _ref14.isLongText;
          return {
            ml: isLongText && isMobile && 5,
            px: isMobile ? 6 : 9,
            bg: isActive ? "menuButtonBackgroundColor" : "transparent",
            width: !isMobile && (isLongText ? "100%" : 32),
            height: {
              base: 8,
              md: 9
            },
            _web: {
              borderReadis: "17px",
              width: !isMobile && (isLongText ? "100%" : "117px")
            },
            borderReadis: 4,
            rounded: "full",
            _text: {
              color: isActive ? "white" : "menuButtonBackgroundColor",
              fontWeight: "500",
              fontSize: isMobile ? "xs" : "sm",
              _web: {
                lineHeight: isMobile ? "14.63px" : "24px",
                fontSize: {
                  base: "12px",
                  md: "14px"
                }
              },
              lineHeight: isMobile ? 4 : 6,
              textTransform: "uppercase"
            }
          };
        },
        pillButton: function pillButton(_ref15) {
          var isActive = _ref15.isActive;
          return {
            bg: isActive ? "secondary.100" : "transparent",
            _web: {
              borderRadius: "20px",
              height: "24px"
            },
            borderRadius: 5,
            height: 6
          };
        },
        exploreMenuButton: function exploreMenuButton() {
          return {
            bg: "white",
            border: 1,
            borderColor: "#8F278A",
            _text: {
              color: "#8F278A"
            }
          };
        },
        orderSettingsDateTimeChoiceSolidButton: function orderSettingsDateTimeChoiceSolidButton() {
          return {
            bg: "orderSettingsDateTimeChoiceColor"
          };
        },
        addToCartSolidButton: function addToCartSolidButton(_ref16) {
          var isUnavailable = _ref16.isUnavailable,
              isMacOS = _ref16.isMacOS;
          return {
            bg: isUnavailable ? "#E5E5E5" : "#8F278A",
            _pressed: {
              bg: isUnavailable ? "#E5E5E5" : "#8F278A"
            },
            _hover: {
              bg: isUnavailable ? "#E5E5E5" : "#8F278A"
            },
            _text: {
              fontWeight: "700"
            },
            _web: {
              paddingBottom: {
                lg: isMacOS && 5
              }
            }
          };
        },
        addBtnPadding: function addBtnPadding(_ref17) {
          var isMacOS = _ref17.isMacOS;
          return {
            fontFamily: "headingSecondary",
            _web: {
              paddingBottom: {
                base: "8px",
                lg: isMacOS ? "8px" : "2px"
              }
            },
            _text: {
              fontFamily: "headingSecondary"
            },
            paddingBottom: 2
          };
        },
        confirmationGradientButton: function confirmationGradientButton() {
          return {
            borderRadius: 8
          };
        },
        waitlistOrder: {
          backgroundColor: "white",
          borderColor: "#8F278A",
          borderWidth: 1,
          pt: 1,
          pb: 1
        },
        //Restaurant Details Start
        restaurantDetails_RestInfo_GetDirectionsButton: function restaurantDetails_RestInfo_GetDirectionsButton() {
          return {
            variant: "outline",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "amenitiesActionButtonsColor",
            alignSelf: "flex-end",
            borderWidth: 1,
            bg: "white",
            _hover: {
              bg: "white"
            },
            _focus: {
              bg: "white"
            },
            _focusVisible: {
              bg: "white"
            },
            py: 2.5,
            px: 2
          };
        },
        //Restaurant Details End
        menuSearchModalCloseButtonContainer: function menuSearchModalCloseButtonContainer() {
          return {
            _web: {
              marginRight: {
                base: "20px",
                md: "40px",
                lg: "110px"
              },
              marginTop: "26px",
              height: "48px",
              width: "48px",
              borderRadius: "8px"
            }
          };
        },
        preorderDineIn: {
          backgroundColor: "#00A9A1"
        },
        // LS tokens
        viewMenuBtn: function viewMenuBtn(_ref18) {
          var isMacOS = _ref18.isMacOS,
              isViewMenu = _ref18.isViewMenu;
          return {
            padding: 0,
            borderWidth: 1,
            borderColor: "secondary.300",
            _text: {
              color: "secondary.300",
              marginY: "11px",
              marginX: 4,
              _web: {
                marginTop: isMacOS ? "11px" : "13px",
                py: isMacOS ? 0 : isViewMenu ? "1.5px" : 0
              },
              fontSize: "sm",
              fontWeight: 400,
              letterSpacing: -0.3,
              fontFamily: "body",
              lineHeight: 4
            }
          };
        },
        defaultBannerBtn: function defaultBannerBtn() {
          return {
            _web: {
              minW: 134,
              px: 4,
              py: 2
            },
            _ios: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            _android: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            px: 4,
            py: 2,
            borderWidth: 1,
            borderColor: "primary.200",
            bg: "#8F278A"
          };
        },
        locationListItemButton: {
          _text: {
            fontFamily: "Brandon",
            fontSize: "16px",
            letterSpacing: 0.2,
            fontWeight: 300,
            _ios: {
              paddingTop: "2px"
            },
            _android: {
              paddingTop: "2px"
            }
          }
        },
        locationListItemButtonWindows: {
          _text: {
            fontFamily: "Brandon",
            fontSize: "16px",
            letterSpacing: 0.2,
            fontWeight: 300,
            paddingTop: "3px"
          }
        },
        viewMenuBtnExternalLink: function viewMenuBtnExternalLink(_ref19) {
          var isLocationSearch = _ref19.isLocationSearch,
              fromAllLocations = _ref19.fromAllLocations,
              isMacOS = _ref19.isMacOS;
          return {
            padding: 0,
            borderWidth: 1,
            borderColor: "secondary.300",
            _text: {
              color: "secondary.300",
              marginY: "11px",
              _web: {
                marginTop: isMacOS ? "11px" : "13px"
              },
              marginX: 4,
              fontSize: "sm",
              fontWeight: 400,
              letterSpacing: -0.3,
              fontFamily: "body",
              lineHeight: 4
            },
            bg: isLocationSearch && fromAllLocations ? "transparent" : "secondary.300",
            _hover: {
              bgColor: "secondary.300",
              _text: {
                color: "white"
              }
            },
            _pressed: {
              bgColor: "secondary.300"
            }
          };
        },
        locationListItemButtonBorderRadius: 6,
        locationsInfographicLoginButton: function locationsInfographicLoginButton() {
          return {
            pr: 12,
            pl: 12,
            py: 3,
            backgroundColor: "secondary.300",
            borderRadius: 6,
            _text: {
              color: "locationInfographicModalActionButtonTextColor",
              fontSize: 18,
              fontWeight: 400,
              textTransform: "uppercase",
              textAlign: "center",
              lineHeight: 6
            }
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref20) {
          var radiusValue = _ref20.radiusValue,
              topRadiusValue = _ref20.topRadiusValue,
              bottomRadiusValue = _ref20.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        viewNutritionalVariant: {
          py: 1,
          mb: 2
        },
        confirmBtnBorderRadius: {
          borderRadius: 8
        },
        joinWaitlist_Header_LoginButton: function joinWaitlist_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "primary.100",
              fontWeight: 400
            },
            borderColor: "primary.100",
            borderRadius: 6,
            px: "17px",
            py: "10px",
            _web: {
              px: {
                base: "10px",
                lg: "17px"
              },
              py: {
                base: "6px",
                lg: "10px"
              }
            },
            _focus: {
              backgroundColor: "white"
            },
            bg: "transparent",
            borderWidth: 1
          };
        },
        homeScreen_reserve_button: function homeScreen_reserve_button() {
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%",
            bg: "bodyBg",
            _pressed: {
              bg: "bodyBg"
            },
            _text: {
              _ios: {
                fontSize: 18
              },
              _android: {
                fontSize: 18
              },
              _web: {
                fontSize: 18
              },
              color: "secondary.300",
              fontWeight: 400,
              lineHeight: 7,
              paddingTop: Platform.OS === "ios" ? 1 : 0,
              marginY: 0.5
            }
          };
        },

        /** Button: Private Dining Start */
        pd_Header_LoginButton: function pd_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "primary.100",
              fontWeight: 400,
              textTransform: "uppercase"
            },
            px: "17px",
            py: "10px"
          };
        },
        pd_request_eventDetails_confirmCTA: function pd_request_eventDetails_confirmCTA() {
          return {
            borderRadius: 8,
            backgroundColor: "#8F278A",
            padding: 0,
            marginTop: 4,
            marginX: 5,
            marginBottom: 3,
            h: 12,
            _text: {
              color: "white",
              letterSpacing: -0.5,
              fontWeight: "400",
              fontSize: 18,
              marginTop: 3,
              marginBottom: 3,
              lineHeight: 6,
              textAlign: "center",
              textTransform: "uppercase"
            },
            _pressed: {
              opacity: 0.8
            }
          };
        },
        pd_requestForm_Footer_cancalCTA: function pd_requestForm_Footer_cancalCTA() {
          return {
            bg: "none",
            border: 2,
            borderColor: "#8F278A",
            _text: {
              fontSize: 16,
              color: "#8F278A"
            },
            _hover: {
              bg: "none"
            }
          };
        },
        pd_requestForm_Footer_ContinueCTA: function pd_requestForm_Footer_ContinueCTA() {
          return {
            px: 12,
            _text: {
              fontWeight: 400,
              fontSize: 16,
              color: "white"
            },
            bg: "#8F278A",
            borderRadius: 6
          };
        },
        pd_confirmation_backToHomeCTA: {
          bg: "none",
          border: 2,
          borderColor: "#8F278A",
          px: 12,
          mt: {
            md: 5
          },
          _text: {
            fontSize: 16,
            color: "#8F278A",
            fontFamily: "Now-Medium"
          },
          _hover: {
            bg: "none"
          }
        },
        pd_landing_stickyFooter_pdReqCTA: {
          py: 2.5,
          width: {
            base: "100%",
            md: "469px"
          },
          height: 12,
          bgColor: "#8F278A",
          borderRadius: 8
        },
        confirmAndAddToCartButton: {
          bg: "#8F278A",
          _pressed: {
            bg: "#8F278A"
          },
          _hover: {
            bg: "#671B63"
          }
        },

        /** Button: Private Dining End */
        ErrorDialogOKButton: {
          bg: "#8F278A",
          _pressed: {
            bg: "#8F278A"
          },
          _hover: {
            bg: "#671B63"
          }
        },

        /** My Account Starts*/
        myAccount_paymentOptions_gc_bs_deleteCTA: {
          width: "100%",
          mb: 5,
          borderWidth: 1,
          borderColor: "secondary.300",
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "secondary.300"
          },
          _web: {
            width: {
              base: "100%",
              md: "30%"
            },
            py: {
              base: 5,
              md: 2.5
            },
            mb: {
              base: 5,
              md: 0
            }
          }
        },

        /** My Account Ends */
        EClubUnsubscribeSubmitButton: {
          alignSelf: {
            md: "flex-start"
          },
          _text: {
            color: "white",
            fontWeight: 300
          },
          bg: "#8F278A",
          _pressed: {
            bg: "#8F278A"
          },
          _hover: {
            bg: "#671B63"
          }
        },
        editProfileFullBottomButton: {},
        orderHistoryReorderFullBottomButton: {},
        noPrefLocationScreen_selectCTA_Button: {
          width: "300px",
          py: 3.5,
          mt: 10,
          bg: "secondary.300",
          mx: "auto"
        },
        orderHistory_emptyScreenCTA_button: {
          width: {
            base: "200px",
            md: "256px"
          },
          py: {
            base: 2.5,
            md: 3.5
          },
          mt: {
            base: 10,
            md: 10
          },
          bg: "secondary.300"
        },
        addEditCreditCard_delete_button: {
          flex: 1,
          mr: 2,
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "secondary.300"
          },
          bg: "transparent",
          borderColor: "secondary.300",
          borderWidth: 1
        },
        addEditCreditCard_update_button: {
          flex: 1,
          ml: 2,
          py: 5,
          _text: {
            fontSize: 16,
            lineHeight: 6,
            letterSpacing: -0.5,
            fontWeight: 400,
            textAlign: "center",
            color: "addCardFooterButtonText"
          },
          bg: "secondary.300"
        },
        myAccount_paymentOptions_deleteGiftCard_confirmationCTAStyles: {
          _text: {
            py: 1
          }
        },
        myAccount_paymentOptions_deleteCreditCard_confirmationCTAStyles: {},
        myAccount_paymentOptions_giftCardDetails_refreshCTA: {
          mb: 5,
          paddingX: 2,
          width: "60%",
          borderColor: "gcBalanceRefreshBorderTextColor",
          mr: 1,
          _web: {
            width: {
              base: "45%",
              md: "30%"
            }
          },
          _text: {
            color: "gcBalanceRefreshBorderTextColor",
            fontWeight: 400
          },
          bg: "#FFFFFF"
        },
        previousOrderItemAddCta: {
          borderRadius: {
            base: "md",
            md: "lg"
          },
          bg: "white",
          borderColor: "reOrderAddBtnBorder",
          borderWidth: 1
        }
      }
    },
    Input: {
      baseStyle: {
        rounded: 0,
        fontFamily: "Now-Medium"
      },
      variants: {
        menuSearchInputContainer: {
          borderRadius: 8
        },
        borderRadiusValue: function borderRadiusValue(_ref21) {
          var radiusValue = _ref21.radiusValue,
              topRadiusValue = _ref21.topRadiusValue,
              bottomRadiusValue = _ref21.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },

        /** Input: Private Dining Start */
        pd_request_eventDetails_noOfGuestinput: {
          borderRadius: 6,
          fontFamily: "Now-Regular"
        },
        pd_request_eventDetails_SplRequest: {
          borderRadius: 8
        },
        pd_request_contactDetails_input: {
          borderRadius: 6,
          fontFamily: "Now-Regular"
        },

        /** Input: Private Dining End */
        myAccountInputForm: {
          fontFamily: "Now-Regular"
        }
      }
    },
    Tooltip: {
      baseStyle: {
        borderRadius: 8,
        padding: 3,
        bg: "#1AA9A0",
        _text: {
          fontSize: 12,
          fontWeight: 500,
          color: "#ffffff"
        }
      }
    },
    Accordion: {
      baseStyle: {
        borderWidth: 0,
        borderColor: "transparent",
        borderRadius: 0
      },
      variants: {
        skuSelectorAccordion: function skuSelectorAccordion(_ref22) {
          var isMandatory = _ref22.isMandatory;
          return {
            borderRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemAccordion: function menuItemAccordion() {
          return {
            borderRadius: {
              md: "10"
            }
          };
        }
      }
    },
    ModalHeader: {
      variants: {
        errorDialogModalHeader: {
          roundedTop: 8
        }
      }
    },
    ModalBody: {
      variants: {
        smartRecommendationModalModalBody: {
          _ios: {
            width: "100%"
          },
          _android: {
            width: "100%"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyStyles: {
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          borderRadius: 12,
          p: {
            base: 6,
            md: 10
          },
          pt: 10
        },
        myAccount_paymentOptions_giftCardsLimitReached_modalBodyStyles: {
          alignItems: "center",
          justifyContent: "center",
          p: 6,
          borderRadius: 12,
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          pt: 10,
          _web: {
            pt: 6
          }
        }
      }
    },
    ModalContent: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref23) {
          var radiusValue = _ref23.radiusValue,
              topRadiusValue = _ref23.topRadiusValue,
              bottomRadiusValue = _ref23.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        pd_cancelModal: {
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "335px",
          py: 8,
          px: 6,
          borderRadius: 4
        },
        editFieldsConfirmationModal: {
          borderRadius: 12,
          p: 12
        },
        editFieldsSuccessModal: {
          borderRadius: 12,
          p: 12,
          maxWidth: {
            md: "588"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_modalContentStyles: {
          p: 0,
          borderRadius: 12
        },
        myAccount_paymentOptions_giftCardLimitReached_modalContentStyles: {
          width: {
            md: "370px"
          },
          p: 0,
          borderRadius: 12
        }
      }
    },
    AccordionSummary: {
      baseStyle: {
        borderTopWidth: 0,
        borderTopColor: "transparent",
        p: 0,
        _hover: {
          bg: "transparent"
        },
        _expanded: {
          bg: "transparent",
          borderBottomColor: "transparent",
          _text: {
            color: "white"
          }
        },
        _disabled: {
          bg: "transparent"
        }
      },
      variants: {
        skuSelectorSummary: function skuSelectorSummary(_ref24) {
          var isMandatory = _ref24.isMandatory;
          return {
            borderTopRadius: {
              md: isMandatory && "xl"
            }
          };
        }
      }
    },
    AccordionDetails: {
      variants: {
        skuSelectorDetails: function skuSelectorDetails(_ref25) {
          var isMandatory = _ref25.isMandatory;
          return {
            borderBottomRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemDetails: function menuItemDetails(_ref26) {
          var isDefaultExpanded = _ref26.isDefaultExpanded;
          return {
            borderBottomRadius: {
              md: isDefaultExpanded && "xl"
            }
          };
        }
      }
    },
    Stack: {
      variants: {
        skuSelectorItem: {
          borderRadius: 12
        },
        //Restaurant Details Start
        restaurantDetails_CurrentStatusAndWaitlist_AvailabilityStack: {
          alignItems: {
            lg: "flex"
          },
          _ios: {
            marginTop: 3
          },
          _android: {
            marginTop: 3
          },
          direction: {
            base: "row",
            lg: "column"
          },
          justifyContent: "space-between",
          space: "md"
        },
        restaurantDetails_CurrentStatusAndWaitlist_WaitTimeStack: {
          _ios: {
            marginRight: 4
          },
          _android: {
            marginRight: 4
          },
          direction: {
            base: "column",
            lg: "row"
          },
          alignItems: "center",
          space: {
            lg: "sm"
          }
        },
        restaurantDetails_RestInfo_AddressLink_Stack: {
          direction: {
            base: "column",
            lg: "row"
          }
        },
        //Restaurant Details End
        EClubUnsubscribeFormContainer: {
          direction: {
            base: "column",
            md: "row"
          },
          space: {
            base: 4,
            md: 8
          },
          maxW: "500"
        },

        /** Stack: Private Dining Start */
        pd_landing_stickyFooter_container: {
          direction: {
            base: "column-reverse",
            lg: "row"
          },
          bgColor: "#FFFFFF",
          alignItems: "center",
          justifyContent: "space-between",
          py: {
            base: 3,
            md: 7
          },
          px: {
            base: 5,
            md: 32
          },
          shadow: 14
        }
        /** Stack: Private Dining End */

      }
    },
    Divider: {
      variants: {
        restaurantDetails_RestInfo_Divider: {
          mx: 10
        },
        jwcFooterBlockDivider: {
          height: 4,
          backgroundColor: "#8A8585",
          orientation: "vertical",
          mx: 3.5,
          w: 0.4
        }
      }
    },
    Text: {
      variants: {
        myAccount_button_editConfirmation_text: {
          fontWeight: 400
        },
        myAccount_button_cta_weight: 400,
        createAccountSelectPrefLocationText: {
          color: "secondary.300",
          lineHeight: 6,
          fontSize: 18,
          fontWeight: 300,
          ml: 1,
          mr: {
            base: 8,
            md: 8
          }
        },
        // My Account
        myAccountLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400,
          color: "#8F278A"
        },
        myAccountLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        myAccountLocationCardPhoneNumber: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        myAccountChangeLocationChangeText: {
          color: "#8F278A",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 400,
          _ios: {
            fontSize: 12
          },
          _android: {
            fontSize: 12
          },
          _web: {
            textTransform: "uppercase"
          }
        },
        myAccountDOBPrevText: function myAccountDOBPrevText(_ref27) {
          var prevMonthButtonDisabled = _ref27.prevMonthButtonDisabled;
          return {
            mr: "auto",
            fontSize: 12,
            color: prevMonthButtonDisabled ? "transparent" : "#303030",
            textTransform: "capitalize"
          };
        },
        myAccountDOBNextText: function myAccountDOBNextText(_ref28) {
          var nextMonthButtonDisabled = _ref28.nextMonthButtonDisabled;
          return {
            ml: "auto",
            fontSize: 12,
            color: nextMonthButtonDisabled ? "transparent" : "#303030",
            textTransform: "capitalize"
          };
        },
        myAccountContainerTitle: {
          fontSize: 20,
          fontWeight: 500,
          textTransform: "uppercase",
          color: "#2A2C25",
          lineHeight: 6,
          letterSpacing: "-0.3"
        },
        myAccount_MenuListItem_cardText_title: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300
        },
        myAccount_MenuListItem_cardText_subTitle: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subText: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          color: "myAccountSubTextColor",
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subTitle2: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "myAccountSubTextColor"
        },
        myAccount_ChangeField_title: {
          paddingLeft: 5,
          paddingTop: 4,
          paddingBottom: 3,
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_ChangeEmail_headerTitle: {
          mt: 6,
          mb: 5,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#2A2C25"
        },
        myAccount_profileInfo_infoCard_title: {
          color: "#000",
          fontSize: 20,
          fontWeight: 400
        },
        myAccount_profileInfo_infoCard_subtext: {
          color: "#606060",
          fontSize: 14,
          fontWeight: 200,
          mt: 1
        },
        myAccount_profileInfo_infoCard_info: {
          fontSize: 10,
          lineHeight: 3,
          color: "editProfileInfoLabelColor"
        },
        myAccount_profileInfo_infoCard_terms: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "themeGrey"
        },
        myAccount_profileInfo_infoCard_terms2: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "backLinkColor"
        },
        myAccount_profileInfo_infoList_emailLabel: {
          color: "#808080",
          fontSize: 14,
          mb: 1
        },
        myAccount_profileInfo_infoList_maskedEmail: {
          color: "themeGrey",
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_profileInfo_infoList_emailChange: {
          fontSize: 12,
          color: "secondary.300"
        },
        myAccount_profileInfo_infoList_changeOperation: {
          color: {
            base: "themeGrey",
            md: "#8F278A"
          },
          letterSpacing: -0.3,
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_orderHistoryItem_orderNumber: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "#303030"
        },
        myAccount_orderHistoryItem_orderPrice: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "secondary200Mobile"
        },
        myAccount_orderHistoryItem_pickpDate: {
          _web: {
            fontSize: {
              base: "12px",
              md: "13px"
            },
            fontWeight: 200,
            color: {
              base: "#606060",
              md: "#303030"
            }
          },
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4
        },
        myAccount_orderHistoryItem_orderTitle: {
          fontSize: 14,
          fontWeight: "200",
          lineHeight: 4,
          noOfLines: 2
        },
        myAccount_edit_fileds_sheet_title: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_preferred_loc_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400,
          mb: 6
        },
        myAccount_preferred_loc_card_title: {
          fontSize: 12,
          color: "#737373",
          fontWeight: 200,
          mb: 2
        },
        myAccount_paymentOptions_title: {
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: "-0.3",
          marginLeft: 5,
          marginTop: 6,
          marginBottom: 3
        },
        myAccount_paymentOptions_tapOnCard: {
          textAlign: "center",
          fontSize: 14,
          lineHeight: 5,
          fontWeight: 400
        },
        myAccount_paymentOptions_noSavedCards_message: {
          mt: 32,
          color: "grey300",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            mt: {
              base: 32,
              md: 8
            },
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_noSavedGiftCards_message: {
          color: "#8E8E8E",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            mt: {
              base: 32,
              md: 0
            },
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_noSavedCreditCards_message: {
          color: "#8E8E8E",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_giftCards_addNew: {
          fontSize: 12,
          color: "primary.100"
        },
        myAccount_paymentOptions_giftCards_addLimitMessage: {
          fontWeight: 200,
          color: "#606060",
          textAlign: "center"
        },
        myAccount_paymentOptions_giftCards_AddCTAText: {
          fontSize: 14,
          lineHeight: 5,
          fontWeight: 300,
          color: "#fff"
        },
        myAccount_paymentOptions_gc_maskedNumber: {
          fontSize: 11,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_number: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_availableBalText: {
          fontSize: 8,
          pb: 0,
          color: "mobilePaymentsCardTextColor",
          _ios: {
            pb: 1
          }
        },
        myAccount_paymentOptions_gc_availableBal: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_label: {
          fontSize: 8,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_titleLabel: {
          pl: 7,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          flex: 1
        },
        myAccount_order_history_order_details_modal_header_title: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 300
        },
        myAccount_order_history_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400
        },
        myAccount_card_details_error_text: {
          color: "red.400",
          fontWeight: 400,
          fontSize: ["xs"],
          mt: 2
        },
        myAccount_consent_area_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor",
          marginRight: 4,
          maxWidth: 72,
          accessible: false,
          _web: {
            maxWidth: "100%"
          }
        },
        myAccount_consent_area_default_card_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor"
        },
        myAccount_add_gift_card_action_sheet_check_balance_text: {
          mt: 3,
          mb: 3.5,
          fontSize: 16,
          lineHeight: 5,
          color: "secondary.300",
          textAlign: "center",
          _web: {
            mt: {
              base: 2.5,
              md: 2.5
            },
            mb: {
              base: 2.5,
              md: 2.5
            }
          },
          fontWeight: 300
        },
        myAccount_add_gift_card_action_sheet_available_balance_text: {
          fontWeight: 400,
          color: "themeGrey",
          py: 2,
          textAlign: "center",
          mt: 5
        },
        myAccount_add_gift_card_action_sheet_error_message: {
          marginY: 3,
          fontWeight: 300,
          fontSize: 12,
          color: "addCardModalValidWarningTextColor",
          lineHeight: 4
        },
        myAccount_ad_gift_card_action_sheet_save_for_future_use_text: {
          pt: 1,
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "saveCardCheckbox"
        },
        myAccount_paymentOptions_gcl_number: {
          fontSize: 16,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_AvailableBal_label: {
          fontSize: 17,
          lineHeight: 7,
          pb: 0,
          _ios: {
            pb: 1
          },
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_bal: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_label: {
          fontSize: 15,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_AddGC_AS_AddText: {
          marginTop: 3.5,
          marginBottom: 3.5,
          fontSize: 18,
          lineHeight: 6,
          textAlign: "center",
          color: "saveCardAddButtonTextColor",
          _web: {
            mt: {
              base: 3,
              md: 3
            },
            mb: {
              base: 3,
              md: 2
            }
          }
        },
        myAccount_paymentOptions_showCC_BS_title: {
          textAlign: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          fontSize: 20,
          lineHeight: 6,
          _web: {
            flex: 1
          }
        },
        myAccount_updateQuestions_selectedText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "securityQuestionTextColor"
        },
        myAccount_updateQuestions_asterisk: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "secondary.300"
        },
        myAccount_updateQuestions_options: {
          fontSize: 14,
          color: "grey300",
          lineHeight: 4,
          fontWeight: 400
        },
        empty_screen_description: {
          _ios: {
            color: "themeGrey"
          },
          _android: {
            color: "themeGrey"
          },
          fontSize: {
            base: "14px",
            md: "16px"
          },
          fontWeight: {
            base: 300
          },
          textAlign: "center",
          color: "reorderInfoTextColor"
        },
        empty_screen_order_togo_btn_text: {
          _ios: {
            paddingY: 1
          },
          _android: {
            paddingY: 1
          },
          _web: {
            fontWeight: "500"
          },
          color: "white"
        },
        order_history_details_text: {
          ml: 1,
          mr: 2,
          lineHeight: 6,
          fontSize: 16,
          fontWeight: 300,
          color: "orderHistoryDetailsText",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          }
        },
        order_history_details_order_from_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "orderHistoryOrderFrom"
        },
        order_history_details_restaurant_name_text: {
          fontWeight: 400,
          fontSize: 12,
          lineHeight: 4,
          letterSpacing: -0.6,
          mt: 1
        },
        order_history_details_restaurant_address_text: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "orderHistoryDetailsAddress"
        },
        order_history_details_pickup_time_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "orderHistoryOrderFrom",
          mb: 1
        },
        order_history_details_pickup_time_desc: {
          mt: 0,
          fontSize: 13,
          lineHeight: 4,
          fontWeight: 400,
          color: "orderHistoryDetailsAddress"
        },
        order_history_details_your_order_text: {
          mt: 2,
          ml: 5,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          mb: 2
        },
        myAccount_userInfoCard_name: {
          lineHeight: 6,
          fontSize: 20,
          noOfLines: 3
        },
        myAccount_userInfoCard_email: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4
        },
        myAccount_userInfoCard_mobileNumber: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4,
          paddingTop: 0.5
        },
        myAccount_userInfoCard_editLabel: {
          color: "secondary.300",
          fontSize: 12,
          lineHeight: 4
        },
        myAccount_fallBackPictureText: {
          fontSize: 26,
          color: "secondary200Mobile"
        },
        myAccount_editFieldsConfirmationModalBodyText: {
          fontWeight: 100,
          fontSize: 18
        },
        // My Account ends

        /* RESERVATION */
        reservationListHeaderUpcoming: {
          fontSize: 16,
          fontWeight: 600,
          color: "#303030",
          pb: 4
        },
        reservationCancelSuccessHeader: {
          fontSize: 20,
          fontWeight: 500,
          color: "#303030",
          textAlign: "center"
        },
        reservationPoliteDressText: {
          fontSize: 14,
          fontWeight: 300,
          pt: 2
        },
        reservationMakeNewReservationCTA: {
          fontWeight: 500,
          fontSize: 20,
          color: "primary.100",
          textAlign: "center"
        },
        reservationCancelSuccessBody: {
          fontSize: 16,
          fontWeight: 200,
          color: "#606060",
          lineHeight: 5,
          textAlign: "center"
        },
        joinWaitlist_Header_Logout: function joinWaitlist_Header_Logout() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "primary.100"
          };
        },
        joinWaitlist_Header_MyAcc: function joinWaitlist_Header_MyAcc() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "primary.100"
          };
        },
        joinWaitlist_Header_MyAcc_Mobile: function joinWaitlist_Header_MyAcc_Mobile() {
          return {
            fontSize: 8,
            mt: 1,
            color: "primary.100"
          };
        },
        reservtionPredferedLocationCardAddress: {
          fontWeight: "300",
          fontSize: 12,
          lineHeight: 4
        },
        reservationConfirmationDateTimeSizeText: {
          fontWeight: 500,
          lineHeight: 5,
          fontSize: 14
        },
        reservationConfirmationRestaurantName: {
          fontSize: {
            base: 14,
            md: 16
          },
          fontWeight: 400,
          lineHeight: 5,
          flexWrap: "wrap"
        },
        reservationConfirmationLocationAddress: {
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 200,
          lineHeight: 5,
          flexWrap: "wrap"
        },
        reservationConfirmationDirectionsText: {
          fontWeight: 500
        },
        reservationListCardDirections: {
          color: "primary.100",
          fontSize: 14,
          fontWeight: 500
        },
        reservationsSelectFromAvailableSlotsTitle: {
          fontWeight: 600,
          color: "#303030"
        },
        reservationsReviewReservationsText: {
          fontWeight: 600
        },
        reservationsChangeLocationChangeText: {
          color: "primary.100",
          textTransform: "uppercase",
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 400
        },
        reservationThankyouConfirmationText: {
          fontSize: 18,
          fontWeight: 600,
          pb: 2,
          color: "primary.100",
          textAlign: "center"
        },
        reservationThankyouConfirmationSubText: {
          fontSize: 16,
          fontWeight: 600,
          textAlign: "center"
        },
        reservationSelectGuestText: {
          fontSize: 14,
          fontWeight: 200
        },
        reservationLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 600,
          color: {
            base: "#020001",
            md: "#303030"
          }
        },
        reservationLocationCardAddress: {
          lineHeight: 5,
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 200,
          color: "#020001"
        },
        reservationLocationModalHeaderText: {
          color: "#282C25",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        reservationFilterStateHeading: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 300,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        reservationTabsText: function reservationTabsText(_ref29) {
          var isActive = _ref29.isActive;
          return {
            textAlign: "center",
            color: isActive ? "#000" : "#FFF",
            fontSize: {
              base: 18,
              md: 20
            },
            fontWeight: 300,
            mt: 2
          };
        },
        reservationDetailsHeaderText: {
          px: 5,
          fontSize: {
            base: 16,
            md: 20
          },
          fontWeight: 300,
          lineHeight: 5,
          color: "grey300"
        },
        reservationPickerTopLabelText: {
          pb: 2,
          noOfLines: 1,
          fontSize: {
            base: 12,
            md: 14
          },
          color: {
            base: "#707070",
            md: "#606060"
          },
          _web: {
            pb: 0,
            mb: {
              base: 1,
              md: 0
            }
          }
        },
        reservationPickerLabelText: {
          pt: 2,
          noOfLines: 1,
          fontSize: 14,
          color: {
            base: "#353D4C",
            md: "#000"
          },
          _web: {
            pt: 0,
            mt: 1,
            width: "min-content",
            borderBottomWidth: 1
          }
        },
        reservationAddDetailsHeading: {
          px: 5,
          fontSize: {
            base: 16,
            md: 20
          },
          fontWeight: 300,
          lineHeight: 5,
          color: "#303030"
        },

        /* RESERVATION */
        advanceOrderMessageText: {
          fontWeight: 400,
          color: "#FF0000",
          fontSize: [12, 12, 14, 14, 14]
        },
        noCheckHeaderText: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 22,
          lineHeight: 26,
          color: "#303030"
        },
        errorDialogBoxTitle: {
          fontSize: "md",
          fontWeight: 500
        },
        OnboardingScreenTitleTextColor: {
          color: "#222828",
          fontWeight: "500"
        },
        //checkDetails Start
        cdHeaderText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdCheckItemsText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdBillingTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdTableDetailTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        //checkDetails End
        // checkSummaryStart
        quantityNumber: {
          paddingY: 1
        },
        paymentCompleteText: {
          fontSize: 18,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        checkSummaryTitle: {
          fontSize: 22,
          color: "secondary200Mobile",
          fontWeight: 500,
          fontFamily: "headingSecondary",
          lineHeight: 6
        },
        checkSummaryBodyText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        checkSummaryEmailText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 5,
          color: "#020001"
        },
        checkSummarySurveyText: {
          color: "secondary200Mobile",
          fontWeight: 500,
          lineHeight: 6,
          fontSize: 14
        },
        checkSummaryPriceText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        totalPriceText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        preAppliedDeductionPrice: {
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 5
        },
        // checkSummaryEnds
        paymentTileTitle: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "orderTotalTextColor"
        },
        paymentTilePrice: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "#55111E"
        },
        paymentMethodsText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        OrderInfoBannerCartIconText: {
          pt: 1
        },
        LoginHeaderText: {
          pt: 1
        },
        checkoutTopLabelText: {
          pt: 1
        },
        emailReceiptText: {
          fontSize: 20,
          lineHeight: 5,
          fontWeight: 500,
          fontFamily: "headingSecondary",
          color: "#55111E"
        },
        addGratuityText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "#303030"
        },
        camAccessText: {
          color: "#737373",
          lineHeight: 6,
          fontSize: 14
        },
        camAccessLinkText: {
          textDecoration: "underline",
          color: "primary.100"
        },
        gratuityTipNumbers: {
          fontSize: 10,
          color: "themeGrey",
          lineHeight: 3
        },
        snackBarText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary200Mobile"
        },
        snackBarPrice: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary.300"
        },
        stepsToMobilePayHeader: {
          fontFamily: "headingSecondary",
          fontSize: 28,
          color: "#303030",
          textTransform: "uppercase",
          ml: 5
        },
        mobilePayStepsHeading: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 16,
          mt: 4,
          ml: 5,
          color: "#782434",
          _web: {
            letterSpacing: "-0.29px"
          },
          letterSpacing: "-0.29"
        },
        mobilePayStepsBody: {
          fontFamily: "body",
          fontWeight: 200,
          fontSize: 11,
          color: "#303030"
        },
        mobilePayVisitLink: {
          display: "block",
          position: "absolute",
          fontSize: 12,
          lineHeight: 12,
          opacity: "0.4",
          color: "#1B1B1B",
          bottom: "42%",
          left: {
            base: "36%",
            sm: "36%",
            md: "42%",
            lg: "45%"
          },
          textAlign: "center"
        },
        waitlistRestaurantInfoBoxTitle: {
          fontSize: 14,
          fontFamily: "body",
          fontWeight: 400,
          color: "waitlistRestaurantInfoBoxText"
        },
        waitlistRestaurantInfoBoxBody: {
          lineHeight: 16,
          fontFamily: "body",
          fontSize: 13,
          fontWeight: 200,
          color: "waitlistRestaurantInfoBoxText"
        },
        wcacPrimaryBtnText: {
          fontSize: 16,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase"
        },
        wcacSecondaryBtnText: {
          fontSize: 16,
          fontWeight: 400,
          color: "#A2402A",
          textTransform: "uppercase"
        },
        remoteCheckinNoteText: {
          _android: {
            lineHeight: 5
          },
          _ios: {
            lineHeight: 5
          },
          mt: 3,
          _web: {
            fontSize: "14px"
          },
          fontSize: "sm",
          fontWeight: 200,
          textAlign: "center"
        },
        successDialogTitleText: {
          lineHeight: 6
        },
        successDialogDescText: {
          _ios: {
            lineHeight: 6
          },
          _android: {
            lineHeight: 6
          }
        },
        orderConfirmationMobileNumberText: {
          lineHeight: 4,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        //JWC STARTS
        jwcLeaveTheLineCancelBtn: {
          fontSize: 16,
          fontWeight: 400,
          color: "primary.100"
        },
        jwcLeaveTheLineContinueBtn: {
          fontSize: 16,
          fontWeight: 400
        },
        jwcLeaveTheLineModalTitle: {
          fontSize: 16,
          color: "#303030",
          fontFamily: "headingSecondary",
          textTransform: "uppercase"
        },
        jwcLeaveTheLineModalBody: {
          fontWeight: 300,
          fontSize: {
            base: 18,
            lg: 14
          },
          lineHeight: {
            base: 25,
            lg: 18
          },
          color: {
            base: "#606060",
            lg: "#020001"
          }
        },
        jwcEstWaitTimePrefix: {
          textAlign: "center",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 6,
          color: "#54301A"
        },
        jwcEstWaitTime: {
          lineHeight: 10,
          fontWeight: 400,
          textAlign: "center",
          fontSize: 32,
          color: "#54301A"
        },
        jwcRestDetails: {
          color: "#80603D",
          lineHeight: 4,
          fontSize: 12,
          fontWeight: 300
        },
        jwcRestName: {
          color: "#80603D",
          fontSize: 15,
          fontWeight: 400
        },
        jwcHowItWorksText: {
          fontSize: 14,
          fontWeight: 300,
          color: "white",
          textAlign: "center"
        },
        jwcOrderWhileYouWaitText: {
          textAlign: "center",
          color: {
            base: "white",
            lg: "#A2402A"
          },
          fontSize: 16,
          fontWeight: 400
        },
        qualityStoryCtaText: {
          textAlign: "center",
          color: {
            base: "#8F278A",
            lg: "#8F278A"
          },
          fontSize: 16,
          fontWeight: 400
        },
        jwcOrderAheadText: {
          fontSize: {
            base: 22,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        qualityStoryDescText: {
          fontSize: {
            base: 21,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        jwcHeaderDirectionsText: {
          color: "#A2402A",
          fontSize: 14
        },
        jwcHeaderLocationName: {
          color: "#303030",
          fontSize: 16,
          fontWeight: 300
        },
        jwcViewPdfMenu: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcLeaveTheLine: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcWaitTimeVary: {
          textAlign: "center",
          fontWeight: 300,
          fontSize: 18,
          color: " #2A2C25",
          lineHeight: 24
        },
        jwcPartySizeNumber: {
          fontWeight: 400,
          fontSize: 17,
          color: "#54301A"
        },
        jwcPartySize: {
          fontWeight: 300,
          fontSize: 17,
          color: "#54301A"
        },
        jwcTitle: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mt: 6
        },
        jwcTitleText: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mb: 4,
          mx: 1,
          lineHeight: 7,
          _ios: {
            mx: 2
          },
          _android: {
            mx: 2
          }
        },
        waitListFooterText: {
          marginTop: 2,
          fontSize: 14,
          fontWeight: 200,
          maxWidth: 74,
          textAlign: "center",
          color: "#303030"
        },
        fwlvButtonText: {
          fontSize: 14,
          color: "#00A9A1",
          textAlign: "center",
          marginTop: 2,
          textTransform: "capitalize"
        },
        refreshIconText: {
          textTransform: "uppercase",
          fontSize: 12,
          color: "#00A9A1",
          lineHeight: 14
        },
        waitlistCheckbackSoonTitle: {
          color: "#54301A",
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 20
        },
        waitlistCheckbackSoonBody: {
          color: "#606060",
          pt: 4,
          fontWeight: 300,
          fontSize: 16,
          lineHeight: 20
        },
        checkinSuccessNoteTitleText: {
          color: "#FFFFFF",
          pt: 3,
          fontSize: {
            base: 20,
            md: 22
          },
          lineHeight: 22,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        checkinSuccessNoteBodyText: {
          color: "#FFFFFF",
          pt: 3,
          px: 4,
          textAlign: "center",
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        leaveTheLineText: {
          fontWeight: 200,
          fontSize: 14,
          lineHeight: 16
        },
        leaveTheLineLinkText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16,
          color: "#00A9A1"
        },
        leaveWaitlistErrorModal: {
          fontWeight: 200,
          fontSize: 18,
          lineHeight: 25,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060"
        },
        waitlistErrorTitle: {
          fontWeight: 500,
          fontSize: 24,
          lineHeight: 24,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#2A2C25"
        },
        waitlistErrorBody: {
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 28,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060",
          mt: 2,
          textAlign: "center",
          maxWidth: 253
        },
        waitTimeText: {
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 16,
          mb: 2
        },
        waitTimeMins: {
          fontWeight: 400,
          fontSize: 32,
          lineHeight: 36
        },
        remoteCheckinTitle: {
          color: "#222828",
          fontSize: 22,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3",
          lineHeight: 22,
          fontWeight: 500,
          textAlign: "center"
        },
        remoteCheckinWaitTimePartySizePrefix: {
          fontSize: 14,
          fontWeight: 200,
          lineHeight: 14
        },
        remoteCheckinWaitTimeThankYou: {
          fontSize: 24,
          fontWeight: 600,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3",
          color: "#303030"
        },
        remoteCheckinWaitTimePartySize: {
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 14
        },
        remoteCheckinWaitTimeNote: {
          fontSize: 14,
          fontWeight: 100,
          lineHeight: 4
        },
        remoteCheckinBodyText: {
          fontSize: 16,
          fontWeight: 200,
          fontFamily: "body",
          color: "white"
        },
        remoteCheckinRefreshBtn: {
          color: "remoteCheckinRefreshBtnColor",
          fontSize: 16,
          fontWeight: 300,
          fontFamily: "Brandon",
          marginY: 2,
          marginX: 8
        },
        startingAtPrice: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        startingAtText: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        categoryText: function categoryText(_ref30) {
          var isActive = _ref30.isActive;
          return {
            fontSize: {
              base: "sm",
              md: "sm"
            },
            fontWeight: isActive ? "600" : "200"
          };
        },
        noThanksText: {
          fontFamily: "headingSecondary",
          textDecoration: "underline",
          textDecorationColor: "white",
          textAlign: "center",
          color: "white",
          _web: {
            fontSize: "28px",
            mt: 5
          },
          _ios: {
            mt: 0,
            fontSize: "28px",
            lineHeight: 8
          },
          _android: {
            mt: 0,
            fontSize: "28px",
            lineHeight: 8
          },
          fontSize: "xl"
        },
        youMayLikeText: {
          fontFamily: "headingSecondary",
          _web: {
            fontSize: "28px"
          },
          fontSize: "xl"
        },
        orderTypeText: {
          fontSize: "sm",
          fontWeight: "300"
        },
        globalBannerCareer: function globalBannerCareer() {
          return {
            textTransform: "uppercase",
            fontWeight: 300,
            color: "#fff",
            fontSize: {
              base: "10px",
              md: "10px",
              lg: "13px"
            },
            right: 0
          };
        },
        menuItemNameWeight: function menuItemNameWeight(_ref31) {
          var isFromSmartRecsOrFrequentlyOrdered = _ref31.isFromSmartRecsOrFrequentlyOrdered;
          return {
            fontWeight: 500,
            fontSize: [14, 14, 14, isFromSmartRecsOrFrequentlyOrdered ? 14 : 20]
          };
        },
        listDescriptionText: function listDescriptionText() {
          return {
            _web: {
              fontSize: 14,
              fontWeight: 300,
              fontFamily: "heading"
            }
          };
        },
        categoryFontSize: function categoryFontSize() {
          return {
            fontSize: [28, 28, 40],
            fontWeight: 400,
            fontFamily: "headingSecondary"
          };
        },
        subCategoryFontSize: function subCategoryFontSize() {
          return {
            fontSize: [22, 22, 32],
            fontFamily: "headingSecondary",
            fontWeight: 400
          };
        },
        menuItemCalorieText: {
          fontSize: [12, 12, 14],
          fontWeight: 200,
          pl: 1
        },
        subSubCategoryFontSize: function subSubCategoryFontSize() {
          return {
            fontSize: [18, 18, 28],
            color: "#505050"
          };
        },
        locationText: {
          color: "#00A9A1",
          fontSize: "xs",
          fontFamily: "body"
        },
        phoneNumberText: {
          color: "#00A9A1",
          fontSize: "xs",
          fontFamily: "body"
        },
        btnText: {
          color: "#00A9A1"
        },
        headerText: {
          color: "#00A9A1",
          fontFamily: "headingSecondary"
        },
        menuItemDetailsPropertyAccordionHeading: function menuItemDetailsPropertyAccordionHeading(_ref32) {
          var isMandatory = _ref32.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "32"
              },
              letterSpacing: "-0.3px"
            },
            _android: {
              letterSpacing: 1
            },
            _ios: {
              letterSpacing: 1
            },
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 400,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "uppercase"
          };
        },
        skuMenuItemDetailsPropertyAccordionHeading: function skuMenuItemDetailsPropertyAccordionHeading(_ref33) {
          var isMandatory = _ref33.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "32"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 400,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "uppercase"
          };
        },
        menuItemDetailsQuestionVarient: function menuItemDetailsQuestionVarient(_ref34) {
          var isMobile = _ref34.isMobile;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "md"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 5
            },
            fontWeight: {
              base: 300,
              md: 500
            },
            color: "themeTextColor",
            textTransform: isMobile && "uppercase",
            fontFamily: isMobile ? "headingSecondary" : "body"
          };
        },
        menuItemDetailsIsRequiredMark: function menuItemDetailsIsRequiredMark() {
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            fontWeight: 300,
            color: "white",
            lineHeight: {
              base: 4,
              md: 5
            },
            alignSelf: "center"
          };
        },
        menuItemDetailsPropertyAccordionRightText: function menuItemDetailsPropertyAccordionRightText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            lineHeight: 5,
            color: "white",
            _web: {
              letterSpacing: "-0.3 px"
            },
            letterSpacing: "-0.3"
          };
        },
        menuDetailPropertyAccordionDescription: function menuDetailPropertyAccordionDescription(_ref35) {
          var isMandatory = _ref35.isMandatory,
              isDefaultExpanded = _ref35.isDefaultExpanded;
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            lineHeight: {
              base: 4,
              md: 5
            },
            fontWeight: 300,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            color: isDefaultExpanded ? "white" : "themeTextColor"
          };
        },
        menuDetailErrorText: function menuDetailErrorText() {
          return {
            fontSize: "xs",
            color: "white",
            fontWeight: 400,
            lineHeight: 4
          };
        },
        deliveryErrorText: function deliveryErrorText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            color: "white",
            fontWeight: 300,
            lineHeight: 4
          };
        },
        menuItemInfoName: function menuItemInfoName() {
          return {
            mb: 2,
            _web: {
              fontSize: ["xl", "xl", "32px"]
            },
            fontSize: ["xl", "xl", 10],
            fontWeight: 500
          };
        },
        addToCardButtonPriceText: function addToCardButtonPriceText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "18px",
                md: "32px"
              },
              position: "relative",
              top: {
                lg: "4px"
              }
            },
            fontWeight: 300,
            fontFamily: "headingSecondary",
            _ios: {
              fontSize: 18
            },
            _android: {
              fontSize: 18
            }
          };
        },
        addToCardButtonText: function addToCardButtonText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "18px",
                md: "32px"
              },
              position: "relative",
              top: {
                lg: "4px"
              }
            },
            fontWeight: 300,
            fontFamily: "headingSecondary",
            _ios: {
              fontSize: 18
            },
            _android: {
              fontSize: 18
            }
          };
        },
        nutritinalInfo: function nutritinalInfo() {
          return {
            fontSize: ["sm", "sm", "lg"],
            fontWeight: 500
          };
        },
        confirmPickupDetailsHeaderText: function confirmPickupDetailsHeaderText() {
          return {
            fontSize: 26,
            fontWeight: 300,
            fontFamily: "headingSecondary",
            color: "#00A9A1",
            lineHeight: 8,
            textTransform: "uppercase"
          };
        },
        confirmPickupDetailsRestaurant: function confirmPickupDetailsRestaurant() {
          return {
            fontSize: 16,
            lineHeight: 5,
            fontWeight: 500,
            color: "#505050"
          };
        },
        confirmPickupDetailsText: function confirmPickupDetailsText() {
          return {
            color: "orderConfirmationTextColor",
            fontWeight: 300,
            lineHeight: 4,
            fontSize: 14,
            _web: {
              letterSpacing: "2px"
            },
            letterSpacing: 1
          };
        },
        mobilePayHeaderBtnText: function mobilePayHeaderBtnText() {
          return {
            fontSize: {
              base: 14,
              md: 18
            },
            fontWeight: 400,
            color: "secondary.300"
          };
        },
        confirmPickupDetailsChangeBtnText: function confirmPickupDetailsChangeBtnText() {
          return {
            fontSize: 20,
            fontWeight: 300,
            color: "#8F278A",
            fontFamily: "headingSecondary",
            _web: {
              position: "relative",
              top: {
                lg: "2px"
              }
            }
          };
        },
        cartItemMenuName: function cartItemMenuName() {
          return {
            fontSize: 18,
            lineHeight: 5,
            _web: {
              letterSpacing: "-0.3px",
              width: {
                base: "164px"
              }
            },
            letterSpacing: "-0.3",
            width: {
              base: 40
            },
            fontWeight: 600,
            color: "menuDetailItemNameColor"
          };
        },
        cartItemPrice: function cartItemPrice() {
          return {
            fontSize: 16
          };
        },
        cartMessageText: function cartMessageText() {
          return {
            fontWeight: 300,
            _web: {
              fontSize: 14
            },
            fontSize: 11
          };
        },
        checkoutNoOfItems: function checkoutNoOfItems() {
          return {
            fontSize: "xs"
          };
        },
        cartItemMenuPropertyName: function cartItemMenuPropertyName() {
          return {
            fontSize: 14,
            lineHeight: 5,
            fontWeight: 500,
            _web: {
              letterSpacing: "-0.3px",
              width: "176px"
            },
            letterSpacing: "-0.3",
            width: 40,
            noOfLines: 3,
            color: "menuDetailItemNameColor"
          };
        },
        orderSettingsText: function orderSettingsText() {
          return {
            fontWeight: "400",
            fontSize: "sm"
          };
        },
        menuItemInfoPrice: function menuItemInfoPrice() {
          return {
            _web: {
              fontSize: {
                base: "13px",
                md: "18px"
              }
            },
            // fontSize: { base: 3, md: 4 },
            fontWeight: "400"
          };
        },
        menuItemInfoPriceStartingAt: function menuItemInfoPriceStartingAt() {
          return {
            _web: {
              fontSize: {
                base: "14px",
                md: "18px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: "300"
          };
        },
        menuItemInfoCalorie: function menuItemInfoCalorie() {
          return {
            _web: {
              fontSize: {
                base: "13px",
                md: "14px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: "400"
          };
        },
        skuSelectorItemPriceText: function skuSelectorItemPriceText(_ref36) {
          var isUnavailable = _ref36.isUnavailable;
          return {
            fontWeight: 600,
            fontSize: {
              base: 14,
              md: 14
            },
            color: isUnavailable ? "#606060" : "#505050"
          };
        },
        skuSelectorItemName: function skuSelectorItemName(_ref37) {
          var isUnavailable = _ref37.isUnavailable;
          return {
            fontWeight: 300,
            fontSize: {
              base: 15,
              md: 18
            },
            color: isUnavailable ? "#606060" : "#505050"
          };
        },
        mobileAuthHeaderText: function mobileAuthHeaderText() {
          return {
            fontWeight: 300,
            fontSize: 24,
            color: "#505050"
          };
        },
        menuItemPrice: function menuItemPrice() {
          return {
            fontSize: [12, 12, 14],
            fontWeight: 600,
            pr: 1
          };
        },
        temperatureSelectLabel: function temperatureSelectLabel() {
          return {
            color: "black",
            fontSize: "md",
            fontFamily: "headingSecondary",
            textTransform: "uppercase"
          };
        },
        cartHeaderOrderType: function cartHeaderOrderType() {
          return {
            fontSize: 16,
            lineHeight: 5,
            fontWeight: 400,
            color: "cartHeaderOrderType",
            textDecoration: "underline",
            textDecorationColor: "cartHeaderOrderType"
          };
        },
        cartHeaderLocationName: function cartHeaderLocationName() {
          return {
            fontSize: 16,
            lineHeight: 5,
            fontWeight: 500,
            color: "cartHeaderLocationName",
            textDecoration: "underline",
            textDecorationColor: "cartHeaderLocationName"
          };
        },
        backToMenu: {
          fontFamily: "headingSecondary",
          fontSize: "xl",
          lineHeight: 6
        },
        emptyCartText: {
          fontSize: "sm",
          fontWeight: 300,
          lineHeight: 4
        },
        allLocationsSelectHeading: {
          color: "#ffff",
          fontSize: 28,
          fontWeight: 600
        },
        allLocationsSelectText: {
          color: "#ffff",
          fontSize: 20,
          fontWeight: 400
        },
        allLocationsText: {
          fontSize: 20,
          color: "#505050",
          fontWeight: 600
        },
        allLocationsLengthText: {
          fontSize: 16,
          color: "#505050",
          fontWeight: 300
        },
        cartItemCancelText: {
          fontSize: 16,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "secondary.300",
          fontWeight: 300,
          fontFamily: "headingSecondary",
          _web: {
            position: "relative",
            top: {
              lg: "2px"
            }
          },
          _ios: {
            lineHeight: 5
          },
          _android: {
            lineHeight: 5
          }
        },
        checkoutText: {
          fontSize: 22,
          lineHeight: 6,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase",
          fontFamily: "headingSecondary",
          _web: {
            position: "relative",
            top: {
              lg: "2px"
            }
          }
        },
        addMoreItemsText: {
          fontSize: 22,
          fontWeight: 400,
          lineHeight: 6,
          textTransform: "uppercase",
          color: "secondary.300",
          fontFamily: "headingSecondary",
          _web: {
            position: "relative",
            top: {
              lg: "4px"
            }
          }
        },
        checkoutPriceText: {
          fontSize: 26,
          py: 1,
          lineHeight: 6,
          fontWeight: 400,
          color: "white",
          fontFamily: "headingSecondary"
        },
        addBtnText: function addBtnText(_ref38) {
          var addButtonText = _ref38.addButtonText;
          return {
            color: "white",
            textTransform: "uppercase",
            fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 14 : 22,
            overflowWrap: "break-word",
            maxWidth: {
              base: "70px",
              md: "110px"
            },
            textAlign: "center",
            marginBottom: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "2px" : 0,
            fontFamily: "headingSecondary",
            lineHeight: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 14 : 22,
            _ios: {
              marginTop: 1.5
            },
            _android: {
              marginTop: 1.5
            }
          };
        },
        menuListTextCTA: {
          fontWeight: 400,
          fontSize: [10, 10, 14, 14, 14]
        },
        cartItemRemoveText: {
          fontSize: 16,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "white",
          fontWeight: 300,
          fontFamily: "headingSecondary",
          _web: {
            position: "relative",
            top: {
              lg: "2px"
            }
          },
          _ios: {
            lineHeight: 5
          },
          _android: {
            lineHeight: 5
          }
        },
        reorderAddButtonText: {
          fontSize: 22,
          color: "reOrderAddBtnBorder",
          fontWeight: 400,
          fontFamily: "headingSecondary",
          _web: {
            position: "relative",
            top: {
              lg: "4px"
            }
          }
        },
        pdfMenuButtonText: {
          my: 1,
          _web: {
            mt: 0
          }
        },
        locationListRestaurantName: function locationListRestaurantName(_ref39) {
          var isFromLocationSearch = _ref39.isFromLocationSearch;
          return {
            fontWeight: 400,
            _web: {
              fontSize: isFromLocationSearch ? {
                base: "14px",
                md: "18px"
              } : "15px"
            },
            lineHeight: 18,
            textAlign: "left"
          };
        },
        locationListRestaurantDetails: function locationListRestaurantDetails(_ref40) {
          var isFromLocationSearch = _ref40.isFromLocationSearch;
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            _web: {
              width: isFromLocationSearch ? "100%" : "70%",
              lineHeight: "18px"
            },
            fontWeight: 300,
            lineHeight: 14
          };
        },
        locationListResturantAddressSecondLine: {
          marginTop: 1,
          marginBottom: 0.5
        },
        asapText: {
          _web: {
            position: "relative",
            top: {
              lg: "2px"
            }
          }
        },
        confirmAndAddToCart: {
          textTransform: "uppercase",
          color: "white",
          fontWeight: 600,
          _web: {
            position: "relative",
            top: {
              lg: "2px"
            }
          }
        },
        confirmationPickupRestName: {
          fontSize: {
            base: 12,
            lg: 16
          },
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          },
          _web: {
            lineHeight: 3
          }
        },
        confirmationPickupRestNameTitle: {
          fontSize: {
            base: 12,
            lg: 16
          },
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          },
          _web: {
            lineHeight: 3
          }
        },
        confirmationPickupResAdd1: {
          lineHeight: 5,
          marginBottom: 1,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationPickupResAdd2: {
          lineHeight: 5,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationSurveyHeader: function confirmationSurveyHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationSurveyText: function confirmationSurveyText() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        // eslint-disable-next-line @typescript-eslint/
        confirmationEclubHeader: function confirmationEclubHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationEclubEmail: function confirmationEclubEmail() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationEclubChangeEmail: function confirmationEclubChangeEmail() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationEclubCheckboxText: function confirmationEclubCheckboxText() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationAccountHeader: function confirmationAccountHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            },
            fontWeight: "400"
          };
        },
        confirmationAccountEmail: function confirmationAccountEmail() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationPickupMyOrderHeader: function confirmationPickupMyOrderHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsHeader: function confirmationPickupDetailsHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsSubTitle: function confirmationPickupDetailsSubTitle() {
          return {
            color: "confirmationAccentLight",
            fontSize: {
              base: 12,
              lg: 13
            }
          };
        },
        confirmationThankYouTitle: function confirmationThankYouTitle() {
          return {
            color: "#020001",
            fontSize: {
              base: 18,
              lg: 32
            },
            fontWeight: "400"
          };
        },
        confirmationThankYouMailText: function confirmationThankYouMailText() {
          return {
            color: "#303030",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "300"
          };
        },
        confirmationThankYouMail: function confirmationThankYouMail() {
          return {
            color: "#020001",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "500"
          };
        },
        confirmationOrderNumber: function confirmationOrderNumber() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "orderConfirmationCustomerEmail",
            fontWeight: "400"
          };
        },
        confirmationThankYouDetailTitle: function confirmationThankYouDetailTitle() {
          return {
            color: "confirmationAccentDark",
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: "400",
              lg: "800"
            }
          };
        },
        confirmationHowToText: function confirmationHowToText() {
          return {
            fontSize: {
              base: 12,
              lg: 14
            },
            color: "confirmationAccentDark"
          };
        },
        confirmationMarketingTitle: function confirmationMarketingTitle() {
          return {
            color: "#4D2C42",
            fontWeight: 400,
            fontSize: {
              base: 12,
              lg: 14
            }
          };
        },
        confirmationMarketingSubtitle: function confirmationMarketingSubtitle() {
          return {
            color: "confirmationAccent",
            fontWeight: "300",
            fontSize: 12
          };
        },
        confirmationOrderTotalItem: function confirmationOrderTotalItem() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationOrderTotalLabel: function confirmationOrderTotalLabel() {
          return {
            fontSize: {
              base: 18,
              lg: 23
            },
            color: "black",
            fontWeight: 600
          };
        },
        confirmationOrderTotal: function confirmationOrderTotal() {
          return {
            fontSize: {
              base: 18,
              lg: 23
            },
            color: "#303030",
            fontWeight: 600
          };
        },
        confirmationPaymentDetailsTitle: function confirmationPaymentDetailsTitle() {
          return {
            color: "black",
            fontSize: {
              base: 16,
              lg: 18
            }
          };
        },
        confirmationSpecialInstructionTitle: function confirmationSpecialInstructionTitle() {
          return {
            fontSize: {
              base: 12,
              md: 18
            }
          };
        },
        confirmationSpecialInstructionSubTitle: function confirmationSpecialInstructionSubTitle() {
          return {
            fontSize: {
              base: 12,
              md: 16
            }
          };
        },
        confirmationCardChargeInfo: function confirmationCardChargeInfo() {
          return {
            fontSize: {
              base: 12,
              lg: 16
            }
          };
        },
        confirmationChangesHeader: function confirmationChangesHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        //OC AddressAndTime variants start
        confirmationPickupRestaurantTitle: function confirmationPickupRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationPickupDateTimeTitle: function confirmationPickupDateTimeTitle() {
          return {
            fontWeight: "300",
            _ios: {
              py: 1
            },
            _android: {
              py: 1
            },
            marginBottom: 1.5,
            fontSize: {
              base: 15,
              lg: 14
            }
          };
        },
        confirmationPickupDateTimeValue: function confirmationPickupDateTimeValue() {
          return {
            fontSize: {
              base: 15,
              lg: 16
            },
            letterSpacing: -0.4,
            fontWeight: "400",
            color: "pickupRestaurantName",
            marginBottom: 1
          };
        },
        confirmationPickupPersonDetails: function confirmationPickupPersonDetails() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            textTransform: "capitalize",
            lineHeight: 4,
            fontWeight: "400",
            letterSpacing: -0.3
          };
        },
        confirmationDeliveryAddressTitle: function confirmationDeliveryAddressTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryRestaurantTitle: function confirmationDeliveryRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryDateTimeTitle: function confirmationDeliveryDateTimeTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryGuestsTitle: function confirmationDeliveryGuestsTitle() {
          return {
            fontWeight: "300"
          };
        },
        //OC AddressAndTime variants end
        orderTrackingCallHelpText: {
          fontSize: "sm",
          fontWeight: 400,
          lineHeight: 5
        },
        orderStatusTrackingTitle: function orderStatusTrackingTitle() {
          return {
            color: "#00A9A1",
            fontWeight: 400,
            fontSize: "xl",
            lineHeight: 6
          };
        },
        orderStatusTitle: function orderStatusTitle() {
          return {
            fontSize: "sm",
            fontWeight: 400,
            lineHeight: 6,
            color: "orderStatusText"
          };
        },
        orderStatusSubText: function orderStatusSubText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusTime: function orderStatusTime() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusPayNowButtonText: function orderStatusPayNowButtonText() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 500,
            color: "white"
          };
        },
        orderStatusCurbsideCheckInButtonPrimary: function orderStatusCurbsideCheckInButtonPrimary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInPrimary"
          };
        },
        orderStatusCurbsideCheckInButtonSecondary: function orderStatusCurbsideCheckInButtonSecondary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInSecondary"
          };
        },
        orderStatusDeatilsTitle: function orderStatusDeatilsTitle() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "#464838",
            marginBottom: 3.5
          };
        },
        otCurbsideVehicleDetailsTitle: function otCurbsideVehicleDetailsTitle() {
          return {
            fontSize: "xs",
            lineHeight: 3,
            fontWeight: 300,
            color: "#606060",
            marginBottom: 1
          };
        },
        otCurbsideVehicleDetails: function otCurbsideVehicleDetails() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            textTransform: "capitalize"
          };
        },
        refreshButtonText: function refreshButtonText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        autoRefreshText: function autoRefreshText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        orderTrackingLocationTimeSectionText: {
          ml: 2,
          fontSize: "sm",
          lineHeight: 6,
          fontWeight: 400
        },
        waitlistLocationShare: {
          fontSize: 12,
          fontWeight: 400,
          color: "#00A9A1",
          textTransform: "uppercase",
          fontFamily: "body"
        },
        waitlistBannerHeaderText: {
          fontSize: 15,
          fontWeight: 600,
          color: "white"
        },
        waitlistLocationName: {
          fontSize: 14,
          color: "#303030",
          fontWeight: 200,
          fontFamily: "body"
        },
        waitlistBannerText: {
          fontSize: 14,
          fontWeight: 100,
          color: "white",
          lineHeight: 18,
          fontFamily: "body"
        },
        waitlistTableHeaderText: {
          fontSize: {
            base: 12,
            md: 12,
            lg: 14
          },
          color: "#303030",
          fontWeight: 400,
          py: 4,
          textAlign: "center",
          fontFamily: "NanumGothic"
        },
        waitlistTableText: {
          fontSize: {
            base: 16,
            md: 16,
            lg: 18
          },
          color: "#303030",
          fontWeight: 200,
          py: 4,
          textAlign: "center",
          fontFamily: "NanumGothic"
        },
        waitlistTableNotUserName: {
          fontSize: 18,
          color: "#303030",
          fontWeight: 300,
          my: 4,
          textAlign: "center",
          letterSpacing: 1
        },
        waitlistFooterHowItWorks: {
          fontWeight: 400,
          color: "secondary.300",
          textTransform: "uppercase",
          fontFamily: "Teko",
          fontSize: 16
        },
        myLocationsLoginText: {
          fontWeight: 600,
          fontSize: 18,
          color: "secondary.300",
          textTransform: "uppercase"
        },
        refreshWaitlist: {
          fontFamily: "NanumGothic",
          fontWeight: 200
        },
        waitlistDisclaimer: {
          fontFamily: "NanumGothic",
          fontWeight: 300
        },
        waitlistOrder: {
          color: "#8F278A",
          textTransform: "uppercase",
          fontWeight: 300,
          fontFamily: "Teko",
          fontSize: 22
        },
        howItWorksHeader: {
          fontSize: 14,
          fontWeight: 200,
          color: "#020001",
          fontFamily: "Karla"
        },
        howItWorksBanner: {
          fontWeight: 100,
          lineHeight: 18,
          fontSize: 14,
          fontFamily: "Karla"
        },
        howItWorksStepsNumber: {
          fontWeight: 200,
          color: "#2C2A26",
          fontSize: 14,
          fontFamily: "Karla"
        },
        howItWorksSteps: {
          fontWeight: 100,
          color: "#2C2A26",
          fontSize: 14,
          fontFamily: "Karla"
        },
        howItWorksActionButton: {
          fontSize: 16,
          fontFamily: "body",
          fontWeight: 200,
          my: -1
        },
        orderStatusTimeMessage: function orderStatusTimeMessage() {
          return {
            marginTop: 2,
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        checkText: function checkText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            color: "checkText"
          };
        },
        checkAmount: function checkAmount() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "checkText"
          };
        },
        curbsideCheckInAvailableText: function curbsideCheckInAvailableText() {
          return {
            fontSize: "sm",
            lineHeight: 5,
            fontWeight: 300,
            textAlign: "center",
            color: "curbsideCheckInAvailable"
          };
        },
        sectionHeaderText: function sectionHeaderText() {
          return {
            color: "themeTextColor",
            fontWeight: 400
          };
        },
        subSectionHeaderText: function subSectionHeaderText() {
          return {
            color: "themeTextColor",
            fontWeight: 400
          };
        },
        notificationsPopupText: function notificationsPopupText() {
          return {
            color: "menuItemNameColor",
            fontWeight: 400
          };
        },

        /* Restaurant Details Start */
        //Restaurant Info
        restaurantDetails_RestInfo_AddToFavoritesText: function restaurantDetails_RestInfo_AddToFavoritesText() {
          return {
            alignItems: "center",
            color: "restaurantInfoAddToFavouritiesTextColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            ml: "3",
            h: "20px",
            //font specific styles
            pt: "3px"
          };
        },
        restaurantDetails_RestInfo_TitleText: function restaurantDetails_RestInfo_TitleText() {
          return {
            fontWeight: "400",
            color: "restDetailsRestInfoTitleColor",
            mb: {
              base: "2",
              lg: "0"
            },
            fontSize: {
              base: "18px",
              lg: "32px"
            },
            textAlign: {
              base: "center",
              lg: "normal"
            }
          };
        },
        restaurantDetails_RestInfo_OpensText: function restaurantDetails_RestInfo_OpensText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor"
          };
        },
        restaurantDetails_RestInfo_DateText: function restaurantDetails_RestInfo_DateText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor",
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestInfo_AddressText: function restaurantDetails_RestInfo_AddressText() {
          return {
            fontWeight: 300,
            lineHeight: 6,
            px: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            _web: {
              lineHeight: {
                base: 5,
                lg: 7
              },
              my: 4,
              px: 0,
              style: {
                "text-underline-offset": "3px"
              }
            },
            textAlign: {
              base: "center",
              lg: "flex-start"
            },
            w: "100%",
            _ios: {
              flex: 1
            },
            _android: {
              flex: 1
            },
            textDecoration: "underline",
            textDecorationColor: "restaurantInfoAddressTextColor",
            color: "restaurantInfoAddressTextColor"
          };
        },
        restaurantDetails_RestInfo_PhoneNumberText: function restaurantDetails_RestInfo_PhoneNumberText(_ref41) {
          var customMarginHorizontal = _ref41.customMarginHorizontal;
          return {
            _ios: {
              mx: customMarginHorizontal || 0
            },
            _android: {
              mx: customMarginHorizontal || 0
            },
            marginLeft: 1,
            fontWeight: 300,
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "restaurantInfoNumberAndDistanceTextColor"
          };
        },
        restaurantDetails_RestInfo_DistanceText: function restaurantDetails_RestInfo_DistanceText() {
          return {
            fontWeight: "300",
            fontSize: "14px",
            color: "restaurantInfoNumberAndDistanceTextColor"
          };
        },
        restaurantDetails_RestInfo_GetDirectionsText: function restaurantDetails_RestInfo_GetDirectionsText() {
          return {
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            }
          };
        },
        //Restaurant Waitlist
        restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText: function restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText() {
          return {
            mb: "6",
            fontSize: [16],
            fontWeight: 300,
            px: 6,
            maxW: {
              lg: "350",
              xl: "400"
            },
            textAlign: "center",
            mx: "auto",
            color: "#303030"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName: function restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName() {
          return {
            color: "#54301A"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize: function restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize() {
          return {
            fontWeight: "300",
            fontSize: 14,
            color: "#54301A"
          };
        },
        //Restaurant CurrentStatus and Waitlist
        restaurantDetails_RestWaitlist_CurrentStatusText: function restaurantDetails_RestWaitlist_CurrentStatusText() {
          return {
            fontWeight: "300",
            //font specific styles
            color: "#606060",
            pt: "4px",
            fontSize: {
              base: "12",
              lg: "16"
            }
          };
        },
        restaurantDetails_RestWaitlist_AvailabilityText: function restaurantDetails_RestWaitlist_AvailabilityText() {
          return {
            _ios: {
              marginLeft: 4
            },
            _android: {
              marginLeft: 4
            },
            fontSize: "14px",
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            maxWidth: {
              base: 40,
              lg: "none"
            },
            lineHeight: 6
          };
        },
        restaurantDetails_RestWaitlist_JoinWaitlistText: function restaurantDetails_RestWaitlist_JoinWaitlistText(_ref42) {
          var disabled = _ref42.disabled;
          return {
            color: "white",
            fontSize: "16px",
            fontWeight: "400",
            _android: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _ios: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _web: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase",
              fontFamily: "Brandon"
            }
          };
        },
        restaurantDetails_RestWaitlist_EstWaitTimeText: function restaurantDetails_RestWaitlist_EstWaitTimeText() {
          return {
            _android: {
              marginTop: 2.5
            },
            _ios: {
              marginTop: 2.5
            },
            lineHeight: 3,
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            fontSize: "11",
            textAlign: "center",
            maxWidth: 40,
            _web: {
              maxWidth: 32,
              fontSize: "12px",
              marginTop: {
                base: 2,
                lg: 0
              }
            }
          };
        },
        //Restaurant Timings
        restaurantDetails_RestTimings_TitleText: function restaurantDetails_RestTimings_TitleText() {
          return {
            fontSize: {
              base: 20,
              lg: 20
            },
            // mb: 4,
            color: "restaurantHoursTextColor"
          };
        },
        restaurantDetails_RestTimings_SpecialDayTitleText: function restaurantDetails_RestTimings_SpecialDayTitleText() {
          return {
            marginBottom: 3,
            color: "restaurantSpecialDayHeadingTextColor",
            fontSize: "16px",
            textAlign: "center",
            px: "3"
          };
        },
        restaurantDetails_RestTimings_SpecialDayDescText: function restaurantDetails_RestTimings_SpecialDayDescText() {
          return {
            fontSize: "14px",
            fontWeight: "300",
            lineHeight: 20,
            color: "restaurantSpecialDayBodyTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconText: function restaurantDetails_RestTimings_WeekDayIconText() {
          return {
            lineHeight: 5,
            fontSize: "12px",
            textTransform: "capitalize",
            _ios: {
              paddingTop: 0.5,
              paddingLeft: 0.5
            }
          };
        },
        restaurantDetails_RestTimings_FullDayTitleText: function restaurantDetails_RestTimings_FullDayTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingWeekDayTextColor",
            maxWidth: "45%",
            textTransform: "capitalize",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursTitleText: function restaurantDetails_RestTimings_HoursTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingWeekDayTextColor",
            maxWidth: "55%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_FullDayItemText: function restaurantDetails_RestTimings_FullDayItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontFamily: "Now-Regular",
            fontWeight: "200",
            maxWidth: "45%",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursItemText: function restaurantDetails_RestTimings_HoursItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontFamily: "Now-Regular",
            fontWeight: "200",
            maxWidth: "55%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_MessageText: function restaurantDetails_RestTimings_MessageText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "13",
              lg: "14"
            },
            fontWeight: "100",
            _ios: {
              lineHeight: 5,
              fontSize: 12
            },
            _android: {
              lineHeight: 5,
              fontSize: 12
            }
          };
        },
        restaurantDetails_RestTimings_SpecialHoursText: function restaurantDetails_RestTimings_SpecialHoursText() {
          return {
            fontWeight: 300,
            fontFamily: "Now-Regular",
            fontSize: 12,
            color: "#606060"
          };
        },
        //Restaurant About
        restaurantDetails_RestAbout_TitleText: function restaurantDetails_RestAbout_TitleText() {
          return {
            color: "restaurantAboutSectionHeadingTextColor",
            marginBottom: 4,
            fontSize: {
              lg: 20,
              base: 16
            },
            lineHeight: 6,
            display: {
              base: "flex",
              lg: "none"
            }
          };
        },
        restaurantDetails_RestAbout_DescText: function restaurantDetails_RestAbout_DescText() {
          return {
            color: {
              lg: "restaurantAboutSectionBodyTextSecColor",
              base: "restaurantAboutSectionBodyTextColor"
            },
            fontFamily: "Now-Regular",
            paddingBottom: 4,
            fontSize: {
              base: "14",
              lg: "14"
            },
            fontWeight: "200",
            lineHeight: "5"
          };
        },
        //Restaurant Action Buttons
        restaurantDetails_ActionButtons_CTAButtonLabelText: function restaurantDetails_ActionButtons_CTAButtonLabelText() {
          return {
            fontFamily: "Brandon",
            fontSize: "16px",
            color: "amenitiesActionButtonsColor",
            textAlign: "center",
            textTransform: "uppercase",
            _web: {
              textTransform: "uppercase"
            }
          };
        },
        //Restaurant Amenities
        restaurantDetails_Amenities_TitleText: function restaurantDetails_Amenities_TitleText() {
          return {
            paddingBottom: 4,
            fontSize: {
              lg: 20,
              base: 16
            },
            color: "amenitiesHeadingColor",
            display: {
              base: "flex"
            }
          };
        },
        restaurantDetails_Amenities_IconName: {
          fontWeight: 300,
          fontSize: {
            base: "12",
            lg: "14"
          },
          color: "#606060"
        },
        restaurantDetails_Amenities_Description: {
          fontSize: {
            base: 12,
            lg: 14
          },
          fontWeight: "300",
          color: "#606060"
        },
        restaurantDetails_Amenities_Title: {
          fontSize: {
            base: 14,
            lg: 16
          },
          mb: 1,
          color: "#606060"
        },
        //Restaurant Holiday Msg
        restaurantDetails_HolidayMsg_Text: {
          fontFamily: "Now-Medium",
          textAlign: "center",
          fontSize: {
            base: "14px"
          },
          color: "white",
          maxW: {
            base: "250px",
            md: "350",
            lg: "100%"
          },
          mx: "auto",
          lineHeight: 5
        },
        //Restaurant Order Button
        restaurantDetails_OrderButton_LabelText: function restaurantDetails_OrderButton_LabelText() {
          return {
            fontFamily: "Brandon",
            _android: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            _ios: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            fontSize: "16px",
            color: "orderFromHereButtonTextColor",
            textAlign: "center",
            textTransform: {
              base: "uppercase",
              lg: "uppercase"
            }
          };
        },
        restaurantDetails_RestTimings_WeekDay: function restaurantDetails_RestTimings_WeekDay() {
          return {
            color: "restaurantTimingWeekDayTextColor",
            fontSize: {
              base: "10",
              lg: "12"
            },
            position: "absolute"
          };
        },
        locationTitleHeader: function locationTitleHeader() {
          return {
            fontWeight: 600,
            fontSize: 18,
            color: "preferredLocationHeaderTextColor",
            textTransform: "uppercase"
          };
        },
        waitlist_leave_the_line_text: function waitlist_leave_the_line_text() {
          return {
            fontSize: 16,
            fontWeight: 300,
            color: "#606060"
          };
        },
        waitlist_leave_the_line_link: function waitlist_leave_the_line_link() {
          return {
            fontSize: 16,
            fontWeight: 400,
            color: "#A2402A"
          };
        },
        restDetails_TextMapper_Title: function restDetails_TextMapper_Title() {
          return {
            fontWeight: 400,
            fontSize: 28,
            mb: 4,
            color: "white",
            textAlign: "left"
          };
        },
        restDetails_TextMapper_Description: function restDetails_TextMapper_Description() {
          return {
            fontWeight: 300,
            fontSize: 18,
            color: "white",
            textAlign: "left"
          };
        },

        /* Restaurant Details End */
        remoteCheckinBodyOrderAheadText: {
          color: "white",
          fontWeight: 600,
          fontSize: 22
        },
        reservationConfirmationText: {
          fontWeight: 200
        },
        //LocationSearch Start
        locationSearchHeading: function locationSearchHeading() {
          return {
            fontWeight: 600,
            fontSize: 20,
            fontFamily: "heading",
            color: "locationSearchTitle"
          };
        },
        recentLocationsText: function recentLocationsText() {
          return {
            fontSize: {
              base: 17,
              md: 20
            },
            fontWeight: 500,
            lineHeight: 5
          };
        },
        orderSettingsQuantityText: function orderSettingsQuantityText() {
          return {
            fontSize: "md",
            py: 2,
            px: 5
          };
        },
        sliderTitleText: function sliderTitleText() {
          return {
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: 500
            }
          };
        },
        reorderButtonText: function reorderButtonText() {
          return {
            fontWeight: 500
          };
        },
        desktopBreadcrumbVariant: function desktopBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        desktopLastBreadcrumbVariant: function desktopLastBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        numberOfCartItems: function numberOfCartItems() {
          return {
            fontWeight: 500
          };
        },
        restTimingsSplMsg: function restTimingsSplMsg() {
          return {
            fontWeight: 300
          };
        },
        currentlyUnavailableText: function currentlyUnavailableText() {
          return {
            color: "primary.100",
            fontWeight: {
              base: 500
            }
          };
        },
        menuCartHeaderTexLineHeightForApp: {
          lineHeight: 5
        },
        legalDisclaimerText: {
          lineHeight: 5
        },
        scrollingNavigationCarouselItemText: function scrollingNavigationCarouselItemText(_ref43) {
          var isActive = _ref43.isActive;
          return {
            fontWeight: isActive ? 400 : 300
          };
        },
        menuDetailDesciptionMobile: function menuDetailDesciptionMobile() {
          return {
            fontFamily: "Now-Medium",
            fontSize: 14,
            color: "#505050"
          };
        },
        increaseTextSize: function increaseTextSize(_ref44) {
          var styleSize = _ref44.styleSize;
          return {
            fontSize: styleSize
          };
        },
        nutritionalInfoBottomSheetAllergenInfo: function nutritionalInfoBottomSheetAllergenInfo() {
          return {
            color: "themeGrey",
            fontWeight: "200",
            fontSize: "xs"
          };
        },
        nutritionalInfoBottomSheetQuestion: function nutritionalInfoBottomSheetQuestion() {
          return {
            fontWeight: "300",
            color: "themeGrey",
            fontSize: "sm"
          };
        },
        myReservationCardBottomControlsText: function myReservationCardBottomControlsText() {
          return {};
        },
        quantityText: function quantityText() {
          return {
            fontSize: {
              base: "xs",
              md: "lg"
            },
            fontWeight: 300,
            lineHeight: {
              base: 4,
              md: 5
            },
            letterSpacing: -0.3
          };
        },
        reservationInfoValue: function reservationInfoValue() {
          return {
            fontWeight: 500,
            lineHeight: 5,
            fontSize: 14
          };
        },
        reservationListCardCtaText: function reservationListCardCtaText() {
          return {
            pl: 2,
            fontWeight: 300,
            lineHeight: 5,
            fontSize: 13
          };
        },
        reservationListCardLocationText: function reservationListCardLocationText() {
          return {
            fontWeight: 200,
            lineHeight: 5
          };
        },
        reservationListCardRestName: {
          mt: 2,
          fontSize: {
            base: 14,
            md: 16
          },
          fontWeight: 400,
          lineHeight: 5
        },
        reservationListCardRestAddress: {
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 200,
          lineHeight: 5
        },
        reservationInfoKey: function reservationInfoKey() {
          return {
            fontWeight: 200,
            lineHeight: 5,
            fontSize: 14
          };
        },

        /** Text: Private Dining Start */
        privateDiningLocationModalHeaderText: {
          color: "#282C25",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        privateDiningFilterStateHeading: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 300,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        pd_requestFlow_form_title: function pd_requestFlow_form_title() {
          return {
            pt: {
              base: 5,
              md: 6
            },
            pb: {
              base: 4,
              md: 6
            },
            fontSize: {
              base: 16,
              md: 22
            },
            lineHeight: 6,
            textAlign: "center"
          };
        },
        pd_requestFlow_form_tabIndex: {
          m: "auto",
          color: "#FFFFFF",
          fontSize: {
            base: "xs",
            md: "md"
          }
        },
        pd_requestFlow_form_tabTitle: function pd_requestFlow_form_tabTitle(_ref45) {
          var isActive = _ref45.isActive,
              isCompleted = _ref45.isCompleted;
          return {
            fontWeight: isActive ? 400 : 200,
            fontSize: {
              base: "sm",
              md: "md"
            },
            color: isActive || isCompleted ? "#303030" : "#808080"
          };
        },
        pd_request_eventDetails_locationTitle: {
          fontSize: {
            base: "sm",
            md: "md"
          },
          fontWeight: 400,
          mb: 1.5,
          color: "#020001"
        },
        pd_request_eventDetails_locationAddress: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          fontWeight: 200,
          lineHeight: 4,
          color: "#020001"
        },
        pd_request_eventDetails_locationPhoneNum: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          fontWeight: 200,
          color: "#020001"
        },
        pd_request_eventDetails_locationChange: {
          fontSize: 12,
          fontWeight: 300,
          color: "#00A9A1"
        },
        pd_request_eventDetails_InputTitle: {
          fontSize: "sm",
          fontWeight: 200,
          lineHeight: 4,
          mb: 2,
          color: "#303030"
        },
        pd_request_eventDetails_noOfGuest_subMessage: {
          fontSize: "sm",
          fontWeight: 200,
          lineHeight: 4,
          color: "#606060",
          mt: 2
        },
        pd_request_eventDetails_splRequestTitle: {
          fontSize: 16,
          fontWeight: 300,
          lineHeight: 4,
          mr: 3
        },
        pd_request_contactDetails_InputTitle: {
          color: "#303030",
          fontSize: 14,
          mb: 2,
          fontFamily: "Now-Regular"
        },
        pd_request_contactDetails_InputTitl_Optional_text: {
          color: "#606060",
          fontSize: 14,
          mb: 2,
          fontFamily: "Now-Regular"
        },
        pd_review_details_diresctions_text: {
          fontWeight: 500,
          fontSize: 14
        },
        pd_request_contactDetails_dobTitle: {
          color: "#303030",
          fontSize: 16,
          mr: 2,
          fontFamily: "Now-Regular"
        },
        pd_request_contactDetails_dobTooltip: {
          maxWidth: 176,
          color: "#ffffff",
          fontSize: 12,
          fontFamily: "Now-Regular"
        },
        pd_request_eventDetails_dineInDate_tooltip: {
          maxWidth: 176,
          color: "#FFFFFF",
          fontSize: 12,
          fontFamily: "Now-Regular"
        },
        pd_contactDetails_userInfoName: {
          color: "#303030",
          fontFamily: "Now-Bold",
          fontWeight: 500,
          fontSize: {
            base: 14,
            md: 16
          },
          mb: 2
        },
        pd_contactDetails_userInfoExtras: {
          color: "#303030",
          fontFamily: "Now-Regular",
          fontSize: {
            base: 12,
            md: 14
          },
          _ios: {
            lineHeight: 14
          },
          _android: {
            lineHeight: 14
          },
          _web: {
            lineHeight: 12
          }
        },
        pd_reviewDetails_title: {
          color: "#606060",
          fontFamily: "Now-Regular",
          fontSize: 12
        },
        pd_reveiwDetails_restName: {
          color: "#020001",
          fontFamily: "Now-Bold",
          fontSize: {
            base: 14,
            md: 16
          },
          mb: 1
        },
        pd_reviewDetails_restAddress: {
          color: "#020001",
          fontFamily: "Now-Regular",
          fontSize: {
            base: 12,
            md: 14
          }
        },
        pd_reviewDetails_restPhoneNum: {
          color: "#020001",
          fontFamily: "Now-Regular",
          fontSize: {
            base: 12,
            md: 14
          }
        },
        pd_reviewDetails_eventInfoTitle: {
          color: "#606060",
          fontFamily: "Now-Regular",
          fontSize: 12,
          _web: {
            lineHeight: 12
          },
          mb: 2
        },
        pd_reviewDetails_eventInfoData: {
          color: "#020001",
          fontFamily: "Now-Regular",
          fontSize: {
            base: 14,
            md: 16
          },
          _web: {
            lineHeight: 12
          }
        },
        pd_reviewDetailsSplReqTitle: function pd_reviewDetailsSplReqTitle(_ref46) {
          var isFromConfirmation = _ref46.isFromConfirmation;
          return {
            color: isFromConfirmation ? "#606060" : "#303030",
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 15,
            fontFamily: "Now-Medium",
            mb: 2
          };
        },
        pd_reviewDetailsSplReqData: function pd_reviewDetailsSplReqData(_ref47) {
          var isFromConfirmation = _ref47.isFromConfirmation;
          return {
            color: isFromConfirmation ? "#303030" : "#606060",
            fontSize: 14,
            fontFamily: "Now-Regular",
            fontWeight: 400
          };
        },
        pd_confirmation_title: {
          color: "#00A9A1",
          fontSize: 16,
          maxW: {
            md: "354px"
          },
          textAlign: "center",
          fontWeight: 600
        },
        pd_confirmation_emailText: {
          color: "#505050",
          fontFamily: "Now-Regular",
          fontSize: 14
        },
        pd_confirmation_email: {
          color: "#303030",
          textAlign: "center",
          fontSize: 14,
          mt: 1
        },
        pd_confirmation_salesMessage: {
          color: "#505050",
          fontFamily: "Now-Regular",
          fontSize: 14,
          maxW: {
            md: "387px"
          },
          textAlign: "center"
        },
        pd_confirmation_restPhoneNum: {
          color: "#00A9A1",
          fontSize: 14,
          fontFamily: "Now-Medium",
          fontWeight: 400
        },
        pd_cancelModalMessage: {
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "#606060",
          fontFamily: "Now-Regular"
        },
        pd_cancelModalCancelCTAText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          textAlign: "center",
          color: "#8F278A",
          fontFamily: "Now-Regular"
        },
        pd_cancelModalCancelConfirmText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          textAlign: "center",
          color: "#FFFFFF",
          fontFamily: "Now-Regular"
        },
        pd_request_eventDetails_dineInDate_subMessage: {
          fontSize: "xs",
          fontWeight: 200,
          lineHeight: 4,
          color: "#808080",
          fontFamily: "Now-Regular",
          mr: 2
        },
        pd_landing_home_subText: {
          color: "#606060",
          fontWeight: 300
        },
        pd_landing_home_activeText: {
          color: "#020001",
          textTransform: "uppercase",
          fontSize: {
            base: 28,
            md: 45
          },
          fontWeight: 500
        },
        pd_landing_stickyContainer_label: {
          fontSize: {
            base: "xs",
            md: "md"
          },
          fontWeight: 300,
          color: "#000000",
          lineHeight: 5,
          textAlign: {
            base: "center",
            md: "start"
          },
          mt: {
            base: 1,
            lg: 0
          },
          maxWidth: {
            base: 80,
            md: "360px"
          },
          wordBreak: "break-word"
        },
        pd_landing_makeAReq_ctaText: {
          color: "#FFFFFF",
          textTransform: "uppercase",
          fontSize: {
            base: "sm",
            md: "xl"
          },
          lineHeight: 6
        },
        pd_landing_menuTabs_itemLabel: function pd_landing_menuTabs_itemLabel(_ref48) {
          var isActive = _ref48.isActive;
          return {
            textTransform: "uppercase",
            color: isActive ? "#FFFFFF" : "#020001",
            fontSize: 16,
            fontWeight: 500,
            lineHeight: 6
          };
        },
        pd_landing_dropdown_activeLable: function pd_landing_dropdown_activeLable(_ref49) {
          var isActive = _ref49.isActive;
          return {
            fontSize: "md",
            fontWeight: 500,
            lineHeight: 6,
            color: isActive ? "#020001" : "#FFFFFF",
            textTransform: "uppercase"
          };
        },
        pd_landing_locationHeaderName: {
          pb: 1,
          fontSize: 16,
          fontWeight: 300,
          color: "#404040",
          textTransform: "capitalize",
          flex: 1,
          mr: 2
        },
        pd_landing_locationHeaderChangeLoc: {
          fontSize: 16,
          color: {
            base: "#00A9A1",
            lg: "#8F278A"
          },
          fontWeight: 600,
          textTransform: "capitalize"
        },
        pd_landing_eventGuideCTA_text: {
          fontWeight: 400,
          color: "#8F278A",
          fontSize: 16
        },
        pd_landing_floorPlanLink_text: {
          textAlign: "center",
          mt: 3,
          fontSize: 14,
          fontWeight: 300,
          color: "#00A9A1"
        },
        pd_landing_floorPlan_viewGalleryLink: {
          display: "none"
        },

        /** Text: Private Dining End */
        eClub_newsTextHeading: {
          textAlign: "center",
          fontWeight: 500,
          color: "#4E311D",
          fontSize: 24,
          width: "70%",
          lineHeight: 8,
          letterSpacing: "-0.3"
        },
        eClub_newsTextSubHeading: {
          textAlign: "center",
          fontWeight: 600,
          color: "#4E311D",
          fontSize: 14,
          width: "70%",
          lineHeight: 8,
          letterSpacing: "-0.3"
        },
        eClub_smsText: {
          fontWeight: 200,
          color: "#4E311D",
          fontSize: 14
        },
        eClub_smsTextFooterText: {
          textAlign: "center",
          fontWeight: 200,
          color: "#303030",
          fontSize: {
            base: "xs",
            md: "12"
          },
          lineHeight: 4,
          w: {
            base: "100%",
            md: "70%"
          }
        },
        eClub_smsTextFooterLegalNoticeText: {
          fontWeight: 200,
          color: "primary.100",
          fontSize: {
            base: "xs",
            md: "12"
          },
          lineHeight: 4
        },
        eClub_TnCs_Text: {
          marginBottom: 3,
          fontWeight: 200,
          fontSize: 14,
          lineHeight: 4
        },
        eClub_TnCs_privacy_policy_text: {
          fontWeight: 200,
          color: "primary.100",
          fontSize: 14,
          lineHeight: 4,
          underline: true
        },
        eClubStickyCancelPressableText: {
          textTransform: "uppercase",
          color: "secondary.300",
          textAlign: "center",
          fontSize: 16
        },
        eclub_selected_restaurant_name: {
          fontWeight: 400
        },
        eclub_changeLocationCTAText: {
          fontWeight: 400
        },
        reservationSeatingOptionText: {},
        myAccount_mobileHeader_text: {
          color: "#2A2C25",
          fontSize: 18,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal"
        },
        order_history_details_order_number_text: {
          color: "secondary200Mobile"
        },
        passwordFooter_passiveText: {
          fontSize: 12,
          color: "mobileResetPasswordText",
          fontWeight: 400,
          lineHeight: 5
        },
        passwordFooter_activeText: {
          fontSize: 12,
          lineHeight: 5,
          color: "mobileAuthFooterActiveText",
          fontWeight: 400
        },
        orderHistory_reorderText: {
          color: "secondary.300",
          fontSize: 16,
          fontWeight: 400
        },
        noPrefLocationScreen_description: {
          fontSize: "16px",
          textAlign: "center",
          color: "#606060",
          fontWeight: "300"
        },
        noPrefLocationScreen_btn_text: {
          fontWeight: "400",
          color: "white",
          letterSpacing: "0.31"
        },
        joinEClubHeading: {
          fontWeight: 500,
          textAlign: "center",
          color: "white",
          fontSize: {
            base: 24,
            md: 32
          },
          width: "60%",
          lineHeight: 8
        },
        joinEClubSubHeading: {
          fontWeight: 200,
          color: "white",
          fontSize: 16,
          textAlign: "center",
          mt: 4
        },
        myAccount_paymentOptions_noSavedCards_title: {
          fontSize: 18,
          fontWeight: 400
        },
        myAccount_paymentOptions_savedGiftCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_savedCreditCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyText: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 6,
          letterSpacing: -1,
          textAlign: "center",
          mb: 3
        },
        myAccountConfirmationHeadTitle: {
          fontSize: 20,
          fontWeight: 400,
          my: 3,
          textAlign: "center",
          letterSpacing: "-0.1",
          color: "#303030"
        },
        myAccountConfirmationHeadSubText: {
          color: "#606060",
          fontSize: 16,
          fontWeight: 300,
          my: 2,
          textAlign: "center",
          lineHeight: 5,
          maxWidth: 337
        },
        addEditCCTitle: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_paymentOptions_modalWrapperHeader_text: {},
        addEditCreditCard_add_pressable_text: {
          marginTop: 5,
          marginBottom: 4,
          fontSize: 16,
          lineHeight: 6,
          textAlign: "center",
          color: "addCardFooterButtonText",
          textTransform: "uppercase"
        },
        gc_refreshBalance_cta_text: {
          color: "gcBalanceRefreshBorderTextColor",
          fontWeight: 400
        },
        myAccount_orderHistoryDetailsHeader_text: {
          color: "orderHistoryModalHeaderTextColor"
        },

        /** Text: Private Dining End */
        reservationLocationSelectCTAText: {
          fontSize: 12,
          fontWeight: 400
        },
        reorderNonLoggedInText: {
          fontSize: 16,
          fontWeight: 500
        },
        reservationCheckboxText: {
          fontWeight: 300
        },
        reservationStaticLinkText: {
          fontWeight: 500,
          color: "primary.100"
        },
        sectionHeaderLongDescription: {
          fontSize: ["sm", "sm", "md"],
          color: "categoriesHeadingColor"
        },
        reservationConfirmModalBodyText: {
          fontSize: 16,
          lineHeight: 5,
          textAlign: {
            md: "center"
          }
        },
        editProfileFullBottomButtonText: {
          fontSize: 16
        },
        dateTimePickerModalTitle: {
          display: "none"
        }
      }
    },
    HStack: {
      variants: {
        // My Account
        myAccountLocationCardHStack: {
          alignItems: "center",
          px: 4,
          py: 5,
          borderRadius: 6,
          borderColor: "#DCDCDC",
          borderWidth: 1
        },
        myAccount_infoList_changeEmail_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
          py: {
            base: 4,
            md: 5
          },
          backgroundColor: {
            base: "myAccountCardBackground",
            md: "#F6F6F6"
          },
          borderRadius: 0,
          _web: {
            w: {
              base: "100%",
              md: "48%"
            }
          }
        },
        // My Account Ends

        /* RESERVATION */
        joinWaitlist_Header_Container: function joinWaitlist_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#FFFFFF",
            bg: "#FFFFFF"
          };
        },
        reservationConfirmationDateTimeSizeHStack: {
          justifyContent: "flex-start",
          alignItems: "flex-start",
          mr: 1,
          flex: 1
        },
        reservationConfirmationDateTimeSizeContainer: {
          pt: 4,
          px: 3,
          justifyContent: "space-between"
        },
        reservationLookUpSuccessHStack: function reservationLookUpSuccessHStack(_ref50) {
          var isError = _ref50.isError;
          return {
            justifyContent: "center",
            space: 2,
            alignItems: "center",
            py: 2,
            my: 2,
            bg: isError ? "#DF450530" : "#F0FFFF",
            maxW: {
              md: "340px"
            },
            w: "100%",
            borderRadius: 4
          };
        },
        reservationLocationCardHStack: {
          my: 4,
          mx: 5,
          alignItems: "center",
          px: 4,
          py: 3,
          borderRadius: 4,
          shadow: 10,
          bg: "white",
          borderWidth: 1,
          borderColor: "reservationBorderColor"
        },
        reservationLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 6,
          borderColor: "#DEDEDE",
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          }
        },
        reservationProfileCardHStack: {
          my: 4,
          _ios: {
            paddingX: 4
          },
          _android: {
            paddingX: 4
          },
          borderRadius: 4,
          shadow: 10,
          bg: {
            base: "white",
            md: "transparent"
          }
        },
        reservationProfileCardLoggedInHStack: {
          alignItems: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            justifyContent: "space-between",
            w: "100%",
            px: 4,
            borderWidth: 1,
            borderRadius: 4,
            borderColor: "reservationBorderColor"
          },
          my: 3,
          bg: "white"
        },

        /* RESERVATION */
        //JWC START
        jwcFooterBlock: {
          py: 2,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        jwcLocationHeaderBlock: {
          py: 5,
          px: 6,
          borderRadius: 12,
          bg: "white",
          borderColor: "transparent",
          borderWidth: 1
        },
        //JWC END
        header: {
          bg: "themeTextColor"
        },
        checkoutBtn: {
          alignItems: "center",
          justifyContent: "space-around",
          _web: {
            height: "60px"
          },
          py: 3,
          px: 5,
          rounded: 8
        },
        scheduledOrderForm: {
          alignItems: "center",
          width: "100%",
          rounded: 6,
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          borderColor: "themeTextFieldBoundary",
          pl: 3,
          mb: 4
        },
        menuDetailIsUnavailable: function menuDetailIsUnavailable(_ref51) {
          var isSelected = _ref51.isSelected;
          return {
            bg: "#E5E5E5",
            borderWidth: isSelected ? 0 : 1,
            borderColor: "themeSectionSeparator",
            borderRadius: isSelected ? 0 : 13,
            shadow: 5,
            overflow: "hidden"
          };
        },
        listItemBox: {
          borderRadius: 10
        },
        cartItemButtonsContainer: function cartItemButtonsContainer() {
          return {
            justifyContent: "space-between"
          };
        },
        //Restaurant Details
        restaurantDetails_Index_RestAbout_HStack: {
          mt: "10",
          space: {
            lg: "md",
            xl: "2xl"
          }
        },
        restaurantDetails_Amenities_AmenitiesIcons_HStack: {
          alignItems: "center"
        },
        restaurantDetails_CurrentStatus_Icon_HStack: {
          alignItems: "center",
          justifyContent: "center",
          _web: {
            justifyContent: {
              base: "center",
              lg: "normal"
            }
          }
        },
        restaurantDetails_RestInfo_AddToFavourites_HStack: {
          alignItems: "center",
          mb: "6"
        },
        restaurantDetails_RestInfo_StarIcon_HStack: {
          alignItems: "center"
        },
        restaurantDetails_RestTime_HStack: {
          alignItems: "center",
          mb: "4"
        },
        restaurantDetails_RestTime_HoursLegend_HStack: {
          mr: "0",
          ml: "auto",
          justifyContent: "center"
        },
        restaurantDetails_RestTimings_WeekDaysIcon_HStack: {
          mb: 9,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_SelectedDay_HStack: {
          mb: 4,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_List_HStack: {
          marginBottom: 3,
          justifyContent: "space-between"
        },
        restaurantDetails_Waitlist_Party_HStack: {
          justifyContent: "center",
          alignItems: "center",
          mb: {
            base: 5
          }
        },
        restaurantDetails_Waitlist_Button_HStack: {
          justifyContent: "center"
        },
        //Order Tracking
        orderTrackingPayNowButtonHStack: {
          bgColor: "payNowButtonBg",
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "space-between"
        },
        orderTrackingCallHelpHStack: {
          py: 4,
          px: 5,
          _web: {
            minHeight: "68px",
            bottom: 0
          },
          bgColor: "background.100",
          borderTopColor: "borderColorCallSection",
          borderTopWidth: 1,
          alignItems: "center",
          justifyContent: "space-between",
          mt: "auto"
        },
        borderRadiusValue: function borderRadiusValue(_ref52) {
          var radiusValue = _ref52.radiusValue,
              topRadiusValue = _ref52.topRadiusValue,
              bottomRadiusValue = _ref52.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        menuDetailArrowPosition: {
          mt: 1.5
        },
        menuDetailPropertyAccordionDescriptionTile: {
          mt: {
            base: 1.5,
            md: 1
          }
        },

        /* HStack: Private Dining Start */
        pd_Header_Container: function pd_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#D6D6D6"
          };
        },
        privateDiningLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 6,
          borderColor: "#DEDEDE",
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          }
        },
        pd_request_eventDetails_selectTime_container: {
          marginTop: 2,
          marginBottom: 1,
          marginX: 5,
          borderColor: "#DEDEDE",
          borderWidth: 1,
          paddingY: 4,
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 8
        },
        pd_request_contactDetails_userInfo: {
          borderWidth: 1,
          borderRadius: 6,
          borderColor: "#DDD",
          p: 4,
          bg: "white"
        },
        pd_request_eventDetails_inputContainer: function pd_request_eventDetails_inputContainer(_ref53) {
          var errorMessage = _ref53.errorMessage,
              isActive = _ref53.isActive;
          return {
            py: 4,
            px: 3,
            alignItems: "center",
            borderWidth: 1,
            borderRadius: 6,
            borderColor: errorMessage ? "#D30000" : isActive ? "#00A9A1" : "#DDDDDD",
            bgColor: "white"
          };
        },
        pd_landing_menuTabs_container: {
          alignItems: "center",
          justifyContent: "space-between",
          flex: {
            base: 0.7,
            xl: 0.5
          }
        },
        pd_landing_menuDropdown_summary: function pd_landing_menuDropdown_summary(_ref54) {
          var isExpanded = _ref54.isExpanded;
          return {
            p: 5,
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "space-between",
            borderBottomColor: isExpanded ? "#E0DED8" : "transparent",
            borderBottomWidth: 1
          };
        },
        pd_landing_eventGuideCTA_body: {
          alignItems: "center",
          justifyContent: "center",
          space: {
            base: 3,
            lg: 4
          },
          py: 2.5,
          bg: "#FFFFFF",
          borderRadius: 8
        },
        pd_landing_floorPlanLinksSection: {
          py: {
            lg: 5
          },
          alignItems: "center",
          justifyContent: "center"
        },

        /* HStack: Private Dining End */
        eClub_smsTextHStack: {
          w: {
            base: "100%",
            md: "70%"
          },
          alignItems: "center",
          mt: 4,
          mb: 8,
          borderRadius: 10,
          borderWidth: 1,
          borderColor: "#E9E9E9",
          shadow: 10,
          bg: "#F6F6F6",
          zIndex: 1
        },
        orderHistoryDetails_basicDetails_HStack: {
          p: 3,
          bg: "background.100",
          alignItems: "center",
          mb: 2
        }
      }
    },
    Flex: {
      variants: {
        orderConfirmationflex: {
          _web: {
            flexDirection: {
              base: "column-reverse",
              lg: "row"
            }
          }
        }
      }
    },
    Image: {
      variants: {
        pdRequestPageBg: {
          display: "inherit"
        },
        cartItemImage: {
          _web: {
            height: {
              base: "71px"
            },
            width: {
              base: "100px"
            }
          },
          rounded: "md",
          height: 70,
          width: 100
        },
        menu_item_card_vertical_image_border_radius: 8,
        //Restaurant Details
        restaurantDetails_RestInfo_Mob_Image: {
          h: "98px",
          w: "98px",
          borderRadius: 10,
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "210px"
            },
            w: {
              base: "97px",
              lg: "220px"
            }
          }
        },
        restaurantDetails_RestInfo_ImageLg: {
          h: "98px",
          w: "98px",
          borderRadius: 10,
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "89px"
            },
            w: {
              base: "97px",
              lg: "94px"
            }
          }
        },
        restaurantDetails_RestInfo_FavoriteIconLg: {
          height: "16px",
          width: "16px"
        },
        //Edit Waitlist
        editWaitlist_LocationHeader_Icon: {
          _web: {
            width: 4,
            height: 5
          }
        },
        rd_spl_hours_legend: {
          width: "11px",
          height: "11px",
          mr: "1"
        },
        rd_spl_hours_icon: {
          width: "11px",
          height: "11px",
          top: 0,
          right: 0,
          position: "absolute"
        },
        //location search page
        location_search_exclamation_icon: {
          display: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref55) {
          var radiusValue = _ref55.radiusValue,
              topRadiusValue = _ref55.topRadiusValue,
              bottomRadiusValue = _ref55.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        favorite_pin_fill_brand_icon: function favorite_pin_fill_brand_icon(_ref56) {
          var active = _ref56.active;
          return {
            height: active ? 4 : 3,
            width: active ? 4 : 3
          };
        },
        //cart overlay
        cart_overlay_pickup_date_brand_icon: {
          _web: {
            height: 5,
            width: 5
          },
          height: 20,
          width: 20,
          mr: 0
        },
        cart_overlay_pickup_time_brand_icon: {
          height: 20,
          width: 20,
          _web: {
            height: 5,
            width: 5
          },
          mr: 0
        },
        pd_select_restaurant_brand_logo: {
          height: "32px",
          width: "138px"
        }
      }
    },
    VStack: {
      variants: {
        jwcWaitTimeBlock: {
          p: 3,
          px: 6,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        addToCartContainer: {
          w: {
            base: "76px",
            md: "120px"
          }
        },
        indicatorsContainer: {
          flex: 1
        },
        //Restaurant Details
        restaurantDetails_Index_RestInfo_VStack: {
          space: "xs"
        },
        restaurantDetails_Index_RestAbout_VStack: {
          position: "relative",
          mx: {
            lg: "60px"
          }
        },
        restaurantDetails_Index_RestAbout_InnerVStack: {
          flex: {
            lg: 4,
            xl: 1
          },
          space: "2xs"
        },
        restaurantDetails_Index_BrandFooter_VStack: {
          overflowX: "hidden"
        },
        restaurantDetails_ActionButtons_VStack: {
          space: "md"
        },
        restaurantDetails_RestInfo_StarIcon_VStack: {
          space: 4,
          justifyContent: "center",
          flex: 1,
          direction: "column-reverse"
        },
        //order tracking
        orderTrackingRefreshButtonVStack: {
          borderColor: "refreshButtonColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2,
          px: 1,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        orderTrackingAutoRefreshVStack: {
          borderColor: "orderStatusSectionBorderColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2.5,
          px: 4,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        nutritionalInfoVStack: {
          mt: {
            base: 2,
            md: 3
          },
          mb: "2",
          alignItems: "flex-start",
          width: "100%",
          _web: {
            width: {
              base: "100%",
              md: "100%",
              lg: "966px"
            }
          }
        },
        vstackBorderBottomRadius: {
          borderBottomRadius: 8
        },

        /** VStack: Private Dining Start */
        pd_requestForm_Tabs_Container: {
          bgColor: "#F0FFFF",
          borderBottomWidth: 1,
          borderBottomColor: "#D6D6D6",
          borderTopRadius: {
            base: 0,
            md: 12
          }
        }
        /** VStack: Private Dining End */

      }
    },
    Box: {
      variants: {
        menuCardShadow: {
          shadow: 0
        },
        // My Account
        myAccountDesktop_container: {
          width: {
            md: "100%",
            lg: 980,
            xl: 1200
          },
          h: 700,
          overflow: "clip",
          rounded: 0,
          bg: "white",
          shadow: 2,
          mx: "auto",
          my: 5
        },
        myAccountDesktop_headerBox: {
          py: 6,
          px: 10,
          borderBottomWidth: 1,
          borderBottomColor: "#EDEDED"
        },
        myAccountDesktop_container_leftSection: {
          borderRightWidth: 1,
          minW: 272,
          borderRightColor: "#EDEDED",
          overflow: "auto",
          mb: 20
        },
        myAccount_editProfile_infoCard: {
          px: {
            base: 5,
            md: 8
          },
          mb: {
            base: 8,
            md: 2
          },
          paddingY: 5,
          bg: "white",
          mt: 1
        },
        myAccount_orderHistoryItem_header: {
          backgroundColor: "mobileOrderHistoryItemCardHeaderBackgroundColor",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          padding: 3,
          paddingRight: 4,
          borderTopRadius: 16,
          overflow: "hidden"
        },
        myAccount_paymentOptions_container: {
          marginBottom: 5,
          my: 1,
          backgroundColor: "white",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%",
            bg: {
              base: "myAccountScreenBackroundColor",
              md: "white"
            }
          }
        },
        myAccount_check_icon_container: {
          justifyContent: "center",
          alignItems: "center",
          rounded: "full",
          bg: "white",
          border: 2,
          borderColor: "#00A9A1",
          w: "90px",
          h: "90px",
          mb: 12,
          mx: "auto"
        },
        myAccount_edit_field_sheet_title_wrapper: {
          bg: "white",
          rounded: 0,
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_profile_icon_container: {
          size: 75,
          overflow: "hidden",
          borderRadius: 100,
          borderWidth: 6,
          borderColor: "ProfilePictureCircleBorderColor",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground"
        },
        myAccount_paymentOptions_cardDetails_container: {
          py: 3,
          backgroundColor: "paymentOptionsHeaderColor",
          borderBottomWidth: 1,
          borderColor: "paymentOptionsBorderColor",
          _web: {
            marginX: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_giftCards_AddCardButton: {
          py: 2,
          px: 3
        },
        myAccount_paymentOptions_gc_isRefershing: {
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_title: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_content: {
          width: "100%",
          px: 4,
          pt: 7,
          _web: {
            px: {
              base: 4,
              md: 0
            }
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_gcContainer: {
          mb: 5,
          _web: {
            width: {
              base: "100%",
              md: "60%"
            },
            alignSelf: "center",
            px: {
              base: 0,
              md: 4
            }
          }
        },
        myAccount_order_history_order_details_modal_header: {
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
          w: "100%"
        },
        myAccount_order_history_title_wrapper: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: 5,
          pt: 5,
          mb: 2
        },
        myAccount_add_edit_credit_card_wrapper: {
          paddingX: 4,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            paddingX: {
              base: 4,
              md: 9
            }
          },
          justifyContent: "space-between"
        },
        myAccount_add_gift_card_actionsheet_wrapper: {
          alignItems: "center",
          paddingLeft: 0,
          paddingTop: 0
        },
        myAccount_add_gift_card_action_sheet_save_for_future_use_wrappper: {
          width: "100%",
          paddingX: 5,
          alignItems: "flex-start",
          justifyContent: "center"
        },
        myAccount_paymentOptions_gcl_isRefershing: {
          position: "absolute",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bs_delete_container: {
          bg: "white",
          py: 3.5,
          alignItems: "flex-end",
          px: 6
        },
        myAccount_paymentOptions_addGC_addSheet_addContainer: {
          width: "100%",
          _android: {
            paddingY: 1
          },
          _ios: {
            marginTop: 6
          },
          paddingX: 5,
          alignItems: "center",
          _web: {
            py: {
              base: 5,
              md: 3.5
            },
            px: {
              md: 12
            }
          },
          flexDirection: "row"
        },
        myAccount_paymentOptions_showCC_BS_titleBox: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          }
        },
        myAccount_security_question_wrapper: {
          px: 5
        },
        myAccount_updatedQuestion_defaultItemContainer: {
          flexDirection: "row",
          justifyContent: "space-between",
          borderBottomColor: "securityQuestionMenuColor",
          py: 2,
          mb: 12,
          borderBottomWidth: 1
        },
        myAccount_userInfoCard_container: {
          px: 5,
          py: 5,
          flexDirection: "row",
          alignItems: "flex-start"
        },
        myAccount_editField_saveErrorMessage: {
          borderRadius: 0,
          mt: 3,
          py: 3,
          px: 5,
          mx: 5,
          border: 1,
          bg: "red.200",
          borderColor: "red.300"
        },
        myAccount_fallBackPictureBackground_Box: {
          height: "100%",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground",
          _web: {
            backgroundColor: "#DCDCDC"
          }
        },
        // My Account ends

        /*RESERVATION*/
        reservationConfirmationDateTimeSizeBox: {
          flex: 1,
          alignItems: "flex-start"
        },
        reservationConfirmationBoxBorderRadius: {
          borderRadius: 6
        },
        reservationConfirmationDetailsBox: {
          borderRadius: 6,
          my: {
            base: 6,
            md: 0
          },
          py: {
            base: 5,
            md: 6
          },
          borderTopWidth: 1,
          borderColor: "#0000001a"
        },
        reservationProfileInputBox: {
          pl: {
            base: 4,
            md: 5
          },
          pr: 4,
          bg: "white",
          _web: {
            pb: 9
          },
          borderRadius: 4,
          borderWidth: {
            base: 0,
            md: 1
          },
          borderColor: "reservationBorderColor"
        },
        reservationProfileContactDetailsBox: {
          py: 4,
          flex: 1,
          my: 3,
          _web: {
            borderRadius: 4,
            borderWidth: {
              base: 1,
              md: 0
            },
            borderColor: "reservationBorderColor"
          }
        },
        reviewReservationsContainerBox: {
          mt: 8,
          alignItems: "center",
          px: 4,
          borderRadius: 4,
          _web: {
            bg: {
              base: "reservationBg",
              md: "myReservationsBoxBg"
            },
            maxW: {
              md: "680px"
            },
            py: 8,
            mt: {
              base: 8,
              md: 16
            },
            px: {
              base: 5,
              md: 24
            },
            mb: {
              base: 8,
              md: 16
            },
            borderWidth: 1,
            borderColor: "reservationUnSelectedCTABorderColor"
          }
        },
        reservationDropdownRadius: 6,
        reservationLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 6,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        reservationLocationDropdownBox: {
          bg: "#F0FFFF",
          py: 4,
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        reservationAvailableTimeSlotBtnBox: {
          _web: {
            width: 24,
            py: 2
          },
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          borderRadius: 4,
          _ios: {
            width: 24,
            height: 10
          },
          _android: {
            width: 24,
            height: 10
          }
        },
        reservationAvailableTimeSlotsBox: {
          borderWidth: 1,
          _ios: {
            py: 3
          },
          _android: {
            py: 3
          },
          _web: {
            py: 4,
            px: 3
          },
          w: "100%",
          mt: 4,
          borderRadius: 4,
          bg: "white"
        },
        reservationTabsBtn: function reservationTabsBtn(_ref57) {
          var isActive = _ref57.isActive;
          return {
            minW: {
              base: "167px",
              md: "191px"
            },
            px: 1,
            h: {
              base: "38px",
              md: "42px"
            },
            bg: isActive ? "reservationBg" : "primary.100",
            borderTopRadius: 6
          };
        },

        /*RESERVATION*/
        remoteCheckinContainer: {
          px: 6,
          py: 4,
          _web: {
            borderRadius: "12px"
          },
          borderWidth: 1,
          borderColor: "#F4F4F4",
          borderRadius: 3,
          width: {
            base: "100%",
            md: "335px"
          },
          shadow: 13,
          justifyContent: "space-around",
          alignItems: "center"
        },
        rd_spl_hours_icon: {
          width: 11,
          height: 11,
          top: 0,
          right: 0,
          position: "absolute"
        },
        rd_spl_hours_legend: {
          width: 11,
          height: 11,
          mr: 1
        },
        indicatorBanner: {
          fontFamily: "Teko-Medium"
        },
        remoteCheckinWaitTimeParentBox: {
          borderColor: "#E9E9E9",
          borderWidth: 1,
          bg: "#F0FFFF"
        },
        OrderInfoBannerCartIconBox: {
          pb: 1
        },
        waitlistRestaurantInfoBox: {
          borderColor: "#E9E9E9",
          borderWidth: 1
        },
        jwcHowItWorksBox: {
          borderBottomWidth: 1,
          borderBottomColor: {
            base: "#A2402A",
            lg: "white"
          }
        },
        checkinSuccessNote: {
          bg: "#00A9A1",
          px: {
            base: 5,
            md: 9
          },
          py: 6,
          borderRadius: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        onboardingScreenTextContainer: {
          top: "79%"
        },
        locationDropdownRadius: 7,
        emptyCartModalRadius: 8,
        appMessagesSuccessDialogBorderRadius: 6,
        sectionHeaderBottomSpace: function sectionHeaderBottomSpace(_ref58) {
          var hasSub = _ref58.hasSub;
          return {
            mb: {
              base: hasSub && -0.5,
              md: hasSub && -1
            }
          };
        },
        configOptionBox: {
          borderRadius: 12
        },
        configOptionBoxWithMAPPWidth: {
          borderRadius: 12,
          _ios: {
            minWidth: 72
          },
          _android: {
            minWidth: 72
          }
        },
        sliderItemBox: {
          borderRadius: {
            base: 8
          }
        },
        brandLogoMobileDimensions: function brandLogoMobileDimensions() {
          return {
            _ios: {
              height: 12,
              width: 40
            },
            _android: {
              height: 12,
              width: 40
            },
            _web: {
              height: "70px",
              width: "166px"
            }
          };
        },
        menuDetailDesciption: function menuDetailDesciption() {
          return {
            color: "#505050",
            _web: {
              fontSize: {
                base: "14px",
                md: "18px"
              },
              fontWeight: 400,
              fontFamily: "Now-Medium"
            },
            fontSize: {
              base: 3,
              md: 4
            }
          };
        },
        menuCardBodyPrice: {
          bottom: 0
        },
        addToCartDivider: function addToCartDivider() {
          return {
            _web: {
              top: {
                lg: "4px"
              }
            }
          };
        },
        temperatureSlider: function temperatureSlider() {
          return {
            bg: "E9E9E9",
            _web: {
              height: {
                base: "360px"
              },
              pb: 5
            },
            height: 400,
            pb: 10
          };
        },
        categoryActiveBorder: {
          borderBottomWidth: "5"
        },
        tempDescriptionBox: function tempDescriptionBox(_ref59) {
          var isChild = _ref59.isChild;
          return {
            px: {
              base: 3,
              md: isChild ? 3 : 5
            },
            py: 5,
            borderLeftRadius: 10,
            borderRightRadius: {
              base: 0,
              md: isChild ? 0 : 10
            },
            bg: "white",
            shadow: 11,
            _web: {
              width: {
                base: "177px",
                md: isChild ? "177px" : "325px"
              }
            }
          };
        },
        selectLocationDropDownBox: {
          ml: {
            base: 0,
            md: 8
          },
          mt: {
            base: 3,
            md: 0
          },
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          borderRadius: 8,
          _web: {
            width: {
              base: "100%",
              md: "335px"
            }
          },
          borderColor: {
            base: "allLocationsSelectBorderColorMobile",
            md: "allLocationsSelectBorderColorDesktop"
          }
        },
        locationCard: function locationCard(_ref60) {
          var isFromLocationSearchPage = _ref60.isFromLocationSearchPage;
          return {
            borderBottomWidth: 1,
            borderWidth: {
              base: 0,
              md: 1
            },
            borderColor: "allLocationsItemBoxBorderColor",
            borderRadius: {
              base: 0,
              md: 8
            },
            p: {
              base: 0,
              md: 1
            },
            mt: {
              base: 0,
              md: 4
            },
            mr: {
              base: 0,
              md: isFromLocationSearchPage ? "2%" : 8
            },
            _web: {
              minWidth: {
                base: "100%",
                md: "300px"
              }
            },
            width: isFromLocationSearchPage ? "48%" : "40%",
            bg: "#ffffff"
          };
        },
        listCard: {
          borderRadius: 8,
          position: "relative",
          pt: {
            base: 3
          },
          pb: {
            base: "14px"
          },
          px: {
            base: 3
          },
          p: {
            lg: 5
          }
        },
        headerCaretIconMobile: function headerCaretIconMobile() {
          return {
            mb: 0
          };
        },
        searchItemCardContainer: function searchItemCardContainer() {
          return {
            width: "100%",
            pr: 4,
            borderBottomWidth: 1,
            borderColor: "#EAEAEA"
          };
        },
        searchModalMenuCategoryListBox: function searchModalMenuCategoryListBox(_ref61) {
          var isMobile = _ref61.isMobile;
          return {
            borderRadius: !isMobile ? 12 : 0
          };
        },
        //Restaurant Details start
        restaurantDetails_Index_Map_Box: {
          flex: 1
        },
        restaurantDetails_Index_RestInfo_Box: {
          flex: 1,
          borderBottomColor: "#D6D6D6",
          borderBottomWidth: "1px"
        },
        restaurantDetails_Index_RestInfo_InnerBox: {
          px: 8
        },
        restaurantDetails_Index_CurrentStatus_Box: function restaurantDetails_Index_CurrentStatus_Box(_ref62) {
          var hideWaitlistSection = _ref62.hideWaitlistSection;
          return {
            px: 8,
            mb: hideWaitlistSection ? 0 : 10
          };
        },
        restaurantDetails_Index_WaitList_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_Divider_Box: {
          px: 6
        },
        restaurantDetails_Index_Amenities_Box: {
          pt: 4
        },
        restaurantDetails_Index_RestTime_Box: {
          flex: {
            lg: 5,
            xl: 1
          }
        },
        restaurantDetails_Index_RestTime_Mob_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_ActionButtons_Box: {
          flex: {
            lg: 3,
            xl: 1
          },
          pr: 2
        },
        restaurantDetails_Index_Mob_OrderButton_Box: function restaurantDetails_Index_Mob_OrderButton_Box(_ref63) {
          var isSticky = _ref63.isSticky;
          return {
            py: 4,
            px: isSticky ? 4 : 0
          };
        },
        restaurantDetails_Index_Mob_RestAbout_Box: {
          h: "auto"
        },
        restaurantDetails_ActionButtons_ViewMenu_Box: function restaurantDetails_ActionButtons_ViewMenu_Box(_ref64) {
          var isMobile = _ref64.isMobile,
              singleActionButton = _ref64.singleActionButton;
          return {
            px: 4,
            _web: {
              display: "grid"
            },
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            style: {
              "grid-template-columns": "1fr",
              "column-gap": "10px"
            }
          };
        },
        restaurantDetails_ActionButtons_ViewMenu_InnerBox: {
          _web: {
            mb: {
              base: 3,
              lg: 4
            }
          }
        },
        restaurantDetails_Amenities_IconBox: {
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row"
        },
        restaurantDetails_Amenities_Box: {
          px: {
            base: 4,
            lg: 6
          }
        },
        restaurantDetails_CurrentStatus_Icon_Box: {
          mr: 4
        },
        restaurantDetails_CurrentStatus_Mob_Divider_Box: {
          mt: 4,
          alignItems: "center"
        },
        restaurantDetails_HolidayMsg_Box: {
          px: {
            base: 2,
            lg: 3
          },
          py: 3,
          bg: "#00A9A1"
        },
        restaurantDetails_Map_Box: {
          height: "140px",
          position: "relative"
        },
        restaurantDetails_OrderButtonSection_Box: function restaurantDetails_OrderButtonSection_Box(_ref65) {
          var isInStack = _ref65.isInStack;
          return {
            px: isInStack ? 0 : 4,
            _web: {
              mb: isInStack ? {
                base: 3,
                lg: 4
              } : 0
            },
            alignItems: "center"
          };
        },
        restaurantDetails_RestAboutSection_Box: {
          px: "6",
          py: {
            base: "6",
            lg: "0"
          }
        },
        restaurantDetails_RestInfo_Outer_ImageBox: {
          position: "relative",
          bg: "white"
        },
        restaurantDetails_RestInfo_Mob_StarIcon_Box: {
          m: "auto"
        },
        restaurantDetails_RestInfo_Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo__Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo_PhoneNum_Box: {
          mb: {
            base: 4,
            lg: 0
          },
          flexDirection: "row",
          justifyContent: {
            base: "space-evenly",
            lg: "flex-start"
          },
          alignItems: {
            base: "center"
          }
        },
        restaurantDetails_RestInfo_PhoneNum_InnerBox: {
          alignItems: "center",
          flexDirection: "row"
        },
        restaurantDetails_RestTime_Box: {
          px: "4",
          py: {
            base: "4",
            lg: "0"
          }
        },
        restaurantDetails_RestTime_RestClosed_Box: {
          my: 5
        },
        restaurantDetails_RestInfo_ImageBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          position: "absolute",
          zIndex: 1,
          alignSelf: "center",
          borderRadius: 15,
          shadow: 11,
          _web: {
            alignSelf: {
              base: "center",
              lg: "left"
            }
          },
          top: {
            base: "-50px",
            lg: "-150px"
          },
          overflow: "hidden"
        },
        restaurantDetails_RestInfo_ImageLgBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          borderRadius: 15,
          shadow: 11,
          mr: "8"
        },
        restaurantDetails_CurrentStatusAndWaitlist_Box: {
          py: "5",
          px: {
            base: "4",
            lg: "8"
          },
          backgroundColor: {
            base: "white",
            lg: "#F4F4F4"
          },
          borderRadius: "12"
        },
        restaurantDetails_CurrentStatus_Box: {
          pt: {
            base: "5",
            lg: "0"
          },
          px: {
            base: "4",
            lg: "0"
          },
          backgroundColor: "white"
        },
        restaurantDetails_Waitlist_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          pb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_WaitlistAlready_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          mb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_RestTimings_Divider: {
          marginBottom: 4
        },
        restDetails_TextMapper_Container: {
          py: 16,
          px: {
            base: "60",
            lg: "116"
          },
          bg: "#ffffff"
        },
        //Restaurant Details end
        //Location search
        tabLocationsTopWidth: 1,
        // location search page
        locationSearchActiveTab: function locationSearchActiveTab(_ref66) {
          var isActive = _ref66.isActive;
          return {
            height: "4px",
            bg: isActive ? "locationSearchActiveTab" : "transparent",
            w: "100%",
            borderTopRadius: "8px"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref67) {
          var radiusValue = _ref67.radiusValue,
              topRadiusValue = _ref67.topRadiusValue,
              bottomRadiusValue = _ref67.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        homeScreenAlertHeadingWrapper: function homeScreenAlertHeadingWrapper(_ref68) {
          var isSmallScreen = _ref68.isSmallScreen;
          return {
            height: isSmallScreen ? 6 : 7,
            mr: 1
          };
        },
        menu_detail_divider: {
          mb: 5
        },
        boxBorderRadius: {
          _web: {
            borderRadius: 8
          },
          borderRadius: 12
        },
        desktopBreadcrumbCaret: function desktopBreadcrumbCaret() {
          return {
            height: 2.5,
            width: 1,
            ml: 2.5,
            mr: 3,
            mb: 1,
            alignItems: "center"
          };
        },
        countLabelContainer: function countLabelContainer(_ref69) {
          var isIOS = _ref69.isIOS;
          return {
            _text: {
              color: "white",
              pt: isIOS ? 1 : 0,
              fontSize: 12
            }
          };
        },
        categoryBox: {
          mb: {
            md: 8,
            base: 3
          }
        },
        mobileGiftCardBrandLogo: {
          height: 35,
          width: 28
        },
        smartRecommendationModalHeadingContainer: {
          flex: 1
        },

        /** Box: Private Dining Start */
        privateDiningDropdownRadius: 6,
        privateDiningLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 6,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        privateDiningLocationDropdownBox: {
          bg: "#F0FFFF",
          h: {
            base: "72px",
            md: "82px"
          },
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        pd_makeRequest_container: {
          width: {
            base: "100%",
            md: "794"
          },
          m: {
            md: "auto"
          },
          my: {
            md: 6
          },
          minH: {
            md: "543"
          },
          bg: {
            base: "transparent",
            md: "#F6F6F6"
          },
          borderRadius: 12,
          borderColor: "#D6D6D6",
          borderWidth: {
            base: 0,
            md: 1
          }
        },
        pd_requestFlow_form_tabActiveBorder: function pd_requestFlow_form_tabActiveBorder(_ref70) {
          var isActive = _ref70.isActive;
          return {
            mt: {
              base: 3,
              md: 4
            },
            height: 1,
            bgColor: isActive ? "requestFormTabActiveItem" : "transparent",
            w: "100%",
            borderTopRadius: 2
          };
        },
        pd_request_eventDetails_locationDetails: {
          py: {
            base: 3,
            md: 4
          },
          px: {
            base: 3,
            md: 4
          },
          borderRadius: 8,
          borderWidth: 1,
          borderColor: "#DEDEDE",
          bgColor: "white"
        },
        pd_actionSheetBorderRadius: 10,
        pd_reviewDetails_container: {
          borderWidth: 1,
          borderRadius: 9,
          borderColor: "#DDD",
          p: 4,
          bg: "white"
        },
        pd_confirmationText_Container: {
          rounded: 9,
          border: 1,
          borderColor: "#DCDCDC",
          py: 5,
          px: {
            base: 4,
            md: "56px"
          },
          bg: "white",
          alignItems: "center"
        },
        pd_reviewDetails_messageRegardingRequest: {
          display: "none"
        },
        pd_request_contactDetails_specialReq: {
          mt: 5
        },
        pd_requestFlow_form_tabBG: function pd_requestFlow_form_tabBG(_ref71) {
          var isActive = _ref71.isActive;
          return {
            bgColor: isActive ? "requestFormTabActiveItem" : "requestFormTabDisableItem"
          };
        },
        pd_landing_eventGuideContainer: {
          width: "100%",
          pb: {
            base: 5,
            lg: "5rem"
          },
          px: {
            base: 5,
            lg: "115px"
          },
          mb: {
            base: 10,
            lg: "0px"
          },
          mt: {
            base: 4,
            lg: "0px"
          }
        },
        pd_landing_menuDropdown: function pd_landing_menuDropdown(_ref72) {
          var isExpanded = _ref72.isExpanded;
          return {
            p: 0,
            bgColor: isExpanded ? "#FFFFFF" : "#00A9A1",
            _hover: {
              bg: isExpanded ? "#FFFFFF" : "#00A9A1"
            },
            _expanded: {
              bg: isExpanded ? "#FFFFFF" : "#00A9A1"
            }
          };
        },
        pd_landing_floorPlan_showGalleryLink: {
          display: "none"
        },

        /** Box: Private Dining End */
        eClub_Building_Box: {
          w: "100%",
          h: 600,
          bg: "#F6F6F6"
        },
        eClubSignUpBox: {
          borderRadius: 20,
          bg: "white",
          mt: 10,
          px: {
            base: 4,
            md: 8
          },
          py: 8,
          w: {
            base: "100%",
            md: "60%"
          },
          alignSelf: "center"
        },
        eClubNewsBox: {
          borderRadius: 10,
          bg: "white",
          w: {
            base: "100%",
            md: "60%"
          },
          mt: 10,
          py: {
            base: 4,
            md: 10
          },
          px: 4,
          alignItems: "center",
          shadow: 10
        },
        eClubConfirmationBox: {
          borderRadius: 20,
          bg: "white",
          px: 10,
          py: 10,
          w: "50%",
          alignItems: "center"
        },
        eClubUnsubscribeContainer: {
          bg: "white",
          rounded: "md",
          p: 5,
          my: 10,
          shadow: 2,
          mx: {
            base: 10,
            md: "auto"
          }
        },
        myAccount_editFields_actionSheet_webBox: {
          pt: 2,
          pb: 7
        },
        myAccount_orderHistoryDetails_actionSheet_webBox: {
          pb: 7
        },
        addCreditCard_securityBanner_ContainerBox: {
          paddingTop: 4,
          paddingX: 5,
          paddingBottom: 4,
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          backgroundColor: "#F6F7F0",
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: "#EAEAEA",
          accessible: false,
          _web: {
            marginBottom: {
              base: 3,
              md: 6
            },
            paddingX: {
              base: 5,
              md: 9
            },
            paddingY: 3
          }
        },
        giftCardContainer_Box: function giftCardContainer_Box(_ref73) {
          var radiusValue = _ref73.radiusValue;
          return {
            _ios: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _android: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _web: {
              style: {
                background: "linear-gradient(91.85deg, #8F278A 0%, #EC008C 100%)"
              }
            },
            borderRadius: radiusValue,
            borderTopRadius: radiusValue,
            borderBottomRadius: radiusValue,
            pt: 1
          };
        },
        editProfileScreens_Box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          backgroundColor: "editProfileScreensBackgroundColor",
          _web: {
            height: "100%",
            overflowY: "auto",
            backgroundColor: "transparent"
          }
        },
        myAccount_orderHistoryItem_orderDetails_Box: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          paddingLeft: 3,
          paddingRight: 4,
          paddingTop: 3,
          paddingBottom: 4,
          justifyContent: "center"
        },
        orderHistoryEmptyScreen_Box: {
          flex: 1,
          justifyContent: "center",
          bg: {
            base: "mobileOrderHistoryBackgroundColor"
          }
        },
        orderHistory_screenContainer_box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%"
          },
          bg: {
            base: "mobileOrderHistoryBackgroundColor",
            md: "white"
          },
          px: {
            base: 0,
            md: 6
          }
        },
        giftCardLarge_brandIcon_Box: {
          mb: 4,
          height: 56,
          width: 80,
          _web: {
            height: "53px",
            width: "76px"
          }
        },
        addGiftCard_actionSheetTitle: {
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_editDetails_editMail: {
          mx: 4,
          px: {
            base: 0,
            md: 5
          },
          pt: 4,
          _android: {
            bgColor: "editProfileScreensBackgroundColor"
          },
          _ios: {
            bgColor: "editProfileScreensBackgroundColor"
          }
        },
        paymentOptions_giftCardLarge_deleteCTA: {},
        myAccount_editDetails_changeDOB: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          backgroundColor: "editProfileScreensBackgroundColor",
          _web: {
            pt: {
              base: 5,
              md: 0
            },
            backgroundColor: "transparent",
            height: "100%"
          }
        },
        eClubBGGradient_box: {// empty
        }
      }
    },
    View: {
      variants: {
        // My Account Starts
        myAccount_orderHistoryCard_container: {
          marginX: 2,
          marginTop: 2,
          marginBottom: 3,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          borderRadius: 16,
          backgroundColor: "white",
          shadow: 4
        },
        myAccount_paymentOptions_giftCards_iconWarpper: {
          paddingY: 2,
          paddingX: 3,
          marginRight: 3
        },
        myAccountConfirmationViewContainer: function myAccountConfirmationViewContainer(_ref74) {
          var isMobile = _ref74.isMobile;
          return {
            bg: "#FFFFFF",
            rounded: {
              base: 0,
              md: 12
            },
            shadow: isMobile ? null : 2,
            my: 8,
            paddingY: 5
          };
        },
        myAccountConfirmationHeadContainer: {
          bg: "#F8F7F6",
          rounded: 12,
          padding: 7,
          mt: {
            md: 5
          },
          mx: {
            base: "auto",
            md: 67
          },
          mb: {
            base: 4,
            md: 2
          }
        },
        // My Account Ends
        confirmationCardLayout: function confirmationCardLayout() {
          return {
            borderRadius: 12
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref75) {
          var radiusValue = _ref75.radiusValue,
              topRadiusValue = _ref75.topRadiusValue,
              bottomRadiusValue = _ref75.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    Alert: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref76) {
          var radiusValue = _ref76.radiusValue,
              topRadiusValue = _ref76.topRadiusValue,
              bottomRadiusValue = _ref76.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    Menu: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref77) {
          var radiusValue = _ref77.radiusValue,
              topRadiusValue = _ref77.topRadiusValue,
              bottomRadiusValue = _ref77.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    ActionsheetContent: {
      variants: {
        topRounded: {},
        myAccount_editFields_actionSheetContent: {
          padding: 0,
          bg: "white"
        },
        myAccount_orderHistoryDetails_actionSheetContent: {
          padding: 0,
          bg: "white"
        },
        payments_addGiftCard_actionSheetContent: {
          height: "max-content",
          padding: 0
        },
        myAccount_paymentOptions_giftCardDetails_actionSheetContent: {}
      }
    },
    PopoverContent: {
      variants: {
        popoverRadius: function popoverRadius(_ref78) {
          var radiusValue = _ref78.radiusValue;
          return {
            borderRadius: radiusValue
          };
        },

        /** PopoverContent: Private Dining Start */
        pd_request_eventDetails_purposDropdown: {
          top: {
            md: 20
          },
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 8,
          borderColor: "#E4E4E4"
        },
        pd_request_eventDetails_timeDropdown: {
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 12,
          shadow: 10,
          borderColor: "transparent"
        },
        pd_request_eventDetails_partySizeDropdown: {
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 8,
          borderColor: "#E4E4E4"
        },
        pd_request_eventDetails_menuPrefDropdown: {
          top: {
            md: 20
          },
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 8,
          borderColor: "#E4E4E4"
        },
        pd_request_contactDetails_dopTooltip: {
          backgroundColor: "#8f278a",
          borderRadius: 8
        },
        pd_request_contactDetails_phoneType: {
          borderRadius: 8,
          py: 6,
          px: 4,
          bg: "white",
          top: 2,
          shadow: 13,
          border: "none"
        }
        /** PopoverContent: Private Dining End */

      }
    },
    Switch: {
      baseStyle: {
        thumbColor: "#FFFFFF",
        onTrackColor: "primary.100"
      }
    },
    Select: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref79) {
          var radiusValue = _ref79.radiusValue,
              topRadiusValue = _ref79.topRadiusValue,
              bottomRadiusValue = _ref79.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        paymentOptions_addEditCC_addressDetails: {
          w: "100%"
        }
      }
    },
    Spinner: {
      variants: {
        paymentOptions_addGiftCard_checkBalanceSpinner: {
          my: 3.5,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          },
          color: "#BBBBBB",
          size: "sm"
        },
        paymentOptions_addGiftCard_addCardSpinner: {
          my: 3.5,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          },
          color: "#FFFFFF",
          size: "sm"
        }
      }
    },
    Checkbox: {
      variants: {
        eclub_restaurantOptions: {
          alignItems: "flex-start"
        }
      }
    }
  },
  fontConfig: {
    Teko: {
      100: {
        normal: "Teko-Light"
      },
      200: {
        normal: "Teko-Light"
      },
      300: {
        normal: "Teko-Regular"
      },
      400: {
        normal: "Teko-Medium"
      },
      500: {
        normal: "Teko-Semi-Bold"
      },
      600: {
        normal: "Teko-Bold"
      }
    },
    NanumGothic: {
      100: {
        normal: "Nanum-Gothic-Regular"
      },
      200: {
        normal: "Nanum-Gothic-Regular"
      },
      300: {
        normal: "Nanum-Gothic-Regular"
      },
      400: {
        normal: "Nanum-Gothic-Bold"
      },
      500: {
        normal: "Nanum-Gothic-Bold"
      },
      600: {
        normal: "Nanum-Gothic-ExtraBold"
      }
    },
    WickedGrit: {
      100: {
        normal: "WickedGrit"
      },
      200: {
        normal: "WickedGrit"
      },
      300: {
        normal: "WickedGrit"
      },
      400: {
        normal: "WickedGrit"
      },
      500: {
        normal: "WickedGrit"
      },
      600: {
        normal: "WickedGrit"
      }
    },
    Brandon: {
      100: {
        normal: "Brandon"
      },
      200: {
        normal: "Brandon"
      },
      300: {
        normal: "Brandon"
      },
      400: {
        normal: "Brandon"
      },
      500: {
        normal: "Brandon"
      },
      600: {
        normal: "Brandon"
      }
    },
    Now: {
      100: {
        normal: "Now-Regular"
      },
      200: {
        normal: "Now-Regular"
      },
      300: {
        normal: "Now-Medium"
      },
      400: {
        normal: "Now-Medium"
      },
      500: {
        normal: "Now-Bold"
      },
      600: {
        normal: "Now-Bold"
      }
    },
    Karla: {
      100: {
        normal: "Karla-Regular"
      },
      200: {
        normal: "Karla-Bold"
      }
    }
  },
  fonts: {
    heading: "WickedGrit",
    body: "Now",
    headingSecondary: "Brandon",
    youMightLikeText: "Now-Bold",
    NanumGothic: "NanumGothic",
    Teko: "Teko",
    Karla: "Karla"
  },
  config: {
    // Changing initialColorMode to 'dark'
    initialColorMode: "light"
  }
}; // extend the theme

export var theme = extendTheme(_objectSpread(_objectSpread({}, baseTheme), config));